export default {
  'pages.layouts.userLayout.title': 'CINO AsPiCe Development System',
  'pages.layouts.userLayout.subtitle':
    'Professional Automotive Software Process Improvement and Capability Assessment Solutions, helping enterprises enhance software development capabilities and achieve excellence.',
  'pages.layouts.userLayout.copyright':
    'Copyright ©2025 XuChuang Information Technology Consulting (Chengdu) Co., Ltd.',
  'pages.layouts.userLayout.feature.quickStart': 'Quick Start, Easy Compliance',
  'pages.layouts.userLayout.feature.aiAssist': 'AI-Powered Efficiency Boost',
  'pages.layouts.userLayout.feature.teamWork': 'Seamless Team Collaboration',
  'pages.layouts.userLayout.feature.projectControl': 'Project Progress Control',
  'pages.layouts.userLayout.feature.auditDisplay': 'Audit Display, One-Click Solution',
  'pages.layouts.userLayout.feature.traceability': 'Precise Traceability Assurance',
  'pages.layouts.userLayout.feature.dataAssets': 'Data Accumulation, Asset Inheritance',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.403.subTitle': 'Sorry, you do not have access permission.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // 系统概览页面
  'pages.system.overview.userCount': 'Total Users',
  'pages.system.overview.projectCount': 'Total Projects',
  'pages.system.overview.templateCount': 'Total Templates',
  'pages.system.overview.documentCount': 'Total Work Products',
  'pages.system.overview.latestProjects': 'Latest Projects',
  'pages.system.overview.companyInfo': 'Company Information',
  'pages.system.overview.viewAll': 'View All',
  'pages.system.overview.edit': 'Edit',
  'pages.system.overview.projectName': 'Project Name',
  'pages.system.overview.memberCount': 'Members',
  'pages.system.overview.documentCountColumn': 'Documents',
  'pages.system.overview.updateTime': 'Updated',
  'pages.system.overview.companyName': 'Company Name',
  'pages.system.overview.companyShortName': 'Short Name',
  'pages.system.overview.companyLogo': 'Company Logo',
  'pages.system.overview.companyDescription': 'Description',

  // 用户列表页面
  'pages.system.users.userId': 'User ID',
  'pages.system.users.userName': 'Name',
  'pages.system.users.userEmail': 'Email',
  'pages.system.users.userDepartment': 'Department',
  'pages.system.users.userRole': 'Role',
  'pages.system.users.createTime': 'Created',
  'pages.system.users.projects': 'Projects',
  'pages.system.users.status': 'Status',
  'pages.system.users.actions': 'Actions',
  'pages.system.users.searchPlaceholder': 'Search by user ID, name or email',
  'pages.system.users.search': 'Search',
  'pages.system.users.addUser': 'Add User',
  'pages.system.users.delete': 'Delete',
  'pages.system.users.confirmDelete': 'Confirm Delete',
  'pages.system.users.confirmDeleteContent': 'Are you sure you want to delete user {{name}}?',
  'pages.system.users.enableSuccess': 'Enabled successfully',
  'pages.system.users.disableSuccess': 'Disabled successfully',
  'pages.system.users.enableFailed': 'Failed to enable',
  'pages.system.users.disableFailed': 'Failed to disable',
  'pages.system.users.deleteSuccess': 'Deleted successfully',
  'pages.system.users.deleteFailed': 'Failed to delete',
  'pages.system.users.addUserSuccess': 'User added successfully',
  'pages.system.users.addUserFailed': 'Failed to add user',
  'pages.system.users.addUserModal.title': 'Add User',
  'pages.system.users.addUserModal.email': 'Email',
  'pages.system.users.addUserModal.emailRequired': 'Please enter user email',
  'pages.system.users.addUserModal.emailInvalid': 'Please enter a valid email address',
  'pages.system.users.addUserModal.emailPlaceholder': 'Please enter user email',
  'pages.system.users.addUserModal.department': 'Department',
  'pages.system.users.addUserModal.departmentPlaceholder': 'Please enter user department',
  'pages.system.users.roles.admin': 'Administrator',
  'pages.system.users.roles.aspice_specialist': 'ASPICE Specialist',
  'pages.system.users.roles.user': 'User',
  'pages.system.users.grant': 'Grant',
  'pages.system.users.toSpecialist': 'To ASPICE Specialist',
  'pages.system.users.toUser': 'To User',
  'pages.system.users.confirmRoleChange': 'Confirm Role Change',
  'pages.system.users.confirmToSpecialistContent':
    'Are you sure you want to change user {{name}} to ASPICE Specialist?',
  'pages.system.users.confirmToUserContent':
    'Are you sure you want to change user {{name}} to User?',
  'pages.system.users.roleChangeSuccess': 'Role changed successfully',
  'pages.system.users.roleChangeFailed': 'Failed to change role',
  'pages.system.users.resetPassword': 'Reset Password',
  'pages.system.users.resetPasswordModal.title': 'Reset Password',
  'pages.system.users.resetPasswordModal.confirmContent':
    'Are you sure you want to reset the password of user {{name}}? The old password will stop working immediately.',
  'pages.system.users.resetPasswordModal.mode': 'New password source',
  'pages.system.users.resetPasswordModal.auto': 'Auto generate',
  'pages.system.users.resetPasswordModal.manual': 'Specify manually',
  'pages.system.users.resetPasswordModal.password': 'New password',
  'pages.system.users.resetPasswordModal.passwordRequired': 'Please enter the new password',
  'pages.system.users.resetPasswordModal.passwordTooShort':
    'Password must be at least 6 characters',
  'pages.system.users.resetPasswordModal.passwordPlaceholder':
    'Enter new password (at least 6 characters)',
  'pages.system.users.resetPasswordSuccess': 'Password reset successfully',
  'pages.system.users.resetPasswordFailed': 'Failed to reset password',
  'pages.system.users.resetPasswordResult.content':
    'New password below — copy it and share with the user (it will not be shown again):',
  'pages.system.users.resetPasswordResult.emailSent': 'Notification email sent',
  'pages.system.users.resetPasswordResult.emailFailed':
    'Notification email failed to send, please inform the user offline',

  // 项目列表页面
  'pages.aspice.projects.projectId': 'Project ID',
  'pages.aspice.projects.projectName': 'Project Name',
  'pages.aspice.projects.projectManager': 'Project Manager',
  'pages.aspice.projects.memberCount': 'Members',
  'pages.aspice.projects.createTime': 'Created',
  'pages.aspice.projects.documentCount': 'Documents',
  'pages.aspice.projects.actions': 'Actions',
  'pages.aspice.projects.view': 'View',
  'pages.aspice.projects.searchPlaceholder': 'Search by ID or project name',
  'pages.aspice.projects.search': 'Search',
  'pages.aspice.projects.detailModal.title': 'Project Details',
  'pages.aspice.projects.detailModal.projectId': 'Project ID',
  'pages.aspice.projects.detailModal.projectName': 'Project Name',
  'pages.aspice.projects.detailModal.projectDescription': 'Project Description',
  'pages.aspice.projects.detailModal.memberCount': 'Members',
  'pages.aspice.projects.detailModal.documentCount': 'Documents',
  'pages.aspice.projects.detailModal.projectManager': 'Project Manager',
  'pages.aspice.projects.detailModal.managerEmail': 'Manager Email',
  'pages.aspice.projects.detailModal.createTime': 'Created',
  'pages.aspice.projects.detailModal.updateTime': 'Updated',

  // 系统设置页面
  'pages.system.settings.companyInfo': 'Company Information',
  'pages.system.settings.licenseManagement': 'License Management',
  'pages.system.settings.emailSettings': 'Email Settings',
  'pages.system.settings.otherSettings': 'Other Settings',
  'pages.system.settings.edit': 'Edit',
  'pages.system.settings.updateLicense': 'Update License',
  'pages.system.settings.save': 'Save',
  'pages.system.settings.cancel': 'Cancel',
  'pages.system.settings.submit': 'Submit',
  'pages.system.settings.updateSuccess': 'Update successful',
  'pages.system.settings.updateFailed': 'Update failed',

  // 企业信息
  'pages.system.settings.company.name': 'Company Name',
  'pages.system.settings.company.shortName': 'Short Name',
  'pages.system.settings.company.shortNameHelp': 'Will appear in exported document names',
  'pages.system.settings.company.logo': 'Company Logo',
  'pages.system.settings.company.logoHelp':
    'Recommended size: 200x60px, Format: PNG/JPG, Size: <2MB',
  'pages.system.settings.company.description': 'Company Description',
  'pages.system.settings.company.uploadLogo': 'Upload Logo',
  'pages.system.settings.company.currentLogo': 'Current logo',
  'pages.system.settings.company.notSet': 'Not set',

  // 授权管理
  'pages.system.settings.license.version': 'License Version',
  'pages.system.settings.license.customerInfo': 'Customer Information',
  'pages.system.settings.license.validUntil': 'Valid Until',
  'pages.system.settings.license.maxUsers': 'Max Users',
  'pages.system.settings.license.currentUsers': 'Current Users',
  'pages.system.settings.license.daysRemaining': 'Days Remaining',
  'pages.system.settings.license.status': 'License Status',
  'pages.system.settings.license.valid': 'Valid',
  'pages.system.settings.license.invalid': 'Invalid',
  'pages.system.settings.license.days': 'days',
  'pages.system.settings.license.updateTitle': 'Update License',
  'pages.system.settings.license.licenseKey': 'License Key',
  'pages.system.settings.license.licenseKeyPlaceholder':
    'Please enter your license key to update system authorization',
  'pages.system.settings.license.licenseKeyRequired':
    'Please enter your license key to update system authorization',
  'pages.system.settings.license.updateSuccessMessage':
    'License updated successfully, Customer: {{customer}}, Valid until: {{validUntil}}, Max Users: {{maxUsers}}',

  // 邮箱设置
  'pages.system.settings.email.smtpServer': 'SMTP Server',
  'pages.system.settings.email.port': 'Port',
  'pages.system.settings.email.username': 'Email Account',
  'pages.system.settings.email.password': 'Password',

  // AI设置
  'pages.system.settings.ai.enabled': 'Enable AI Features',
  'pages.system.settings.ai.endpoint': 'API Endpoint',
  'pages.system.settings.ai.apiKey': 'API Key',
  'pages.system.settings.ai.parameters': 'Request Parameters',
  'pages.system.settings.ai.endpointPlaceholder': 'e.g.: https://api.deepseek.com/v1',
  'pages.system.settings.ai.endpointRequired': 'Please enter API Endpoint',
  'pages.system.settings.ai.apiKeyPlaceholder': 'Please enter API Key',
  'pages.system.settings.ai.apiKeyRequired': 'Please enter API Key',
  'pages.system.settings.ai.parametersPlaceholder': '{"temperature": 0.7, "max_tokens": 2048}',
  'pages.system.settings.ai.parametersHelp':
    'JSON format, e.g.: {"temperature": 0.7, "max_tokens": 2048}',
  'pages.system.settings.ai.yes': 'Yes',
  'pages.system.settings.ai.no': 'No',
  'pages.system.settings.ai.allowPMSelectAllUsers': 'Allow Project Managers to Select All Users',
  'pages.system.settings.ai.allowPMSelectAllUsersHelp':
    'When enabled, project managers can select from all platform users when adding members; when disabled, they can only select existing project members',
  'pages.system.settings.ai.onlyAspiceSpecialistCreateProject':
    'Only Allow Aspice Specialists to Create Projects',
  'pages.system.settings.ai.onlyAspiceSpecialistCreateProjectHelp':
    'When enabled, only Aspice specialists can create new projects',
  'pages.system.settings.ai.enableKeepOriginalFile': 'Enable Keep Original File',
  'pages.system.settings.ai.enableKeepOriginalFileHelp':
    'When enabled, users can choose to keep the original file format when uploading local files',

  // 账号信息页面
  'pages.account.settings.title': 'Account Information',
  'pages.account.settings.updateProfile': 'Update Profile',
  'pages.account.settings.changePassword': 'Change Password',
  'pages.account.settings.name': 'Name',
  'pages.account.settings.email': 'Email',
  'pages.account.settings.phone': 'Phone',
  'pages.account.settings.department': 'Department',
  'pages.account.settings.position': 'Position',
  'pages.account.settings.signature': 'Signature',
  'pages.account.settings.noSignature': 'No signature',
  'pages.account.settings.currentPassword': 'Current Password',
  'pages.account.settings.newPassword': 'New Password',
  'pages.account.settings.confirmPassword': 'Confirm New Password',
  'pages.account.settings.passwordMismatch': 'The two passwords do not match',

  // 项目概览页面
  'pages.projectOverview.notJoinedProject':
    'You have not joined any project. You can contact the project manager to invite you to join a project.',
  'pages.projectOverview.notJoinedProjectMananger':
    'If you are a project manager, you can create a new project.',
  'pages.projectOverview.createNewProject': 'Create New Project',
  'pages.projectOverview.createNewProjectModal': 'Create New Project',
  'pages.projectOverview.projectName': 'Project Name',
  'pages.projectOverview.projectNamePlaceholder': 'Please enter project name',
  'pages.projectOverview.projectDescription': 'Project Description',
  'pages.projectOverview.projectDescriptionPlaceholder': 'Please enter project description',
  'pages.projectOverview.aspiceVModel': 'ASPICE V Model',
  'pages.projectOverview.notSelected': 'Not Selected',
  'pages.projectOverview.owner': 'Owner',
  'pages.projectOverview.notAssigned': 'Not Assigned',
  'pages.projectOverview.workProducts': 'Work Products',
  'pages.projectOverview.processConfiguration': 'Process Configuration',
  'pages.projectOverview.createSuccess': 'Project created successfully!',
  'pages.projectOverview.createFailed': 'Failed to create, please try again!',
  'pages.projectOverview.switchSuccess': 'Switched to project: ',
  'pages.projectOverview.switchFailed': 'Failed to switch project, please switch manually!',
  'pages.projectOverview.userInfoFailed': 'Failed to get user information, please login again!',

  // Project overview statistics
  'pages.projectOverview.stats.totalProcesses': 'Total Processes',
  'pages.projectOverview.stats.totalProcessesDesc': 'Number of all processes in the project',
  'pages.projectOverview.stats.totalWorkProducts': 'Total Work Products',
  'pages.projectOverview.stats.totalWorkProductsDesc': 'Number of all work products in the project',
  'pages.projectOverview.stats.publishedWorkProducts': 'Published Work Products',
  'pages.projectOverview.stats.publishedWorkProductsDesc': 'Number of published work products',
  'pages.projectOverview.stats.memberCount': 'Number of Members',
  'pages.projectOverview.stats.memberCountDesc': 'Number of members participating in the project',

  // File Info Table (Work Product Preview)
  'pages.fileInfoTable.fileName': 'File Name',
  'pages.fileInfoTable.version': 'Version',
  'pages.fileInfoTable.updateTime': 'Update Time',
  'pages.fileInfoTable.actions': 'Actions',
  'pages.fileInfoTable.downloadFile': 'Download File',
  'pages.fileInfoTable.updateFile': 'Update File',
  'pages.fileInfoTable.fileIdNotExist': 'File ID does not exist',
  'pages.fileInfoTable.downloadStarted': 'File download started',
  'pages.fileInfoTable.downloadFailed': 'File download failed, please try again',
  'pages.fileInfoTable.onlyExcelFiles': 'Only Excel files (.xlsx, .xls) can be uploaded',
  'pages.fileInfoTable.fileSizeLimit': 'File must be smaller than 100MB',
  'pages.fileInfoTable.uploadFailed': 'File upload failed',
  'pages.fileInfoTable.tip':
    'Tip: You can download the file to local for modification, then upload the updated file through the "Update File" button.',

  // Document Editor Header
  'pages.docEditor.header.draft': 'Draft',
  'pages.docEditor.header.draftLocked': 'Draft Locked',
  'pages.docEditor.header.review': 'In Review',
  'pages.docEditor.header.reviewPassed': 'Review Passed',
  'pages.docEditor.header.auditPassed': 'Audit Passed',
  'pages.docEditor.header.approved': 'Approved',
  'pages.docEditor.header.controlled': 'Controlled',
  'pages.docEditor.header.published': 'Published',
  'pages.docEditor.header.obsolete': 'Obsolete',
  'pages.docEditor.header.save': 'Save',
  'pages.docEditor.header.submitReview': 'Submit Review',
  'pages.docEditor.header.submitChange': 'Submit Change',
  'pages.docEditor.header.reviewDocument': 'Review Document',
  'pages.docEditor.header.updateReview': 'Update Reviewers',
  'pages.docEditor.header.export': 'Export Document',
  'pages.docEditor.header.edit': 'Edit',
  'pages.docEditor.header.close': 'Close',
  'pages.docEditor.header.problem': 'Problem',
  'pages.docEditor.header.compare': 'Compare',
  'pages.docEditor.compare.title': 'Compare Documents',
  'pages.docEditor.compare.baseDocument': 'Compare With',
  'pages.docEditor.compare.currentDocument': 'Current Document',
  'pages.docEditor.compare.selectPlaceholder': 'Select document',
  'pages.docEditor.compare.searchEmpty': 'No matching document',
  'pages.docEditor.compare.deleted': 'Deleted',
  'pages.docEditor.compare.added': 'Added',
  'pages.docEditor.compare.emptyContent': 'No content',
  'pages.docEditor.compare.selectToCompare': 'Select a document on the left to compare',
  'pages.docEditor.compare.loadFailed': 'Failed to load the document',
  'pages.docEditor.compare.loadListFailed': 'Failed to load documents',
  'pages.docEditor.compare.unsupported': 'This format cannot be compared',
  'pages.docEditor.compare.sheetMissing': 'This document has no such sheet',
  'pages.docEditor.compare.formatDiffer':
    'The selected document uses a different format, so the comparison is shown as text',

  // Excel Table Component
  'pages.excelTable.groupDisplay': 'Group Display',
  'pages.excelTable.rowIndex': '#',
  'pages.excelTable.configTrace': 'Configure Traceability',
  'pages.excelTable.addColumn': 'Add Column',
  'pages.excelTable.deleteColumn': 'Delete Column',
  'pages.excelTable.addRow': 'Add Row',
  'pages.excelTable.copyRow': 'Copy Row',
  'pages.excelTable.insertRow': 'Insert Empty Row',
  'pages.excelTable.deleteSelectedRows': 'Delete Selected Rows',
  'pages.excelTable.mergeCells': 'Merge Cells',
  'pages.excelTable.unmergeCells': 'Unmerge Cells',
  'pages.excelTable.mergeCellsTip': 'Drag, or Shift-click, to select cells and merge them',
  'pages.excelTable.unmergeCellsTip':
    'Select a merged cell to unmerge. Text stays in the first cell',
  'pages.excelTable.mergeNeedSelection': 'Select at least two cells first',
  'pages.excelTable.unmergeNeedSelection': 'Select a merged cell first',
  'pages.excelTable.unmergeHeaderTip':
    'Select a merged header to unmerge. Each column header is restored',
  'pages.excelTable.mergeHeaderAndBodyDisabled': 'Header and body cells cannot be merged together',
  'pages.excelTable.mergeGroupedDisabled': 'Turn off group display first',
  'pages.excelTable.mergeChoiceDescription':
    'The selected area contains different content. Choose how you want to merge it.',
  'pages.excelTable.mergeKeepFirst': 'Keep the content of the first cell',
  'pages.excelTable.mergeKeepAll': 'Keep the content of all cells intact',
  'pages.excelTable.mergeChoiceConfirm': 'OK',
  'pages.excelTable.fontFamily': 'Font',
  'pages.excelTable.fontSize': 'Size',
  'pages.excelTable.fontColor': 'Font Color',
  'pages.excelTable.cellColor': 'Cell Color',
  'pages.excelTable.presetColors': 'Standard Colors',
  'pages.excelTable.clearFormat': 'Clear Format',
  'pages.excelTable.formatNeedSelection': 'Select cells before changing the format',
  'pages.excelTable.deleteHeaderGroup': 'Delete Group',
  'pages.excelTable.deleteHeaderGroupConfirm':
    'Delete the header group "{{title}}"? This cannot be undone.',
  'pages.excelTable.cancel': 'Cancel',
  'pages.excelTable.noData': 'No Data',
  'pages.excelTable.configTraceTitle': 'Configure Traceability Relationship',
  'pages.excelTable.loading': 'Loading...',
  'pages.excelTable.noTraceDocuments': 'No available trace documents',
  'pages.excelTable.configTraceDescription':
    'Please select the corresponding column for each trace document to save the traceability relationship:',
  'pages.excelTable.selectColumn': 'Select Column',
  'pages.excelTable.aiGenerateSuccess': 'AI generated {{count}} rows of new data have been added',
  'pages.excelTable.aiParseError': 'AI Generated Content Parsing Failed',
  'pages.excelTable.aiParseErrorContent':
    'The AI-generated content format is incorrect and cannot be parsed as table data. Please regenerate or modify the prompt.',
  'pages.excelTable.aiGenerate': '✨ AI Generate',

  // Loading messages
  'pages.loading.loadingResources': 'Loading Resources',
  'pages.loading.initialLoadMessage':
    'Initial resource loading may take some time, please wait patiently',
  'pages.loading.uploadingFile': 'Uploading file...',
  'pages.loading.gettingSourceContent': 'Getting source document content, please wait...',
  'pages.loading.loadingTemplateContent': 'Loading template content...',
  'pages.loading.parsingDocument': 'Parsing document...',
  'pages.loading.loading': 'Loading...',
  'pages.loading.loadingReviewInfo': 'Loading review information...',
  'pages.loading.contentGenerating': 'Please wait, content is being generated...',

  // 评审任务页面
  'pages.reviewTasks.documentId': 'Document ID',
  'pages.reviewTasks.documentName': 'Document Name',
  'pages.reviewTasks.version': 'Version',
  'pages.reviewTasks.project': 'Project',
  'pages.reviewTasks.process': 'Process',
  'pages.reviewTasks.owner': 'Owner',
  'pages.reviewTasks.submitTime': 'Submit Time',
  'pages.reviewTasks.yourRole': 'Your Role',
  'pages.reviewTasks.status': 'Status',
  'pages.reviewTasks.actions': 'Actions',
  'pages.reviewTasks.searchPlaceholder': 'Search by document ID or name',
  'pages.reviewTasks.search': 'Search',
  'pages.reviewTasks.role.author': 'Author',
  'pages.reviewTasks.role.reviewer': 'Review Group',
  'pages.reviewTasks.role.auditor': 'Auditor',
  'pages.reviewTasks.role.approver': 'Approver',
  'pages.reviewTasks.status.notstarted': 'Not Started',
  'pages.reviewTasks.status.approved': 'Approved',
  'pages.reviewTasks.status.rejected': 'Rejected',
  'pages.reviewTasks.status.unknown': 'Unknown',
  'pages.reviewTasks.action.approve': 'Approve',
  'pages.reviewTasks.action.reject': 'Reject',
  'pages.reviewTasks.action.updateReview': 'Update Review',
  'pages.reviewTasks.action.viewDocument': 'View Document',
  'pages.reviewTasks.action.viewReviewRecords': 'Review Records',
  'pages.reviewTasks.reviewModal.approveTitle': 'Approve Review',
  'pages.reviewTasks.reviewModal.rejectTitle': 'Reject Review',
  'pages.reviewTasks.reviewModal.reviewResult': 'Review Result',
  'pages.reviewTasks.reviewModal.reviewComment': 'Review Comment',
  'pages.reviewTasks.reviewModal.reviewResultRequired': 'Please select review result',
  'pages.reviewTasks.reviewModal.reviewCommentRequired': 'Please enter review comment',
  'pages.reviewTasks.reviewModal.reviewCommentPlaceholder': 'Please enter review comment...',
  'pages.reviewTasks.submitSuccess': 'Review submitted successfully',
  'pages.reviewTasks.submitFailed': 'Failed to submit review',
  'pages.reviewTasks.operationFailed': 'Operation failed, please try again',
  'pages.reviewTasks.getRecordsFailed': 'Failed to get review records',
  'pages.reviewTasks.reviewRecordsModal.title': 'Review Records',
  'pages.reviewTasks.reviewRecordsModal.close': 'Close',
  'pages.reviewTasks.reviewRecordsModal.loading': 'Loading...',
  'pages.reviewTasks.reviewRecordsModal.documentTitle': 'Document Title',
  'pages.reviewTasks.reviewRecordsModal.documentCode': 'Document ID',
  'pages.reviewTasks.reviewRecordsModal.reviewersTitle': 'Review Group',
  'pages.reviewTasks.reviewRecordsModal.auditorTitle': 'Auditor',
  'pages.reviewTasks.reviewRecordsModal.approverTitle': 'Approver',
  'pages.reviewTasks.reviewRecordsModal.reviewer': 'Reviewer',
  'pages.reviewTasks.reviewRecordsModal.auditor': 'Auditor',
  'pages.reviewTasks.reviewRecordsModal.approver': 'Approver',
  'pages.reviewTasks.reviewRecordsModal.status': 'Status',
  'pages.reviewTasks.reviewRecordsModal.comment': 'Comment',
  'pages.reviewTasks.reviewRecordsModal.reviewTime': 'Review Time',

  // ASPICE概览页面
  'pages.aspice.overview.projectCount': 'Total Projects',
  'pages.aspice.overview.templateCount': 'Total Templates',
  'pages.aspice.overview.documentCount': 'Total Process Documents',
  'pages.aspice.overview.roleCount': 'Total Roles',
  'pages.aspice.overview.recentProjects': 'Recent Projects',
  'pages.aspice.overview.recentTemplates': 'Recent Templates',
  'pages.aspice.overview.recentDocuments': 'Recent Process Documents',
  'pages.aspice.overview.viewAll': 'View All',
  'pages.aspice.overview.projectManager': 'Project Manager',
  'pages.aspice.overview.approved': 'Approved',
  'pages.aspice.overview.reviewing': 'In Review',

  // ASPICE模板页面
  'pages.aspice.templates.process': 'Process',
  'pages.aspice.templates.templateName': 'Template Name',
  'pages.aspice.templates.version': 'Version',
  'pages.aspice.templates.tags': 'Tags',
  'pages.aspice.templates.workProductType': 'Work Product Type',
  'pages.aspice.templates.fileFormat': 'File Format',
  'pages.aspice.templates.updateTime': 'Update Time',
  'pages.aspice.templates.actions': 'Actions',
  'pages.aspice.templates.view': 'View',
  'pages.aspice.templates.update': 'Update',
  'pages.aspice.templates.download': 'Download',
  'pages.aspice.templates.delete': 'Delete',
  'pages.aspice.templates.create': 'New Template',
  'pages.aspice.templates.createTemplate': 'Create Template',
  'pages.aspice.templates.updateTemplate': 'Update Template',
  'pages.aspice.templates.sourceDoc': 'Source Document',
  'pages.aspice.templates.sourceDocPlaceholder': 'Please enter document ID or full link',
  'pages.aspice.templates.versionRequired': 'Please enter version number',
  'pages.aspice.templates.description': 'Description',
  'pages.aspice.templates.tagsLabel': 'Tags',
  'pages.aspice.templates.saveSuccess': 'Saved successfully',
  'pages.aspice.templates.createSuccess': 'Created successfully',
  'pages.aspice.templates.updateSuccess': 'Updated successfully',
  'pages.aspice.templates.saveFailed': 'Failed to save',
  'pages.aspice.templates.createFailed': 'Failed to create',
  'pages.aspice.templates.updateFailed': 'Failed to update',
  'pages.aspice.templates.operationFailed': 'Operation failed',
  'pages.aspice.templates.confirmDelete': 'Confirm Delete',
  'pages.aspice.templates.confirmDeleteContent': 'Are you sure to delete template {{name}}?',
  'pages.aspice.templates.deleteSuccess': 'Deleted successfully',
  'pages.aspice.templates.deleteFailed': 'Delete failed',

  // 新增条目 - 模板页面
  'pages.aspice.templates.allTemplates': 'All Templates',
  'pages.aspice.templates.sourceDocRequired': 'Please enter source document link',
  'pages.aspice.templates.sourceDocHelp':
    'Enter the work product link or document ID, the system will fetch the content automatically.',
  'pages.aspice.templates.templateNameRequired': 'Please enter template name',
  'pages.aspice.templates.templateNamePlaceholder': 'Please enter template name',
  'pages.aspice.templates.versionPlaceholder': 'Please enter version number, e.g. 0.0',
  'pages.aspice.templates.tagsHelp':
    'Select existing tags or input new ones, press Enter to confirm',
  'pages.aspice.templates.tagsPlaceholder': 'Please select or input tags',
  'pages.aspice.templates.descriptionPlaceholder': 'Please enter template description (optional)',
  'pages.aspice.templates.versionPattern': 'Version number can only contain numbers and dots',

  // ASPICE角色页面
  'pages.aspice.roles.roleId': 'Role ID',
  'pages.aspice.roles.roleName': 'Role Name',
  'pages.aspice.roles.roleDescription': 'Role Description',
  'pages.aspice.roles.actions': 'Actions',
  'pages.aspice.roles.edit': 'Edit',
  'pages.aspice.roles.delete': 'Delete',
  'pages.aspice.roles.createRole': 'New Role',
  'pages.aspice.roles.editRole': 'Edit Role',
  'pages.aspice.roles.confirmDelete': 'Confirm Delete',
  'pages.aspice.roles.confirmDeleteContent': 'Are you sure you want to delete role {{name}}?',
  'pages.aspice.roles.saveSuccess': 'Saved successfully',
  'pages.aspice.roles.createSuccess': 'Created successfully',
  'pages.aspice.roles.deleteSuccess': 'Deleted successfully',
  'pages.aspice.roles.operationFailed': 'Operation failed',
  'pages.aspice.roles.deleteFailed': 'Failed to delete',

  // ASPICE程序文件页面
  'pages.aspice.processDocs.fileName': 'File Name',
  'pages.aspice.processDocs.processName': 'Process Name',
  'pages.aspice.processDocs.version': 'Version',
  'pages.aspice.processDocs.status': 'Status',
  'pages.aspice.processDocs.updateTime': 'Update Time',
  'pages.aspice.processDocs.actions': 'Actions',
  'pages.aspice.processDocs.view': 'View',
  'pages.aspice.processDocs.download': 'Download',
  'pages.aspice.processDocs.edit': 'Edit',
  'pages.aspice.processDocs.searchPlaceholder': 'Search by file name',
  'pages.aspice.processDocs.search': 'Search',
  'pages.aspice.processDocs.createDoc': 'New Process Document',
  'pages.aspice.processDocs.createDocModal': 'New Process Document',
  'pages.aspice.processDocs.process': 'Process',
  'pages.aspice.processDocs.selectProcess': 'Please select process',
  'pages.aspice.processDocs.fileNameRequired': 'Please enter file name',
  'pages.aspice.processDocs.versionRequired': 'Please enter version number',
  'pages.aspice.processDocs.versionPattern': 'Version number can only contain numbers and dots',
  'pages.aspice.processDocs.versionPlaceholder': 'Please enter numeric version number, e.g.: 0.0',
  'pages.aspice.processDocs.uploadFile': 'Upload File',
  'pages.aspice.processDocs.uploadFileRequired': 'Please upload file',
  'pages.aspice.processDocs.uploadFileExtra': 'Supports .xlsx, .xls, .docx file formats',
  'pages.aspice.processDocs.selectFile': 'Select File',
  'pages.aspice.processDocs.fileTypeError': 'Only .xlsx, .xls, .docx file formats are supported',
  'pages.aspice.processDocs.excelParseSuccess': 'Excel file parsed successfully',
  'pages.aspice.processDocs.wordParseSuccess': 'Word file parsed successfully',
  'pages.aspice.processDocs.projectNotFound': 'Process document project not found',
  'pages.aspice.processDocs.uploadFileFirst': 'Please upload file first',
  'pages.aspice.processDocs.addSuccess': 'Added successfully',
  'pages.aspice.processDocs.addFailed': 'Failed to add',
  'pages.aspice.processDocs.getContentFailed': 'Failed to get document content',
  'pages.aspice.processDocs.exportNotSupported': 'Export format {{format}} not supported',
  'pages.aspice.processDocs.exportFailed': 'Export failed',
  'pages.aspice.processDocs.status.draft': 'Draft',
  'pages.aspice.processDocs.status.draftLocked': 'Draft Locked',
  'pages.aspice.processDocs.status.review': 'In Review',
  'pages.aspice.processDocs.status.reviewPassed': 'Review Passed',
  'pages.aspice.processDocs.status.auditPassed': 'Audit Passed',
  'pages.aspice.processDocs.status.approved': 'Approved',
  'pages.aspice.processDocs.status.controlled': 'Controlled',
  'pages.aspice.processDocs.status.published': 'Published',
  'pages.aspice.processDocs.status.obsolete': 'Obsolete',

  // NoProcess component
  'pages.aspice.processDocs.noProcess.pmMessage':
    'No process configured for the current project. Please configure the process first.',
  'pages.aspice.processDocs.noProcess.userMessage':
    'No process configured for the current project. Please contact the project manager to configure the process.',
  'pages.aspice.processDocs.noProcess.configureProcess': 'Configure Process',

  // Bottom menu links
  'pages.layout.processDocsPreview': 'Process Documents Preview',
  'pages.layout.systemManual': 'System Manual',
  'pages.layout.aspiceSpecialistInterface': 'Back to Main Control Page',
  'pages.layout.productLibrary': 'Product Library',
  'pages.layout.reviewTasks': 'Review Tasks',

  // Product Library page
  'pages.productLibrary.title': 'Product Library',
  'pages.productLibrary.projectName': 'Project Name',
  'pages.productLibrary.documentCount': 'Work Product Count',
  'pages.productLibrary.actions': 'Actions',
  'pages.productLibrary.viewDetails': 'View Details',
  'pages.productLibrary.download': 'Download',
  'pages.productLibrary.noDocuments': 'No documents in project product library',
  'pages.productLibrary.preparingExport': 'Preparing export...',
  'pages.productLibrary.foundDocuments': 'Found {{count}} documents, starting export...',
  'pages.productLibrary.exporting':
    'Exporting ({{current}}/{{total}}) {{processCode}} - {{title}}...',
  'pages.productLibrary.untitledDocument': 'Untitled Document',
  'pages.productLibrary.generatingZip': 'Generating ZIP file...',
  'pages.productLibrary.exportSuccess':
    '{{projectName}} product library exported successfully, {{count}} documents in total',
  'pages.productLibrary.exportFailed': 'Export failed, please try again later',
  'pages.productLibrary.fetchFailed': 'Failed to fetch product library list',
  'pages.productLibrary.detailModalTitle': '{{projectName}} Product Library List',
  'pages.productLibrary.processName': 'Process Name',
  'pages.productLibrary.documentName': 'Document Name',
  'pages.productLibrary.documentVersion': 'Document Version',
  'pages.productLibrary.category': 'Category',
  'pages.productLibrary.owners': 'Owners',
  'pages.productLibrary.addedTime': 'Added to Product Library',

  // Project Info page
  'pages.project.info.title': 'Project Information',
  'pages.project.info.edit': 'Edit',
  'pages.project.info.deleteProject': 'Delete Project',
  'pages.project.info.projectName': 'Project Name',
  'pages.project.info.projectCode': 'Project Code',
  'pages.project.info.projectDescription': 'Project Description',
  'pages.project.info.projectManager': 'Project Manager',
  'pages.project.info.createTime': 'Create Time',
  'pages.project.info.updateTime': 'Update Time',
  'pages.project.info.projectStats': 'Project Statistics',
  'pages.project.info.memberCount': 'Project Members',
  'pages.project.info.processCount': 'Process Count',
  'pages.project.info.documentCount': 'Work Product Count',
  'pages.project.info.memberUnit': 'members',
  'pages.project.info.processUnit': 'processes',
  'pages.project.info.documentUnit': 'documents',
  'pages.project.info.editModal.title': 'Edit Project Information',
  'pages.project.info.editModal.nameRequired': 'Project name is required',
  'pages.project.info.editModal.descriptionRequired': 'Project description is required',
  'pages.project.info.confirmDelete': 'Confirm Delete',
  'pages.project.info.confirmDeleteContent':
    'Are you sure you want to delete the current project? This operation cannot be undone!',
  'pages.project.info.updateSuccess': 'Update successful',
  'pages.project.info.updateFailed': 'Update failed',
  'pages.project.info.deleteSuccess': 'Project deleted successfully',
  'pages.project.info.deleteFailed': 'Project deletion failed',
  'pages.project.info.projectIdNotFound': 'Project ID not found',
  'pages.project.info.fetchFailed': 'Failed to fetch project information',

  // Process Configuration page
  'pages.project.processes.title': 'Process Configuration',
  'pages.project.processes.processId': 'Process ID',
  'pages.project.processes.processName': 'Process Name',
  'pages.project.processes.progress': 'Progress',
  'pages.project.processes.owners': 'Owner',
  'pages.project.processes.members': 'Members',
  'pages.project.processes.status': 'Status',
  'pages.project.processes.actions': 'Actions',
  'pages.project.processes.notSet': 'Not Set',
  'pages.project.processes.enabled': 'Enabled',
  'pages.project.processes.disabled': 'Disabled',
  'pages.project.processes.updateOwners': 'Update Process Members',
  'pages.project.processes.updateOwner': 'Update Process Owner',
  'pages.project.processes.processOwners': 'Process Owner',
  'pages.project.processes.processMembers': 'Process Members',
  'pages.project.processes.selectOwners': 'Please select process members',
  'pages.project.processes.selectOwner': 'Please select a process owner',
  'pages.project.processes.enableSuccess': 'Successfully enabled process {{name}}',
  'pages.project.processes.disableSuccess': 'Successfully disabled process {{name}}',
  'pages.project.processes.enableFailed': 'Failed to enable process',
  'pages.project.processes.disableFailed': 'Failed to disable process',
  'pages.project.processes.updateOwnersSuccess': 'Successfully updated process members',
  'pages.project.processes.updateOwnersFailed': 'Failed to update process members',
  'pages.project.processes.updateOwnerSuccess': 'Successfully updated process owner',
  'pages.project.processes.updateOwnerFailed': 'Failed to update process owner',
  'pages.project.processes.fetchProcessesFailed': 'Failed to fetch process list',
  'pages.project.processes.fetchMembersFailed': 'Failed to fetch project members',

  // Team Management page
  'pages.project.team.title': 'Team Management',
  'pages.project.team.addMember': 'Add Member',
  'pages.project.team.joinedMembers': 'Joined Members',
  'pages.project.team.invitedMembers': 'Invited Members',
  'pages.project.team.roleList': 'Role List',
  'pages.project.team.memberName': 'Name',
  'pages.project.team.memberEmail': 'Email',
  'pages.project.team.memberRoles': 'Roles',
  'pages.project.team.memberProcesses': 'Related Processes',
  'pages.project.team.actions': 'Actions',
  'pages.project.team.update': 'Update',
  'pages.project.team.inviteTime': 'Invite Time',
  'pages.project.team.invitedBy': 'Invited By',
  'pages.project.team.roleId': 'Role ID',
  'pages.project.team.roleName': 'Role Name',
  'pages.project.team.roleDescription': 'Role Description',
  'pages.project.team.addMemberModal.title': 'Add Member',
  'pages.project.team.addMemberModal.email': 'Member Email',
  'pages.project.team.addMemberModal.emailPlaceholder': 'Please enter member email',
  'pages.project.team.addMemberModal.emailRequired': 'Please enter email',
  'pages.project.team.addMemberModal.emailInvalid': 'Please enter a valid email address',
  'pages.project.team.addMemberModal.selectUser': 'Select User',
  'pages.project.team.addMemberModal.selectUserPlaceholder': 'Please select a user',
  'pages.project.team.addMemberModal.userRequired': 'Please select a user',
  'pages.project.team.addMemberModal.roles': 'Roles',
  'pages.project.team.addMemberModal.selectRoles': 'Please select roles',
  'pages.project.team.addMemberModal.rolesRequired': 'Please select roles',
  'pages.project.team.addMemberModal.processes': 'Responsible Processes',
  'pages.project.team.addMemberModal.selectProcesses': 'Please select responsible processes',
  'pages.project.team.updateMemberModal.title': 'Update Member Information',
  'pages.project.team.deleteMember': 'Delete Member',
  'pages.project.team.confirmDelete': 'Confirm Delete',
  'pages.project.team.confirmDeleteContent': 'Are you sure you want to delete member {{name}}?',
  'pages.project.team.addSuccess': 'Added successfully',
  'pages.project.team.addFailed': 'Failed to add member',
  'pages.project.team.updateSuccess': 'Configuration successful',
  'pages.project.team.updateFailed': 'Configuration failed',
  'pages.project.team.deleteSuccess': 'Deleted successfully',
  'pages.project.team.deleteFailed': 'Failed to delete',
  'pages.project.team.fetchDataFailed': 'Failed to fetch data',

  // Work Products page
  'pages.workProducts.searchPlaceholder': 'Enter document ID or name to search',
  'pages.workProducts.search': 'Search',
  'pages.workProducts.searchSuccess': 'Search successful',
  'pages.workProducts.aiGenerate': 'AI Generate',
  'pages.workProducts.addPlanning': 'Create Planning',
  'pages.workProducts.addWorkProduct': 'Create Work Product',
  'pages.workProducts.addWorkProductOther': 'Create',
  'pages.workProducts.addSecurityAnalysis': 'Create Security Analysis Tool',
  'pages.workProducts.baselineList': 'Baseline List',
  'pages.workProducts.traceabilityList': 'Traceability Matrix',
  'pages.workProducts.documentId': 'Document ID',
  'pages.workProducts.documentName': 'Document Name',
  'pages.workProducts.version': 'Version',
  'pages.workProducts.owner': 'Owner',
  'pages.workProducts.status': 'Status',
  'pages.workProducts.baseline': 'Baseline',
  'pages.workProducts.updateTime': 'Update Time',
  'pages.workProducts.actions': 'Actions',
  'pages.workProducts.preview': 'Preview',
  'pages.workProducts.edit': 'Edit',
  'pages.workProducts.renameDocument': 'Rename Document',
  'pages.workProducts.renameHint': 'Double-click to rename',
  'pages.workProducts.renameNotAllowed': 'Only draft documents you can edit can be renamed',
  'pages.workProducts.updateTitleSuccess': 'Update document title success',
  'pages.workProducts.updateTitleFailed': 'Update document title failed',
  'pages.workProducts.documentNameRequired': 'Please enter document name',
  'pages.workProducts.enterDocumentName': 'Please enter document name',
  'pages.workProducts.delete': 'Delete',
  'pages.workProducts.export': 'Export',
  'pages.workProducts.exportWithCount': 'Export ({{count}})',
  'pages.workProducts.selectDocumentsToExport': 'Please select documents to export',
  'pages.workProducts.confirmExport': 'Confirm Export',
  'pages.workProducts.confirmExportContent': '{{count}} document(s) selected, continue to export?',
  'pages.workProducts.documentsNotFound': 'Selected documents not found',
  'pages.workProducts.preparingExport': 'Preparing to export documents...',
  'pages.workProducts.exportingDocument': 'Exporting {{processCode}} - {{title}}...',
  'pages.workProducts.generatingZip': 'Generating ZIP file...',
  'pages.workProducts.exportSuccess': 'Documents exported successfully',
  'pages.workProducts.exportFailed': 'Failed to export documents',
  'pages.workProducts.untitledDocument': 'Untitled Document',
  'pages.workProducts.updateReview': 'Update Review',
  'pages.workProducts.confirmDelete': 'Confirm Delete',
  'pages.workProducts.confirmDeleteContent':
    'Are you sure you want to delete document {{title}}? You can restore it from the Recycle Bin.',
  'pages.workProducts.deleteSuccess': 'Delete successful',
  'pages.workProducts.deleteFailed': 'Delete failed',
  'pages.workProducts.projectNotFound': 'Current project not found',
  'pages.workProducts.getProjectFailed': 'Failed to get current project',
  'pages.workProducts.getProcessesFailed': 'Failed to get process list',
  'pages.workProducts.getBaselinesFailed': 'Failed to get baseline list',
  'pages.workProducts.getMembersFailed': 'Failed to get project members',
  'pages.workProducts.updateReviewSuccess': 'Review personnel updated successfully',
  'pages.workProducts.updateReviewFailed': 'Failed to update review',
  'pages.workProducts.documentCategories.planning': 'Planning',
  'pages.workProducts.documentCategories.workProduct': 'Work Product',
  'pages.workProducts.documentCategories.qualityAssurance': 'Quality Assurance',
  'pages.workProducts.documentCategories.other': 'Other',
  'pages.workProducts.documentCategories.processDocument': 'Process Document',
  'pages.workProducts.documentCategories.securityAnalysis': 'Security Analysis Tool',
  'pages.workProducts.documentCategories.simpleChange': 'Simple Change',
  'pages.simpleChange.upload': 'Upload Change Request',
  'pages.simpleChange.uploadSuccess': 'Document uploaded',
  'pages.simpleChange.getListFailed': 'Failed to load simple change documents',
  'pages.simpleChange.fileTypeError': 'Only .xlsx, .xls and .docx files are supported',
  'pages.simpleChange.parsing': 'Parsing file, please wait',
  'pages.simpleChange.documentChange': 'Document Change',
  'pages.simpleChange.change': 'Change',
  'pages.simpleChange.changeSuccess': 'Draft documents created',
  'pages.simpleChange.controlledDocuments': 'Controlled Documents',
  'pages.simpleChange.getControlledFailed': 'Failed to load controlled documents',
  'pages.simpleChange.contentLoadFailed': 'Failed to load document content',
  'pages.simpleChange.unsupportedPreview': 'This document format cannot be previewed',
  'pages.workProducts.status.draft': 'Draft',
  'pages.workProducts.status.draftLocked': 'Draft Locked',
  'pages.workProducts.status.review': 'In Review',
  'pages.workProducts.status.reviewPassed': 'Review Passed',
  'pages.workProducts.status.auditPassed': 'Audit Passed',
  'pages.workProducts.status.approved': 'Pending Release',
  'pages.workProducts.status.controlled': 'Controlled',
  'pages.workProducts.status.published': 'Published',
  'pages.workProducts.status.obsolete': 'Obsolete',

  // Change Management Component
  'pages.workProducts.changeManagement.changeRequests': 'Change Requests',
  'pages.workProducts.changeManagement.changeRequestSummary': 'Change Request Summary',
  'pages.workProducts.changeManagement.getProjectFailed': 'Failed to get current project',

  // Configuration Management Component
  'pages.workProducts.configManagement.management': 'Management Library',
  'pages.workProducts.configManagement.controlled': 'Controlled Library',
  'pages.workProducts.configManagement.baseline': 'Baseline Library',
  'pages.workProducts.configManagement.getProjectFailed': 'Failed to get current project',
  'pages.workProducts.configManagement.getBaselinesFailed': 'Failed to get baseline list',

  // Create Document Modal
  'pages.workProducts.createModal.title': 'Create Work Product',
  'pages.workProducts.createModal.templateTab': 'Create from Template',
  'pages.workProducts.createModal.copyTab': 'Copy from Existing',
  'pages.workProducts.createModal.localTab': 'Upload from Local',
  'pages.workProducts.createModal.integrateTab': 'Integrate Other Systems',
  'pages.workProducts.createModal.selectTemplate': 'Select Template',
  'pages.workProducts.createModal.selectTemplatePlaceholder': 'Please select template',
  'pages.workProducts.createModal.version': 'Version',
  'pages.workProducts.createModal.versionRequired': 'Please enter version number',
  'pages.workProducts.createModal.versionPattern':
    'Version number can only contain numbers and dots',
  'pages.workProducts.createModal.versionPlaceholder':
    'Please enter numeric version number, e.g.: 0.0',
  'pages.workProducts.createModal.uploadFile': 'Upload File',
  'pages.workProducts.createModal.uploadFileRequired': 'Please upload file',
  'pages.workProducts.createModal.uploadFileExtra': 'Supports .xlsx, .xls, .docx file formats',
  'pages.workProducts.createModal.uploadFileExtraWithPdf':
    'Supports .xlsx, .xls, .docx, .pdf file formats',
  'pages.workProducts.createModal.pdfFileSizeLimit': 'PDF file size cannot exceed 50MB',
  'pages.workProducts.createModal.uploadFileExtraOriginal':
    'Keep original file option only supports .xlsx, .xls format files',
  'pages.workProducts.createModal.selectFile': 'Select File',
  'pages.workProducts.createModal.workProductName': 'Work Product Name',
  'pages.workProducts.createModal.workProductNamePlaceholder': 'Please enter work product name',
  'pages.workProducts.createModal.keepOriginalFile': 'Keep Original File',
  'pages.workProducts.createModal.keepOriginalFileDesc':
    'Do not convert file to online format, can download to local for modification',
  'pages.workProducts.createModal.clearFileInfo': 'Uploaded file cleared, please re-upload',
  'pages.workProducts.createModal.uploadIntegrateFile':
    'Please upload data file exported from integrated system',
  'pages.workProducts.createModal.projectNotFound': 'Current project not found',
  'pages.workProducts.createModal.systemNames.zentao': 'ZenTao',
  'pages.workProducts.createModal.systemNames.tapd': 'TAPD',
  'pages.workProducts.createModal.systemNames.jira': 'Jira',
  'pages.workProducts.createModal.systemNames.redmine': 'Redmine',
  'pages.workProducts.createModal.aiGeneratingTitle': 'AI is generating document',
  'pages.workProducts.createModal.aiGeneratingDesc':
    'Generate work product based on integrated system data',

  // Create Document Modal - Copy from Existing
  'pages.workProducts.createModal.selectSourceDoc': 'Select Source Work Product',
  'pages.workProducts.createModal.selectSourceDocPlaceholder': 'Please select source work product',
  'pages.workProducts.createModal.newVersion': 'New Version Number',
  'pages.workProducts.createModal.newVersionRequired': 'Please enter new version number',
  'pages.workProducts.createModal.newVersionPlaceholder':
    'Please enter numeric version number, e.g.: 0.0',

  // Create Document Modal - Integrate Systems
  'pages.workProducts.createModal.integrate.zentao': 'ZenTao',
  'pages.workProducts.createModal.integrate.tapd': 'TAPD',
  'pages.workProducts.createModal.integrate.jira': 'Jira',
  'pages.workProducts.createModal.integrate.redmine': 'Redmine',
  'pages.workProducts.createModal.integrate.zentaoDesc': 'ZenTao Project Management System',
  'pages.workProducts.createModal.integrate.tapdDesc': 'TAPD Tencent Agile Collaboration Platform',
  'pages.workProducts.createModal.integrate.jiraDesc': 'Jira Project Management Tool',
  'pages.workProducts.createModal.integrate.redmineDesc': 'Redmine Project Management Tool',
  'pages.workProducts.createModal.integrate.functionDescription': 'Function Description',
  'pages.workProducts.createModal.integrate.functionDescriptionText':
    'Supports integrating data from other project management and defect tracking systems. Please select the system to integrate with, and the data files exported from other systems (CSV, Excel, Word). AI will automatically import the data into the newly created work product.',
  'pages.workProducts.createModal.integrate.selectSystem': 'Select Integration System',
  'pages.workProducts.createModal.integrate.selectSystemRequired':
    'Please select integration system',
  'pages.workProducts.createModal.integrate.selected': 'Selected: {{system}}',
  'pages.workProducts.createModal.integrate.uploadDataFile': 'Upload Data File',
  'pages.workProducts.createModal.integrate.uploadDataFileRequired': 'Please upload data file',
  'pages.workProducts.createModal.integrate.uploadDataFileExtra':
    'Supports .csv, .xlsx, .xls, .docx format files, only supports uploading 1 file',
  'pages.workProducts.createModal.integrate.selectFile': 'Select File',
  'pages.workProducts.createModal.integrate.selectSystemFirst':
    'Please select integration system first',
  'pages.workProducts.createModal.integrate.fileFormatNotSupported':
    'Only supports .csv, .xlsx, .xls, .docx format files',
  'pages.workProducts.createModal.integrate.csvEmpty': 'CSV file content is empty',
  'pages.workProducts.createModal.integrate.csvNoData': 'CSV file has no valid data',
  'pages.workProducts.createModal.integrate.csvParseFailed':
    'CSV file parsing failed, please check file format',
  'pages.workProducts.createModal.integrate.csvReadFailed': 'CSV file reading failed',
  'pages.workProducts.createModal.integrate.systemChanged':
    'Integration system changed, please re-upload file',
  'pages.workProducts.createModal.customDocumentCodePlaceholder': 'Please enter document ID',

  // AI Generate Modal
  'pages.workProducts.aiGenerateModal.title': 'AI Generate',
  'pages.workProducts.aiGenerateModal.cancel': 'Cancel',
  'pages.workProducts.aiGenerateModal.startGenerate': 'Start Generate',
  'pages.workProducts.aiGenerateModal.systemWillGenerate':
    'System will generate work product for {{processCode}} {{processName}}.',
  'pages.workProducts.aiGenerateModal.aiWillGenerate':
    'AI will generate work product based on the following content:',
  'pages.workProducts.aiGenerateModal.builtInTemplates': 'System built-in templates',
  'pages.workProducts.aiGenerateModal.relatedTraceDocs': 'Related trace documents',
  'pages.workProducts.aiGenerateModal.uploadedRefDocs':
    'Your uploaded reference documents (optional)',
  'pages.workProducts.aiGenerateModal.specialRequirements': 'Your special requirements (optional)',
  'pages.workProducts.aiGenerateModal.uploadRefDocs': 'Upload Reference Documents (Optional)',
  'pages.workProducts.aiGenerateModal.specialRequirementsLabel': 'Special Requirements (Optional)',
  'pages.workProducts.aiGenerateModal.specialRequirementsPlaceholder':
    'Please enter your special requirements, such as: need to focus on certain aspects, or need to include specific content, etc.',
  'pages.workProducts.aiGenerateModal.aiGeneratingTitle': 'AI is generating document',
  'pages.workProducts.aiGenerateModal.aiGeneratingDesc':
    'Generate {{processCode}} {{processName}} document based on your requirements',
  'pages.workProducts.aiGenerateModal.projectNotFound':
    'Current project not found, please confirm you have selected a project',
  'pages.workProducts.aiGenerateModal.generateSuccess': 'AI document generation successful',
  'pages.workProducts.aiGenerateModal.generateFailed': 'AI document generation failed',
  'pages.workProducts.aiGenerateModal.enterPrompt': 'Please enter content requirements',
  'pages.workProducts.aiGenerateModal.aiFeatureDev': 'AI generation feature under development...',

  // AI Generating Modal
  'pages.workProducts.aiGeneratingModal.title': 'AI is generating document',
  'pages.workProducts.aiGeneratingModal.description':
    'Generate document based on your requirements',
  'pages.workProducts.aiGeneratingModal.pleaseWait': 'Please wait, document is being generated...',

  // Baseline List
  'pages.workProducts.baselineList.createBaseline': 'Create Baseline',

  // Management Library
  'pages.managementRepository.getProcessListFailed': 'Failed to get process list',
  'pages.managementRepository.getBaselineListFailed': 'Failed to get baseline list',
  'pages.managementRepository.getDocumentListFailed': 'Failed to get document list',
  'pages.managementRepository.addToBaseline': 'Add to Baseline',
  'pages.managementRepository.selectBaseline': 'Please select baseline',
  'pages.managementRepository.baselineUpdateSuccess': 'Document baseline updated successfully',
  'pages.managementRepository.baselineUpdateSuccessWithStatus':
    'Document baseline updated successfully, related baseline status has been changed to draft',
  'pages.managementRepository.baselineUpdateFailed': 'Failed to update document baseline',
  'pages.managementRepository.notInBaseline': 'Not in baseline',
  'pages.managementRepository.statusDraft': 'Draft',
  'pages.managementRepository.statusDraftLocked': 'Draft Locked',
  'pages.managementRepository.statusReview': 'In Review',
  'pages.managementRepository.statusReviewPassed': 'Review Passed',
  'pages.managementRepository.statusAuditPassed': 'Audit Passed',
  'pages.managementRepository.statusApproved': 'Pending Release',
  'pages.managementRepository.statusControlled': 'Controlled',
  'pages.managementRepository.statusPublished': 'Published',
  'pages.managementRepository.statusObsolete': 'Obsolete',
  'pages.managementRepository.documentId': 'Document ID',
  'pages.managementRepository.documentName': 'Document Name',
  'pages.managementRepository.version': 'Version',
  'pages.managementRepository.process': 'Process',
  'pages.managementRepository.status': 'Status',
  'pages.managementRepository.baseline': 'Baseline',
  'pages.managementRepository.addToProductLibrary': 'Add to Product Library',
  'pages.managementRepository.removeFromProductLibrary': 'Remove from Product Library',
  'pages.managementRepository.addToProductLibrarySuccess': 'Added to product library',
  'pages.managementRepository.addToProductLibraryFailed': 'Failed to add to product library',
  'pages.managementRepository.removeFromProductLibrarySuccess': 'Removed from product library',
  'pages.managementRepository.removeFromProductLibraryFailed':
    'Failed to remove from product library',
  'pages.managementRepository.productLibraryOperationFailed': 'Product library operation failed',
  'pages.managementRepository.noPermission': 'No permission',
  'pages.managementRepository.owner': 'Owner',
  'pages.managementRepository.searchPlaceholder': 'Search document name or ID',
  'pages.managementRepository.selectProcess': 'Select Process',
  'pages.managementRepository.selectBaselineFilter': 'Select Baseline',
  'pages.managementRepository.search': 'Search',
  'pages.managementRepository.updateBaselineTooltip': 'Update Baseline',
  'pages.managementRepository.updateDocumentBaseline': 'Update Document Baseline',
  'pages.managementRepository.removeBaseline': 'Remove from baseline',
  'pages.managementRepository.removeBaselineDesc':
    'Select "Remove from baseline" to remove the document from the current baseline',
  'pages.managementRepository.duplicateDocumentWarning':
    'Other documents with duplicate names under the same process will be removed from the current baseline',
  'pages.managementRepository.statusWarning':
    'Note: Updating the baseline will change the related baseline status to draft',

  // Change Request List
  'pages.changeRequestList.typeSystem': 'System',
  'pages.changeRequestList.typeSoftware': 'Software',
  'pages.changeRequestList.typeOther': 'Other',
  'pages.changeRequestList.statusOpen': 'Open',
  'pages.changeRequestList.statusClosed': 'Closed',
  'pages.changeRequestList.getChangeRequestsFailed': 'Failed to get change requests',
  'pages.changeRequestList.getChangeRequestsListFailed': 'Failed to get change request list',
  'pages.changeRequestList.getBaselineListFailed': 'Failed to get baseline list',
  'pages.changeRequestList.getProjectMembersFailed': 'Failed to get project members',
  'pages.changeRequestList.confirmDelete': 'Confirm Delete',
  'pages.changeRequestList.deleteConfirmMessage':
    'Are you sure you want to delete change request {{id}}? This operation cannot be undone.',
  'pages.changeRequestList.confirm': 'Confirm',
  'pages.changeRequestList.cancel': 'Cancel',
  'pages.changeRequestList.deleteSuccess': 'Delete successful',
  'pages.changeRequestList.deleteFailed': 'Delete failed',
  'pages.changeRequestList.deleteChangeRequestFailed': 'Failed to delete change request',
  'pages.changeRequestList.updateSuccess': 'Update successful',
  'pages.changeRequestList.createSuccess': 'Create successful',
  'pages.changeRequestList.updateFailed': 'Update failed',
  'pages.changeRequestList.createFailed': 'Create failed',
  'pages.changeRequestList.submitFailed': 'Submit failed, please check the form',
  'pages.changeRequestList.changeNumber': 'Change Number',
  'pages.changeRequestList.createTime': 'Create Time',
  'pages.changeRequestList.changeSource': 'Change Source',
  'pages.changeRequestList.impactAnalysisReport': 'Impact Analysis Report',
  'pages.changeRequestList.status': 'Status',
  'pages.changeRequestList.actions': 'Actions',
  'pages.changeRequestList.searchPlaceholder': 'Enter change number to search',
  'pages.changeRequestList.view': 'View',
  'pages.changeRequestList.update': 'Update',
  'pages.changeRequestList.delete': 'Delete',
  'pages.changeRequestList.uploadSuccess': '{{filename}} uploaded successfully',
  'pages.changeRequestList.uploadFailed': '{{filename}} upload failed: {{error}}',
  'pages.changeRequestList.unknownError': 'Unknown error',
  'pages.changeRequestList.uploadFailedGeneric': '{{filename}} upload failed',
  'pages.changeRequestList.fileTypeError': 'Only PDF, Word, Excel format files are supported!',
  'pages.changeRequestList.uploadFileExtra': 'Supports .pdf, .doc, .docx, .xls, .xlsx file formats',
  'pages.changeRequestList.fileSizeError': 'File size cannot exceed 10MB!',
  'pages.changeRequestList.createChangeRequest': 'Create Change Request',
  'pages.changeRequestList.updateChangeRequest': 'Update Change Request',
  'pages.changeRequestList.createChangeRequestTitle': 'Create Change Request',
  'pages.changeRequestList.fieldRequired': '{{label}} cannot be empty',
  'pages.changeRequestList.changeSourceLabel': 'Change Source',
  'pages.changeRequestList.changeSourcePlaceholder':
    'e.g.: Customer requirements, Internal optimization',
  'pages.changeRequestList.ownerLabel': 'Owner',
  'pages.changeRequestList.ownerPlaceholder': 'Select change request owner',
  'pages.changeRequestList.descriptionLabel': 'Change Description',
  'pages.changeRequestList.descriptionPlaceholder':
    'Describe the change content and reason in detail',
  'pages.changeRequestList.crTypeLabel': 'CR Type',
  'pages.changeRequestList.crTypePlaceholder': 'Select change request type',
  'pages.changeRequestList.affectedSystemBaselineLabel': 'Affected System Baseline',
  'pages.changeRequestList.affectedSystemBaselinePlaceholder': 'Select affected system baseline',
  'pages.changeRequestList.plannedSystemBaselineLabel': 'Planned System Baseline',
  'pages.changeRequestList.plannedSystemBaselinePlaceholder': 'Select planned system baseline',
  'pages.changeRequestList.affectedSoftwareBaselineLabel': 'Affected Software Baseline',
  'pages.changeRequestList.affectedSoftwareBaselinePlaceholder':
    'Select affected software baseline',
  'pages.changeRequestList.plannedSoftwareBaselineLabel': 'Planned Software Baseline',
  'pages.changeRequestList.plannedSoftwareBaselinePlaceholder': 'Select planned software baseline',
  'pages.changeRequestList.uploadFile': 'Upload File',
  'pages.changeRequestList.ccbDecisionLabel': 'CCB Decision',
  'pages.changeRequestList.impactAnalysisResultReport': 'Impact Analysis Result Report',
  'pages.changeRequestList.viewReport': 'View Report',
  'pages.changeRequestList.ccbDecision': 'CCB Decision',
  'pages.changeRequestList.plannedImplementationTime': 'Planned Implementation Time',
  'pages.changeRequestList.actualImplementationTime': 'Actual Implementation Time',
  'pages.changeRequestList.none': 'None',
  'pages.changeRequestList.notSet': 'Not set',
  'pages.changeRequestList.notImplemented': 'Not implemented',
  'pages.changeRequestList.impactAnalysisReportLabel': 'Impact Analysis Report',
  'pages.changeRequestList.applicationInfo': 'Application Information',
  'pages.changeRequestList.changeNumberLabel': 'Change Number',
  'pages.changeRequestList.changeNumberPlaceholder': 'Please enter change number',
  'pages.changeRequestList.expectedCompletionDateLabel': 'Expected Completion Date',
  'pages.changeRequestList.applicant': 'Applicant',
  'pages.changeRequestList.applicationDate': 'Application Date',
  'pages.changeRequestList.changeSourceTypeLabel': 'Change Source Type',
  'pages.changeRequestList.changeSourceTypePlaceholder': 'Please select change source type',
  'pages.changeRequestList.sourceTypeCustomer': 'Customer Requirements & Feedback',
  'pages.changeRequestList.sourceTypeDefect': 'Testing & Field Defects',
  'pages.changeRequestList.sourceTypeTech': 'Technical Solutions & Hardware/Software Adaptation',
  'pages.changeRequestList.sourceTypeAspice': 'ASPICE Internal Audit & Assessment Improvement',
  'pages.changeRequestList.sourceTypeRegulatory': 'Regulatory & Industry Standard Updates',
  'pages.changeRequestList.sourceTypeProcess': 'Internal Process & System Optimization',
  'pages.changeRequestList.sourceTypeProject': 'Project Management Requirements Adjustment',
  'pages.changeRequestList.sourceTypeSupplier': 'Supplier & External Collaboration Changes',
  'pages.changeRequestList.sourceTypeOther': 'Other',
  'pages.changeRequestList.changeSourceBasisLabel': 'Change Source Basis',
  'pages.changeRequestList.changeSourceBasisPlaceholder': 'Please enter change source basis',
  'pages.changeRequestList.changeRequirementLabel': 'Change Requirement Description',
  'pages.changeRequestList.changeRequirementPlaceholder':
    'Please describe the change requirements in detail',
  'pages.changeRequestList.changeLevelLabel': 'Change Level',
  'pages.changeRequestList.levelSafety': 'Functional Safety Related',
  'pages.changeRequestList.levelRegulatory': 'Regulatory Related',
  'pages.changeRequestList.levelGeneral': 'General Function Related',
  'pages.changeRequestList.levelOther': 'Other',
  'pages.changeRequestList.attachmentLabel': 'Attachment',
  'pages.changeRequestList.relatedProcesses': 'Related Processes',
  'pages.changeRequestList.processes': 'Processes',
  'pages.changeRequestList.selectProcessPlaceholder': 'Select process',
  'pages.changeRequestList.selectDocumentPlaceholder': 'Select document',
  'pages.changeRequestList.review': 'Review',
  'pages.changeRequestList.verify': 'Verify',
  'pages.changeRequestList.changeVerification': 'Change Verification',
  'pages.changeRequestList.completed': 'Completed',
  'pages.changeRequestList.partial': 'Partial',
  'pages.changeRequestList.missedItems': 'Missed Items',
  'pages.changeRequestList.verifyModal.title': 'Change Verification',
  'pages.changeRequestList.verifyModal.resultRequired': 'Please select change verification result',
  'pages.changeRequestList.verifyModal.missedItemsRequired': 'Please fill in missed items',
  'pages.changeRequestList.verifyModal.missedItemsPlaceholder': 'Please fill in missed items',
  'pages.changeRequestList.verifyModal.success': 'Verification completed',
  'pages.changeRequestList.verifyModal.failed': 'Verification failed',
  'pages.changeRequestList.export': 'Export',
  'pages.changeRequestList.noDataToExport': 'No data to export',
  'pages.changeRequestList.exportSuccess': 'Export successful',
  'pages.changeRequestList.changeRequestDetailsTitle': 'Change Request Details',
  'pages.changeRequestList.close': 'Close',
  'pages.changeRequestList.projectName': 'Project Name',
  'pages.changeRequestList.changeDescription': 'Change Description',

  // Change Review Modal
  'pages.changeRequestList.reviewModal.title': 'Change Review',
  'pages.changeRequestList.reviewModal.change': 'Change Required',
  'pages.changeRequestList.reviewModal.noImpact': 'No Impact',
  'pages.changeRequestList.reviewModal.approveChange': 'Approve Change',
  'pages.changeRequestList.reviewModal.changeDocuments': 'Affected Documents',
  'pages.changeRequestList.reviewModal.document': 'Document',
  'pages.changeRequestList.reviewModal.selectDocument': 'Please select document',
  'pages.changeRequestList.reviewModal.alreadyChanged': 'Already Changed',
  'pages.changeRequestList.reviewModal.changeSummary': 'Please enter change summary',
  'pages.changeRequestList.reviewModal.success': 'Review completed',
  'pages.changeRequestList.reviewModal.failed': 'Review failed',
  'pages.changeRequestList.reviewModal.getDocumentsFailed': 'Failed to get document list',
  'pages.changeRequestList.reviewModal.missingDocuments':
    'Documents not selected for the following processes with "Approve Change": ',
  'pages.changeRequestList.reviewModal.emptyDescription':
    'Change summary cannot be empty for document "{{docName}}" in {{processCode}}',
  'pages.changeRequestList.ccbDecisionPlaceholder':
    'Enter Configuration Control Board (CCB) decision content',
  'pages.changeRequestList.statusLabel': 'Status',
  'pages.changeRequestList.statusPlaceholder': 'Select current status',
  'pages.changeRequestList.plannedImplementationTimeLabel': 'Planned Implementation Time',
  'pages.changeRequestList.actualImplementationTimeLabel': 'Actual Implementation Time',

  // Traceability component
  'pages.traceability.noWorkProductTitle': 'No Work Product',
  'pages.traceability.noWorkProductDesc':
    'No work product has been created for process {{processCode}}',

  // Template update tip & document tree
  'pages.aspice.templates.updateTip':
    'If you need to update the template, create a new work product with this template in the project, edit it and submit for review. After approval, click "New Template" to create a new version.',
  'pages.documentTree.expandAll': 'Expand All',
  'pages.documentTree.collapseAll': 'Collapse All',
  'pages.documentTree.updateChapterNum': 'Update Chapter Number',

  // License messages
  'pages.login.license.invalid': 'System License status is abnormal: {{message}}',
  'pages.login.license.expiring':
    'System License will expire in {{days}} days, please renew in time',

  // Reference Document Uploader
  'pages.referenceUploader.docxFormatRecommended':
    'Recommend using .docx format for better parsing results',
  'pages.referenceUploader.cannotParseDoc':
    'Cannot parse .doc format file, please convert to .docx format',
  'pages.referenceUploader.unsupportedFormat': 'Unsupported file format',
  'pages.referenceUploader.fileReadFailed': 'File reading failed',
  'pages.referenceUploader.onlySupports':
    'Only supports Word (.doc, .docx) and Excel (.xls, .xlsx) formats',
  'pages.referenceUploader.fileSizeLimit': 'File size cannot exceed 10MB',
  'pages.referenceUploader.parseSuccess': '{{filename}} parsed successfully',
  'pages.referenceUploader.parseFailed': '{{filename}} parsing failed: {{error}}',
  'pages.referenceUploader.unknownError': 'Unknown error',
  'pages.referenceUploader.documentDeleted': 'Document deleted',
  'pages.referenceUploader.noContent': 'No content',
  'pages.referenceUploader.worksheet': 'Worksheet',
  'pages.referenceUploader.parsing': 'Parsing...',
  'pages.referenceUploader.selectReferenceDoc': 'Select Reference Document',
  'pages.referenceUploader.supportFormats':
    'Supports Word (.doc, .docx) and Excel (.xls, .xlsx) formats, max 10MB, up to {{maxCount}} files',
  'pages.referenceUploader.uploadedDocs': 'Uploaded Documents',
  'pages.referenceUploader.preview': 'Preview',
  'pages.referenceUploader.delete': 'Delete',
  'pages.referenceUploader.wordDoc': 'Word Document',
  'pages.referenceUploader.excelWorkbook': 'Excel Workbook',
  'pages.referenceUploader.worksheets': 'worksheets',
  'pages.referenceUploader.close': 'Close',

  // Diagram Modal
  'pages.diagramModal.newTitle': 'New Diagram',
  'pages.diagramModal.editTitle': 'Edit Diagram',
  'pages.diagramModal.importTitle': 'Import Diagram',
  'pages.diagramModal.save': 'Save',
  'pages.diagramModal.cancel': 'Cancel',
  'pages.diagramModal.loading': 'Loading diagram editor...',
  'pages.diagramModal.notInitialized': 'Editor not initialized yet, please wait',

  // Create Baseline Modal
  'pages.createBaseline.getBaselineInfoFailed': 'Failed to get baseline information',
  'pages.createBaseline.updateSuccess': 'Baseline updated successfully',
  'pages.createBaseline.updateFailed': 'Failed to update baseline',
  'pages.createBaseline.createFailed': 'Failed to create baseline',
  'pages.createBaseline.createSuccess': 'Baseline created successfully',
  'pages.createBaseline.updateTitle': 'Update Baseline',
  'pages.createBaseline.createTitle': 'Create Baseline',
  'pages.createBaseline.nameLabel': 'Baseline Name',
  'pages.createBaseline.nameRequired': 'Please enter baseline name',
  'pages.createBaseline.namePlaceholder': 'Please enter baseline name',
  'pages.createBaseline.descriptionLabel': 'Baseline Description',
  'pages.createBaseline.descriptionPlaceholder': 'Please enter baseline description (optional)',

  // Baseline List
  'pages.baselineList.getProcessListFailed': 'Failed to get process list',
  'pages.baselineList.getBaselineListFailed': 'Failed to get baseline list',
  'pages.baselineList.baselineNotFound': 'Baseline information not found',
  'pages.baselineList.configItemList': 'Configuration Item List',
  'pages.baselineList.configItemListNotFound': 'Configuration Item List document not found',
  'pages.baselineList.getConfigItemListFailed': 'Failed to get Configuration Item List',
  'pages.baselineList.preparingExport': 'Preparing export...',
  'pages.baselineList.gettingBaselineDocs': 'Getting baseline documents...',
  'pages.baselineList.noAssociatedDocs': 'This baseline has no associated documents',
  'pages.baselineList.foundDocsStartExport': 'Found {{count}} documents, starting export...',
  'pages.baselineList.exportingProcessDoc': 'Exporting {{docTitle}} in {{processCode}}',
  'pages.baselineList.untitledDoc': 'Untitled Document',
  'pages.baselineList.generatingZip': 'Generating zip file...',
  'pages.baselineList.exportAllSuccess': 'All work products exported successfully',
  'pages.baselineList.exportFailed': 'Export failed, please try again',
  'pages.baselineList.confirmDelete': 'Confirm Delete',
  'pages.baselineList.deleteBaselineWarning':
    'Deleting the baseline will remove all associations between work products and this baseline, but will not delete the work products themselves. Are you sure you want to delete this baseline?',
  'pages.baselineList.confirm': 'Confirm',
  'pages.baselineList.cancel': 'Cancel',
  'pages.baselineList.deleteSuccess': 'Baseline deleted successfully',
  'pages.baselineList.deleteFailed': 'Failed to delete baseline',
  'pages.baselineList.exportAllConfigItems': 'Export All Configuration Items',
  'pages.baselineList.exportAllWorkProducts': 'Export All Work Products',
  'pages.baselineList.statusDraft': 'Draft',
  'pages.baselineList.statusReview': 'In Review',
  'pages.baselineList.statusApproved': 'Pending Release',
  'pages.baselineList.statusPublished': 'Published',
  'pages.baselineList.statusObsolete': 'Obsolete',
  'pages.baselineList.baselineId': 'Baseline ID',
  'pages.baselineList.baselineName': 'Baseline Name',
  'pages.baselineList.baselineDescription': 'Baseline Description',
  'pages.baselineList.status': 'Status',
  'pages.baselineList.workProductCount': 'Work Product Count',
  'pages.baselineList.createTime': 'Created Time',
  'pages.baselineList.actions': 'Actions',
  'pages.baselineList.configItemListTooltip': 'Configuration Item List',
  'pages.baselineList.updateBaselineTooltip': 'Update Baseline',
  'pages.baselineList.deleteBaselineTooltip': 'Delete Baseline',

  // Doc Editor messages
  'pages.docEditor.message.saveSuccess': 'Saved successfully',
  'pages.docEditor.message.saveFail': 'Save failed',
  'pages.docEditor.message.saveFailRetry': 'Save failed, please try again later',
  'pages.docEditor.message.saveLoading': 'Saving...',
  'pages.docEditor.message.documentIdMissing': 'Document ID not found, cannot save',
  'pages.docEditor.message.inputVersionNumber': 'Please enter version number',
  'pages.docEditor.message.inputVersionDescription': 'Please enter version description',
  'pages.docEditor.message.newVersionCreated': 'New version created successfully',
  'pages.docEditor.message.export.noDocInfo':
    'Cannot export document, document information does not exist',
  'pages.docEditor.message.untitledDocument': 'Untitled Document',
  'pages.docEditor.message.fetchReviewStatusFail': 'Failed to fetch review status',
  'pages.docEditor.message.docInfoMissing': 'Document information is missing',
  'pages.docEditor.message.saveContentForReviewFail':
    'Failed to save document content, cannot submit review',
  'pages.docEditor.message.updateMetadataFail': 'Failed to update document metadata',
  'pages.docEditor.message.submitReviewSuccess': 'Document has been submitted for review',
  'pages.docEditor.message.submitChangeSuccess': 'Change has been submitted',
  'pages.docEditor.message.submitReviewFail': 'Submit review failed',
  'pages.docEditor.message.reviewInfoMissing': 'Document or review information is missing',
  'pages.docEditor.message.submitReviewResultSuccess': 'Review result submitted',
  'pages.docEditor.message.submitReviewResultFail': 'Submit review result failed',
  'pages.docEditor.message.titleUpdateSuccess': 'Title updated successfully',
  'pages.docEditor.message.fileExportSuccess': 'File exported successfully',
  'pages.docEditor.message.fileExportFail': 'File export failed, please retry',
  'pages.docEditor.message.uploadSuccess': 'File uploaded successfully',
  'pages.docEditor.message.revisionUpdateSuccess': 'Revision history updated',
  'pages.docEditor.message.revisionDeleteSuccess': 'Revision record deleted',
  'pages.docEditor.message.traceSaveSuccess': 'Trace configuration saved',
  'pages.docEditor.message.nodeAddSuccess': 'Node added successfully',
  'pages.docEditor.message.nodeDeleteSuccess': 'Node deleted successfully',
  'pages.docEditor.message.nodeAttachmentsDeleteFail':
    'Failed to delete attachments of the node, please try again later',
  'pages.docEditor.message.copySuccess': 'Copied to clipboard',
  'pages.docEditor.message.nodeUpgradeSuccess': 'Node upgraded successfully',
  'pages.docEditor.message.nodeDowngradeSuccess': 'Node downgraded successfully',
  'pages.docEditor.message.aiContentAdded': 'AI generated content added to the end of document',
  'pages.docEditor.message.aiFeatureDev': 'AI generation feature is under development...',
  'pages.docEditor.message.aiGenerateFail': 'AI generation failed',
  'pages.docEditor.message.generateSuccess': 'Content generated successfully',
  'pages.docEditor.message.nodeCodeUpdated': 'Node code updated',
  'pages.docEditor.message.updateChangeRequestFail': 'Failed to update change request',

  // Tabs
  'pages.docEditor.tab.testSpec': 'Test Specification',
  'pages.docEditor.tab.testSummary': 'Test Summary',

  // Test Summary component
  'pages.docEditor.testSummary.noResultColumn':
    'No Test Result column found, cannot generate summary',
  'pages.docEditor.testSummary.statisticsTitle': 'Test Execution Statistics',
  'pages.docEditor.testSummary.totalCases': 'Total Test Cases',
  'pages.docEditor.testSummary.passed': 'Passed',
  'pages.docEditor.testSummary.failed': 'Failed',
  'pages.docEditor.testSummary.notExecuted': 'Not Executed',
  'pages.docEditor.testSummary.resultDistribution': 'Result Distribution',
  'pages.docEditor.testSummary.resultDetails': 'Result Details',

  // Doc Editor Save Modal
  'pages.docEditor.saveModal.title': 'Save Document',
  'pages.docEditor.saveModal.saveOption': 'Save Method',
  'pages.docEditor.saveModal.saveOptionExtra':
    'Select to create a new version, the current version will be set to Draft Locked',
  'pages.docEditor.saveModal.saveToCurrent': 'Save to current version',
  'pages.docEditor.saveModal.newVersion': 'Create new version',
  'pages.docEditor.saveModal.newVersionNumber': 'New Version Number',
  'pages.docEditor.saveModal.inputNewVersionNumber': 'Please enter version number',
  'pages.docEditor.saveModal.versionDescription': 'Version Description',
  'pages.docEditor.saveModal.versionDescriptionExtra':
    'Please briefly describe the changes in this version',
  'pages.docEditor.saveModal.inputVersionDescription': 'Please enter version description',
  'pages.docEditor.saveModal.revisionDescription': 'Revision description',
  'pages.docEditor.saveModal.inputRevisionDescription': 'Please enter the revision description',

  // Doc Editor Review Modal
  'pages.docEditor.reviewModal.title': 'Submit Review',
  'pages.docEditor.reviewModal.processTitle': 'Review process:',
  'pages.docEditor.reviewModal.processItem1':
    'Document review has four stages: Review Group → Review Leader → Audit → Approval',
  'pages.docEditor.reviewModal.processItem2':
    'After the review group all approve, the review leader reviews; after the leader approves, the auditor reviews; after the auditor approves, it enters approval',
  'pages.docEditor.reviewModal.processItem3':
    'Rejecting back to the owner upgrades a minor version; returning to the review leader or auditor continues on the same document',
  'pages.docEditor.reviewModal.reviewerLabel': 'Review Group',
  'pages.docEditor.reviewModal.reviewLeaderLabel': 'Review Leader',
  'pages.docEditor.reviewModal.auditorLabel': 'Auditor',
  'pages.docEditor.reviewModal.approverLabel': 'Approver',
  'pages.docEditor.reviewModal.reviewerValidation':
    'Please select at least one review group member',
  'pages.docEditor.reviewModal.reviewLeaderValidation': 'Please select a review leader',
  'pages.docEditor.reviewModal.samePersonValidation':
    'Auditor and approver cannot be the same person',
  'pages.docEditor.reviewModal.approverInReviewersValidation':
    'Approver cannot be in the review group',
  'pages.docEditor.reviewModal.auditorInReviewersValidation':
    'Auditor cannot be in the review group',
  'pages.docEditor.reviewModal.reviewLeaderInReviewersValidation':
    'Review leader cannot be in the review group',
  'pages.docEditor.reviewModal.auditorEqualsApproverValidation':
    'Auditor and approver cannot be the same person',
  'pages.docEditor.reviewModal.reviewLeaderEqualsAuditorValidation':
    'Review leader and auditor cannot be the same person',
  'pages.docEditor.reviewModal.reviewLeaderEqualsApproverValidation':
    'Review leader and approver cannot be the same person',
  'pages.docEditor.reviewModal.reviewerExtra':
    'The review group reviews the document and provides feedback; multiple members can be selected',
  'pages.docEditor.reviewModal.svvOwnerHint': '{{code}} owner: {{name}}',
  'pages.docEditor.reviewModal.reviewerPlaceholder':
    'Please select one or more review group members',
  'pages.docEditor.reviewModal.reviewLeaderPlaceholder': 'Please select review leader',
  'pages.docEditor.reviewModal.reviewLeaderExtra':
    'The review leader reviews the document after the review group all approve',
  'pages.docEditor.reviewModal.auditorPlaceholder': 'Please select auditor',
  'pages.docEditor.reviewModal.auditorValidation': 'Please select an auditor',
  'pages.docEditor.reviewModal.auditorExtra':
    'The auditor reviews the document after the review group all approve',
  'pages.docEditor.reviewModal.approverPlaceholder': 'Please select approver',
  'pages.docEditor.reviewModal.approverValidation': 'Please select an approver',
  'pages.docEditor.reviewModal.approverExtra':
    'Approver is responsible for final confirmation that the document can be published',
  'pages.docEditor.reviewModal.changeSummaryLabel': 'Change Content',
  'pages.docEditor.reviewModal.changeSummaryValidation': 'Please enter the change content',

  'pages.docEditor.submitChangeModal.title': 'Submit Change',
  'pages.docEditor.submitChangeModal.processTitle': 'Change process:',
  'pages.docEditor.submitChangeModal.processItem1':
    'A simple change has four stages: Project Manager → CCB Leader → Verification → Confirmation',
  'pages.docEditor.submitChangeModal.processItem2':
    'After the project manager confirms, the CCB leader reviews; after the leader approves, verification starts; after verification, it enters confirmation',
  'pages.docEditor.submitChangeModal.processItem3':
    'Rejecting back to the owner upgrades a minor version; returning to the CCB leader or verifier continues on the same document',
  'pages.docEditor.submitChangeModal.projectManager': 'Project Manager',
  'pages.docEditor.submitChangeModal.ccbLeader': 'CCB Leader',
  'pages.docEditor.submitChangeModal.verifier': 'Verifier',
  'pages.docEditor.submitChangeModal.confirmer': 'Confirmer',
  'pages.docEditor.submitChangeModal.projectManagerExtra':
    'Project manager of the current project. This cannot be changed',
  'pages.docEditor.submitChangeModal.projectManagerRequired':
    'The current project has no project manager',
  'pages.docEditor.submitChangeModal.ccbLeaderRequired': 'Please select a CCB leader',
  'pages.docEditor.submitChangeModal.verifierRequired': 'Please select a verifier',
  'pages.docEditor.submitChangeModal.confirmerRequired': 'Please select a confirmer',
  'pages.docEditor.submitChangeModal.ccbLeaderPlaceholder': 'Please select a CCB leader',
  'pages.docEditor.submitChangeModal.verifierPlaceholder': 'Please select a verifier',
  'pages.docEditor.submitChangeModal.confirmerPlaceholder': 'Please select a confirmer',
  'pages.docEditor.submitChangeModal.ccbLeaderExtra':
    'The CCB leader reviews after the project manager approves',
  'pages.docEditor.submitChangeModal.verifierExtra':
    'The verifier checks the change after the CCB leader approves',
  'pages.docEditor.submitChangeModal.confirmerExtra':
    'The confirmer makes the final confirmation before release',
  'pages.docEditor.submitChangeModal.sameAsProjectManager':
    'Cannot be the same person as the project manager',
  'pages.docEditor.submitChangeModal.ccbLeaderEqualsVerifier':
    'CCB leader and verifier cannot be the same person',
  'pages.docEditor.submitChangeModal.ccbLeaderEqualsConfirmer':
    'CCB leader and confirmer cannot be the same person',
  'pages.docEditor.submitChangeModal.verifierEqualsConfirmer':
    'Verifier and confirmer cannot be the same person',

  // Update Review modal
  'pages.docEditor.updateReviewModal.title': 'Update Reviewers',
  'pages.docEditor.updateReviewModal.reviewerLabel': 'Review Group',
  'pages.docEditor.updateReviewModal.reviewLeaderLabel': 'Review Leader',
  'pages.docEditor.updateReviewModal.auditorLabel': 'Auditor',
  'pages.docEditor.updateReviewModal.approverLabel': 'Approver',
  'pages.docEditor.updateReviewModal.reviewerValidation':
    'Please select at least one review group member',
  'pages.docEditor.updateReviewModal.reviewLeaderValidation': 'Please select a review leader',
  'pages.docEditor.updateReviewModal.auditorValidation': 'Please select an auditor',
  'pages.docEditor.updateReviewModal.approverValidation': 'Please select an approver',
  'pages.docEditor.updateReviewModal.approverInReviewersValidation':
    'Approver cannot be in the review group',
  'pages.docEditor.updateReviewModal.auditorInReviewersValidation':
    'Auditor cannot be in the review group',
  'pages.docEditor.updateReviewModal.auditorEqualsApproverValidation':
    'Auditor and approver cannot be the same person',
  'pages.docEditor.updateReviewModal.reviewLeaderInReviewersValidation':
    'Review leader cannot be in the review group',
  'pages.docEditor.updateReviewModal.reviewLeaderEqualsAuditorValidation':
    'Review leader and auditor cannot be the same person',
  'pages.docEditor.updateReviewModal.reviewLeaderEqualsApproverValidation':
    'Review leader and approver cannot be the same person',
  'pages.docEditor.updateReviewModal.reviewerExtra':
    'Multiple review group members can be selected; the review leader starts after all of them approve',
  'pages.docEditor.updateReviewModal.reviewLeaderExtra':
    'The review leader will review after the review group all approve',
  'pages.docEditor.updateReviewModal.auditorExtra':
    'The auditor will review after the review leader approves',
  'pages.docEditor.updateReviewModal.approverExtra':
    'Approver will make final approval after the auditor approves',
  'pages.docEditor.updateReviewModal.reviewerPlaceholder': 'Please select review group',
  'pages.docEditor.updateReviewModal.reviewLeaderPlaceholder': 'Please select review leader',
  'pages.docEditor.updateReviewModal.auditorPlaceholder': 'Please select auditor',
  'pages.docEditor.updateReviewModal.approverPlaceholder': 'Please select approver',

  // Close Document modal
  'pages.docEditor.closeModal.title': 'Close Document',
  'pages.docEditor.closeModal.confirm': 'Do you want to save the current document?',
  'pages.docEditor.closeModal.saveAndClose': 'Save and Close',
  'pages.docEditor.closeModal.closeDirectly': 'Close Without Saving',

  // ExcelTable Add Column
  'pages.excelTable.addFirstColumn': 'Add to first column',
  'pages.excelTable.afterColumn': 'after',
  'pages.excelTable.tableEnd': 'End of table',

  // AI Generator quick prompts
  'pages.excelTable.quickSendTip': 'Ctrl/Cmd + Enter quick send',
  'pages.excelTable.quickPromptTitle': 'Quick prompt suggestions:',
  'pages.excelTable.aiPromptPlaceholder': 'Please enter your table data request...',
  'pages.excelTable.aiPromptDescription':
    'Enter your requirements and AI will generate related data',

  // Review result modal
  'pages.docEditor.reviewResultModal.yourRole': 'Your role:',
  'pages.docEditor.reviewResultModal.currentStatus': 'Current status:',
  'pages.docEditor.reviewResultModal.approved': 'Approved',
  'pages.docEditor.reviewResultModal.rejected': 'Rejected',
  'pages.docEditor.reviewResultModal.pending': 'Pending',
  'pages.docEditor.reviewResultModal.reviewResult': 'Review Result',
  'pages.docEditor.reviewResultModal.approveOption': 'Approve',
  'pages.docEditor.reviewResultModal.rejectOption': 'Reject',
  'pages.docEditor.reviewResultModal.comment': 'Review Comment',
  'pages.docEditor.reviewResultModal.commentRequired': 'Please enter review comment',

  // Revision history modal
  'pages.docEditor.revisionHistory.title': 'Revision History',
  'pages.docEditor.revisionHistory.version': 'Version',
  'pages.docEditor.revisionHistory.record': 'Revision Record',
  'pages.docEditor.revisionHistory.date': 'Revision Date',
  'pages.docEditor.revisionHistory.author': 'Author',
  'pages.docEditor.revisionHistory.reviewer': 'Reviewer',
  'pages.docEditor.revisionHistory.approver': 'Approver',
  'pages.docEditor.revisionHistory.inputRecord': 'Please enter revision record',

  // Revision records modal
  'pages.docEditor.revisionRecords.title': 'Revision Record',
  'pages.docEditor.revisionRecords.version': 'Version',
  'pages.docEditor.revisionRecords.description': 'Revision description',
  'pages.docEditor.revisionRecords.date': 'Revision Date',
  'pages.docEditor.revisionRecords.author': 'Owner',
  'pages.docEditor.revisionRecords.reviewers': 'Review Group',
  'pages.docEditor.revisionRecords.auditors': 'Auditor',
  'pages.docEditor.revisionRecords.approvers': 'Approvers',
  'pages.docEditor.revisionRecords.actions': 'Actions',
  'pages.docEditor.revisionRecords.confirmDelete':
    'Are you sure you want to delete this revision record?',

  // Control Page modal
  'pages.docEditor.controlPage.title': 'Document Control Page',
  'pages.docEditor.controlPage.docVersion': 'Doc Version',
  'pages.docEditor.controlPage.docID': 'Doc ID',
  'pages.docEditor.controlPage.docStatus': 'Doc Status',
  'pages.docEditor.controlPage.draft': 'Draft',
  'pages.docEditor.controlPage.draftLocked': 'Draft Locked',
  'pages.docEditor.controlPage.inReview': 'In Review',
  'pages.docEditor.controlPage.reviewPassed': 'Review Passed',
  'pages.docEditor.controlPage.auditPassed': 'Audit Passed',
  'pages.docEditor.controlPage.approved': 'Approved',
  'pages.docEditor.controlPage.controlled': 'Controlled',
  'pages.docEditor.controlPage.released': 'Released',
  'pages.docEditor.controlPage.author': 'Author',
  'pages.docEditor.controlPage.review': 'Review',
  'pages.docEditor.controlPage.audit': 'Audit',
  'pages.docEditor.controlPage.approve': 'Approval',
  'pages.docEditor.controlPage.date': 'Date',

  // ChangeRequestSummaryList
  'pages.changeRequestSummaryList.getSummariesFailed': 'Failed to get change request summaries',
  'pages.changeRequestSummaryList.getSummariesListFailed':
    'Failed to get change request summary list',
  'pages.changeRequestSummaryList.getChangeRequestsFailed': 'Failed to get change requests',
  'pages.changeRequestSummaryList.parseChangeRequestIdsFailed':
    'Failed to parse change request ID list',
  'pages.changeRequestSummaryList.versionExists':
    'Version V{{version}} already exists, please use a new version number or update the existing change request summary',
  'pages.changeRequestSummaryList.updateSummaryFailed': 'Failed to update change request summary',
  'pages.changeRequestSummaryList.createSummaryFailed': 'Failed to create change request summary',
  'pages.changeRequestSummaryList.deleteFailed': 'Delete failed',
  'pages.changeRequestSummaryList.deleteDocumentFailed': 'Failed to delete document',
  'pages.changeRequestSummaryList.submitFailed': 'Submit failed, please check the form',
  'pages.changeRequestSummaryList.updateSummarySuccess':
    'Change request summary updated successfully',
  'pages.changeRequestSummaryList.createSummarySuccess':
    'Change request summary created successfully',
  'pages.changeRequestSummaryList.deleteSuccess': 'Delete successful',
  'pages.changeRequestSummaryList.version': 'Version',
  'pages.changeRequestSummaryList.status': 'Status',
  'pages.changeRequestSummaryList.createTime': 'Create Time',
  'pages.changeRequestSummaryList.actions': 'Actions',
  'pages.changeRequestSummaryList.statusDraft': 'Draft',
  'pages.changeRequestSummaryList.statusDraftLocked': 'Draft Locked',
  'pages.changeRequestSummaryList.statusReview': 'Under Review',
  'pages.changeRequestSummaryList.statusApproved': 'Approved',
  'pages.changeRequestSummaryList.statusPublished': 'Published',
  'pages.changeRequestSummaryList.statusArchived': 'Archived',
  'pages.changeRequestSummaryList.preview': 'Preview',
  'pages.changeRequestSummaryList.update': 'Update',
  'pages.changeRequestSummaryList.delete': 'Delete',
  'pages.changeRequestSummaryList.createSummary': 'Create Change Request Summary',
  'pages.changeRequestSummaryList.updateSummaryTitle': 'Update Change Request Summary',
  'pages.changeRequestSummaryList.createSummaryTitle': 'Create Change Request Summary',
  'pages.changeRequestSummaryList.confirmDelete': 'Confirm Delete',
  'pages.changeRequestSummaryList.deleteConfirmMessage':
    'Are you sure you want to delete change request summary {{title}}? You can restore it from the Recycle Bin.',
  'pages.changeRequestSummaryList.confirm': 'Confirm',
  'pages.changeRequestSummaryList.cancel': 'Cancel',
  'pages.changeRequestSummaryList.versionLabel': 'Version',
  'pages.changeRequestSummaryList.versionRequired': 'Please enter version number',
  'pages.changeRequestSummaryList.versionPattern':
    'Version number can only contain numbers and dots',
  'pages.changeRequestSummaryList.versionPlaceholder':
    'Please enter numeric version number, e.g.: 0.0',
  'pages.changeRequestSummaryList.changeRequestsLabel': 'Included Change Requests',
  'pages.changeRequestSummaryList.changeRequestsRequired':
    'Please select at least one change request',
  'pages.changeRequestSummaryList.changeRequestsPlaceholder': 'Select change requests to include',
  'pages.changeRequestSummaryList.fieldRequired': '{{label}} is required',
  'pages.changeRequestSummaryList.unnamedChangeRequest': 'Unnamed Change Request',

  // Review result modal
  'pages.docEditor.reviewResultModal.title': 'Review Result',

  // Column configuration modal
  'pages.docEditor.columnConfig.title': 'Column Configuration',
  'pages.docEditor.columnConfig.columnTitle': 'Column Title',
  'pages.docEditor.columnConfig.relatedDoc': 'Related Document',
  'pages.docEditor.columnConfig.relatedDataField': 'Related Data Field',

  // Edit title modal
  'pages.docEditor.editTitleModal.title': 'Edit Title',
  'pages.docEditor.editTitleModal.label': 'Title',
  'pages.docEditor.editTitleModal.placeholder': 'Please enter title',

  // Configure relation modal
  'pages.docEditor.configureRelation.title': 'Configure Relationship',
  'pages.docEditor.configureRelation.requirementTab': 'Requirements',
  'pages.docEditor.configureRelation.requirementDoc': 'Requirement Document',
  'pages.docEditor.configureRelation.requirementID': 'Requirement ID',
  'pages.docEditor.configureRelation.architectureTab': 'Architecture',
  'pages.docEditor.configureRelation.architectureDoc': 'Architecture Document',
  'pages.docEditor.configureRelation.architectureSection': 'Architecture Section',

  // TraceDocPanel component
  'pages.docEditor.traceDocPanel.title': 'Upstream Work Products',
  'pages.docEditor.traceDocPanel.readOnlyHint': 'Read-only reference',
  'pages.docEditor.traceDocPanel.selectTraceDoc': 'Select Trace Document',
  'pages.docEditor.traceDocPanel.noTraceDoc': 'No trace documents',
  'pages.docEditor.traceDocPanel.loadingTraceDocs': 'Loading trace documents...',
  'pages.docEditor.traceDocPanel.refreshTraceDocs': 'Refresh Trace Documents',
  'pages.docEditor.traceDocPanel.configureTrace': 'Configure Trace Relationship',
  'pages.docEditor.traceDocPanel.traceRelationship': 'Trace Relationship',
  'pages.docEditor.traceDocPanel.sourceDocument': 'Source Document',
  'pages.docEditor.traceDocPanel.targetDocument': 'Target Document',
  'pages.docEditor.traceDocPanel.openInNewPage': 'Open in New Page',
  'pages.docEditor.traceDocPanel.columnSettings': 'Default Column Display Settings',
  'pages.docEditor.traceDocPanel.columnSettingsTitle': 'Default Column Display Settings',
  'pages.docEditor.traceDocPanel.selectColumnsForDoc':
    'Select default columns to display for document "{{title}}":',
  'pages.docEditor.traceDocPanel.selectAll': 'Select All',

  // User registration and authentication
  'pages.register.passwordMismatch': 'The two passwords entered do not match!',
  'pages.register.success': 'Registration successful!',
  'pages.register.failed': 'Registration failed!',
  'pages.register.failedRetry': 'Registration failed, please try again!',
  'pages.register.submit': 'Register',
  'pages.register.email': 'Email',
  'pages.register.emailRequired': 'Please enter email!',
  'pages.register.emailInvalid': 'Please enter a valid email address!',
  'pages.register.name': 'Name',
  'pages.register.nameRequired': 'Please enter name!',
  'pages.register.password': 'Password',
  'pages.register.passwordRequired': 'Please enter password!',
  'pages.register.passwordMinLength': 'Password must be at least 6 characters!',
  'pages.register.confirmPassword': 'Confirm Password',
  'pages.register.confirmPasswordRequired': 'Please confirm password!',
  'pages.register.backToLogin': 'Back to Login',

  // Forgot password
  'pages.forgotPassword.success': 'Password reset link has been sent to your email!',
  'pages.forgotPassword.failed': 'Send failed, please try again!',
  'pages.forgotPassword.submit': 'Send Reset Link',
  'pages.forgotPassword.emailPlaceholder': 'Please enter your registered email',

  // ProcessDocs page
  'pages.processDocs.fileName': 'File Name',
  'pages.processDocs.processName': 'Process Name',
  'pages.processDocs.version': 'Version',
  'pages.processDocs.status': 'Status',
  'pages.processDocs.updateTime': 'Update Time',
  'pages.processDocs.actions': 'Actions',
  'pages.processDocs.view': 'View',
  'pages.processDocs.search': 'Search',
  'pages.processDocs.searchPlaceholder': 'Enter file name to search',
  'pages.processDocs.title': 'Process Documents List',
  'pages.processDocs.statusDraft': 'Draft',
  'pages.processDocs.statusDraftLocked': 'Draft Locked',
  'pages.processDocs.statusReview': 'Under Review',
  'pages.processDocs.statusReviewPassed': 'Review Passed',
  'pages.processDocs.statusAuditPassed': 'Audit Passed',
  'pages.processDocs.statusApproved': 'Approved',
  'pages.processDocs.statusControlled': 'Controlled',
  'pages.processDocs.statusPublished': 'Published',
  'pages.processDocs.statusObsolete': 'Obsolete',

  // DocEditor components
  'pages.docEditor.changeImplementationReport': 'Change Implementation Statistics Report',
  'pages.docEditor.monthlyChangeStats': 'Monthly Change Statistics',
  'pages.docEditor.noImage': 'No Image',
  'pages.docEditor.noReviewInfo': 'No review information found',
  'pages.docEditor.selectTraceItems': 'Select trace items for current node',
  'pages.docEditor.editRequirementDesc': 'Edit Requirement Description',
  'pages.docEditor.testCaseTotal': 'Total Test Cases',
  'pages.docEditor.passedTests': 'Passed Tests',
  'pages.docEditor.failedTests': 'Failed Tests',
  'pages.docEditor.notExecutedTests': 'Not Executed Tests',
  'pages.docEditor.imagePreview': 'Image Preview',
  'pages.docEditor.traceItemChanged': 'This trace item has been changed',
  'pages.docEditor.copy': 'Copy',
  'pages.docEditor.traceConfigured': 'Trace configured',
  'pages.docEditor.confirmDelete': 'Confirm Delete',
  'pages.docEditor.addNewNode': 'Add New Node',
  'pages.docEditor.editNodeTitle': 'Edit Node Title',
  'pages.docEditor.configureTraceRelation': 'Configure Trace Relationship',
  'pages.docEditor.appendTraceItems': 'Append trace',
  'pages.docEditor.appendTraceItemsTip':
    'Append the checked upstream references to the end of this chapter, good for bulk linking',
  'pages.docEditor.insertUpstreamTrace': 'Insert upstream item',
  'pages.docEditor.insertUpstreamTraceTip':
    'Insert a reference to an upstream process document at the cursor, even mid-sentence',
  'pages.docEditor.insertUpstreamTraceDisabled':
    'No upstream document configured for this process yet',
  'pages.docEditor.insertSelfTrace': 'Insert item from this doc',
  'pages.docEditor.insertSelfTraceTip':
    'Insert a reference to another chapter (paragraph / table row) of this document at the cursor',
  'pages.docEditor.traceDrawerDragTip':
    'Drag the title bar to move, drag the bottom-right corner to resize',
  'pages.docEditor.traceDrawerDragHint': 'Draggable',
  'pages.docEditor.selfTraceSource.title': 'This document (internal trace)',
  'pages.docEditor.selfTraceSource.badge': 'Internal',
  'pages.docEditor.selfTraceSource.hint':
    'Check paragraphs or table rows from other chapters of this document to reference them here; uncheck removes them from the body.',
  'pages.docEditor.selfTraceSource.noColumnHint':
    '"Select trace items" has not been used in the traceability matrix of process {{process}} yet, so all {{count}} items are shown for now. Pick the items to be traced there first; only the checked ones will remain here.',
  'pages.docEditor.pleaseSelect': 'Please select',
  'pages.docEditor.enterNodeTitle': 'Please enter node title',
  'pages.docEditor.selectTraceItemsPlaceholder': 'Please select trace items',
  'pages.docEditor.nodeTitle': 'Node Title',
  'pages.docEditor.selectTraceItemsLabel': 'Select Trace Items',

  // DocEditor roles
  'pages.docEditor.role.author': 'Author',
  'pages.docEditor.role.reviewer': 'Review Group',
  'pages.docEditor.role.auditor': 'Auditor',
  'pages.docEditor.role.approver': 'Approver',

  // ReviewPanel review panel
  'pages.docEditor.reviewPanel.title': 'Review Report',
  'pages.docEditor.reviewPanel.changeFlowTitle': 'Change Process',
  'pages.docEditor.reviewPanel.projectManagerTitle': 'Project Manager',
  'pages.docEditor.reviewPanel.ccbLeaderTitle': 'CCB Leader',
  'pages.docEditor.reviewPanel.verifierTitle': 'Verifier',
  'pages.docEditor.reviewPanel.confirmerTitle': 'Confirmer',
  'pages.docEditor.reviewPanel.currentRole': 'Current Role:',
  'pages.docEditor.reviewPanel.reviewer': 'Review Group',
  'pages.docEditor.reviewPanel.auditor': 'Auditor',
  'pages.docEditor.reviewPanel.approver': 'Approver',
  'pages.docEditor.reviewPanel.me': '(Me)',
  'pages.docEditor.reviewPanel.statusApproved': 'Approved',
  'pages.docEditor.reviewPanel.statusConditional': 'Conditionally Approved',
  'pages.docEditor.reviewPanel.statusRejected': 'Rejected',
  'pages.docEditor.reviewPanel.commentIsProblem': 'Problem',
  'pages.docEditor.reviewPanel.commentNotProblem': 'Not a Problem',
  'pages.docEditor.reviewPanel.statusPending': 'Pending Review',
  'pages.docEditor.reviewPanel.statusPendingAudit': 'Pending Audit',
  'pages.docEditor.reviewPanel.statusPendingApproval': 'Pending Approval',
  'pages.docEditor.reviewPanel.reviewComments': 'Review Comments:',
  'pages.docEditor.reviewPanel.inputSubject': 'Please enter subject',
  'pages.docEditor.reviewPanel.inputSubjectRequired': 'Please enter subject',
  'pages.docEditor.reviewPanel.subject': 'Subject',
  'pages.docEditor.reviewPanel.severity': 'Severity',
  'pages.docEditor.reviewPanel.priority': 'Priority',
  'pages.docEditor.reviewPanel.selectSeverity': 'Please select severity',
  'pages.docEditor.reviewPanel.selectPriority': 'Please select priority',
  'pages.docEditor.reviewPanel.severityRequired': 'Please select severity',
  'pages.docEditor.reviewPanel.priorityRequired': 'Please select priority',
  'pages.docEditor.reviewPanel.inputComment': 'Please enter review comment',
  'pages.docEditor.reviewPanel.addComment': 'Add Comment',
  'pages.docEditor.reviewPanel.convertToDraft': 'Return to the initiator',
  'pages.docEditor.reviewPanel.convertToDraftConfirm': 'Revert this document to draft?',
  'pages.docEditor.reviewPanel.convertToDraftConfirmDesc':
    'The document will be returned to a draft state.',
  'pages.docEditor.reviewPanel.convertToDraftSuccess': 'Document reverted to draft',
  'pages.docEditor.reviewPanel.convertToDraftFailed': 'Failed to revert to draft',
  'pages.docEditor.reviewPanel.endReview': 'Finish review',
  'pages.docEditor.reviewPanel.endReviewConfirm': 'Finish this review?',
  'pages.docEditor.reviewPanel.endReviewSuccess': 'Review finished',
  'pages.docEditor.reviewPanel.endReviewFailed': 'Failed to finish review',
  'pages.docEditor.reviewPanel.save': 'Save',
  'pages.docEditor.reviewPanel.cancel': 'Cancel',
  'pages.docEditor.reviewPanel.confirmDelete': 'Are you sure to delete this review comment?',
  'pages.docEditor.reviewPanel.approve': 'Approve',
  'pages.docEditor.reviewPanel.reject': 'Reject',
  'pages.docEditor.reviewPanel.waitingForReviewers':
    'Waiting for the review group to approve before audit',
  'pages.docEditor.reviewPanel.waitingForAuditor':
    'Waiting for the auditor to approve before approval',
  'pages.docEditor.reviewPanel.documentInfo': 'Document Information',
  'pages.docEditor.reviewPanel.documentCode': 'Document Code:',
  'pages.docEditor.reviewPanel.documentTitle': 'Document Title:',
  'pages.docEditor.reviewPanel.version': 'Version:',
  'pages.docEditor.reviewPanel.status': 'Status:',
  'pages.docEditor.reviewPanel.inputCommentRequired': 'Please enter review comment',
  'pages.docEditor.reviewPanel.commentAddSuccess': 'Review comment added',
  'pages.docEditor.reviewPanel.commentAddFailed': 'Failed to add review comment',
  'pages.docEditor.reviewPanel.commentUpdateSuccess': 'Review comment updated',
  'pages.docEditor.reviewPanel.commentUpdateFailed': 'Failed to update review comment',
  'pages.docEditor.reviewPanel.commentDeleteSuccess': 'Review comment deleted',
  'pages.docEditor.reviewPanel.commentDeleteFailed': 'Failed to delete review comment',
  'pages.docEditor.reviewPanel.commentRequired': 'Please enter review comment',
  'pages.docEditor.reviewPanel.statusUpdateSuccess': 'Review approved',
  'pages.docEditor.reviewPanel.statusRejectSuccess': 'Review rejected',
  'pages.docEditor.reviewPanel.statusUpdateFailed': 'Failed to submit review result',
  'pages.docEditor.reviewPanel.loadCommentsFailed': 'Failed to load review comments',
  'pages.docEditor.reviewPanel.reviewersTitle': 'Review Group',
  'pages.docEditor.reviewPanel.reviewLeaderTitle': 'Review Leader',
  'pages.docEditor.reviewPanel.auditorTitle': 'Auditor',
  'pages.docEditor.reviewPanel.approverTitle': 'Approver',
  'pages.docEditor.reviewPanel.returnToLabel': 'Return to',
  'pages.docEditor.reviewPanel.returnToOwner': 'Owner',
  'pages.docEditor.reviewPanel.returnToReviewLeader': 'Review Leader',
  'pages.docEditor.reviewPanel.returnToAuditor': 'Auditor',
  'pages.docEditor.reviewPanel.returnToOwnerSuccess':
    'Returned to owner and created version V{{version}}',
  'pages.docEditor.reviewPanel.upgradeSuccess':
    'Approved current version and created controlled version V{{version}}',
  'pages.docEditor.reviewPanel.sourceVersion': 'Source version V{{version}}',
  'pages.docEditor.reviewPanel.historyTitle': 'Reviews History',
  'pages.docEditor.reviewPanel.historyEmpty': 'No review data',
  'pages.docEditor.reviewPanel.withdrawReview': 'Withdraw Review',
  'pages.docEditor.reviewPanel.withdrawChange': 'Withdraw Change',
  'pages.docEditor.reviewPanel.withdrawReviewConfirm': 'Withdraw this review?',
  'pages.docEditor.reviewPanel.withdrawChangeConfirm': 'Withdraw this change?',
  'pages.docEditor.reviewPanel.withdrawReviewDescription':
    'The document will return to draft. Review comments and problems created from them will be deleted.',
  'pages.docEditor.reviewPanel.withdrawChangeDescription':
    'The document will return to draft. Change comments and problems created from them will be deleted.',
  'pages.docEditor.reviewPanel.withdrawReviewSuccess': 'Review withdrawn',
  'pages.docEditor.reviewPanel.withdrawChangeSuccess': 'Change withdrawn',
  'pages.docEditor.reviewPanel.withdrawReviewFailed': 'Withdraw failed',

  // DocEditor problem panel
  'pages.docEditor.problemPanel.title': 'Problems',
  'pages.docEditor.problemPanel.create': 'Create Problem',
  'pages.docEditor.problemPanel.empty': 'No problems',
  'pages.docEditor.problemPanel.loadAll': 'All problems loaded',
  'pages.docEditor.problemPanel.sourceVersion': 'Source version V{{version}}',
  'pages.docEditor.problemPanel.sourceVersionLabel': 'Source Version',
  'pages.docEditor.problemPanel.detailTitle': 'Problem Details',
  'pages.docEditor.problemPanel.formTitle': 'Create Problem',
  'pages.docEditor.problemPanel.subjectRequired': 'Please enter subject',
  'pages.docEditor.problemPanel.subjectPlaceholder': 'Please enter subject',
  'pages.docEditor.problemPanel.descriptionRequired': 'Please enter problem description',
  'pages.docEditor.problemPanel.descriptionPlaceholder': 'Please enter problem description',
  'pages.docEditor.problemPanel.priorityRequired': 'Please select priority',
  'pages.docEditor.problemPanel.severityRequired': 'Please select severity',
  'pages.docEditor.problemPanel.processDocument': 'Process and Document',
  'pages.docEditor.problemPanel.processDocumentRequired': 'Please select process and document',
  'pages.docEditor.problemPanel.processDocumentPlaceholder': 'Please select process and document',
  'pages.docEditor.problemPanel.createSuccess': 'Created successfully',
  'pages.docEditor.problemPanel.createFailed': 'Failed to create',
  'pages.docEditor.problemPanel.edit': 'Edit',
  'pages.docEditor.problemPanel.editTitle': 'Edit Problem',
  'pages.docEditor.problemPanel.editSuccess': 'Updated successfully',
  'pages.docEditor.problemPanel.editFailed': 'Failed to update',
  'pages.docEditor.problemPanel.loadDetailFailed': 'Failed to load problem details',
  'pages.docEditor.problemPanel.loadOptionsFailed': 'Failed to load processes and documents',
  'pages.docEditor.problemPanel.assignTitle': 'Assign Problem',
  'pages.docEditor.problemPanel.assign': 'Assign',
  'pages.docEditor.problemPanel.handlerRequired': 'Please select a handler',
  'pages.docEditor.problemPanel.handlerPlaceholder': 'Please select a handler',
  'pages.docEditor.problemPanel.remarkPlaceholder': 'Please enter a remark',
  'pages.docEditor.problemPanel.assignSuccess': 'Assigned successfully',
  'pages.docEditor.problemPanel.assignFailed': 'Failed to assign',
  'pages.docEditor.problemPanel.loadHandlersFailed': 'Failed to load handlers',
  'pages.docEditor.problemPanel.activity': 'Activity',
  'pages.docEditor.problemPanel.historyEmpty': 'No activity',
  'pages.docEditor.problemPanel.historyChangeField': '{{field}}: ',
  'pages.docEditor.problemPanel.noModification': 'No Modification',
  'pages.docEditor.problemPanel.noModificationTitle': 'No Modification',
  'pages.docEditor.problemPanel.startProcessing': 'Start Processing',
  'pages.docEditor.problemPanel.startProcessingTitle': 'Start Processing',
  'pages.docEditor.problemPanel.submitReview': 'Submit Review',
  'pages.docEditor.problemPanel.submitReviewTitle': 'Submit Review',
  'pages.docEditor.problemPanel.reviewPass': 'Review Passed',
  'pages.docEditor.problemPanel.reviewFail': 'Review Failed',
  'pages.docEditor.problemPanel.reviewFailTitle': 'Review Failed',
  'pages.docEditor.problemPanel.closeProblem': 'Close Problem',
  'pages.docEditor.problemPanel.pass': 'Pass',
  'pages.docEditor.problemPanel.reject': 'Reject',
  'pages.docEditor.problemPanel.rejectTitle': 'Reject',
  'pages.docEditor.problemPanel.reopen': 'Reopen',
  'pages.docEditor.problemPanel.reopenTitle': 'Reopen',
  'pages.docEditor.problemPanel.isProblemRequired': 'Please select whether this is a problem',
  'pages.docEditor.problemPanel.plannedCompletionDateRequired':
    'Please select planned completion date',
  'pages.docEditor.problemPanel.plannedCompletionDatePlaceholder':
    'Please select planned completion date',
  'pages.docEditor.problemPanel.rootCauseRequired': 'Please enter root cause',
  'pages.docEditor.problemPanel.rootCausePlaceholder': 'Please enter root cause',
  'pages.docEditor.problemPanel.temporaryActionRequired': 'Please enter temporary action',
  'pages.docEditor.problemPanel.temporaryActionPlaceholder': 'Please enter temporary action',
  'pages.docEditor.problemPanel.solutionRequired': 'Please enter solution',
  'pages.docEditor.problemPanel.solutionPlaceholder': 'Please enter solution',
  'pages.docEditor.problemPanel.workHoursRequired': 'Please enter work hours',
  'pages.docEditor.problemPanel.workHoursPlaceholder': 'Please enter work hours',
  'pages.docEditor.problemPanel.resolutionDocumentPlaceholder':
    'Please select a resolution version',
  'pages.docEditor.problemPanel.remarkRequired': 'Please enter a remark',
  'pages.docEditor.problemPanel.confirmReviewPass': 'Confirm review passed?',
  'pages.docEditor.problemPanel.confirmClose': 'Confirm closing this problem?',
  'pages.docEditor.problemPanel.delete': 'Delete',
  'pages.docEditor.problemPanel.confirmDelete': 'Confirm deleting this problem?',
  'pages.docEditor.problemPanel.deleteSuccess': 'Deleted successfully',
  'pages.docEditor.problemPanel.deleteFailed': 'Failed to delete',
  'pages.docEditor.problemPanel.actionSuccess': 'Operation succeeded',
  'pages.docEditor.problemPanel.actionFailed': 'Operation failed',
  'pages.docEditor.problemPanel.relatedCasePlaceholder': 'Please enter related case',
  'pages.docEditor.problemPanel.similarProblemPlaceholder': 'Click to select a linked problem',
  'pages.docEditor.problemPanel.selectSimilarProblem': 'Select Linked Problem',
  'pages.docEditor.problemPanel.similarProblemRequired': 'Please select a problem',
  'pages.docEditor.problemPanel.loadSimilarProblemsFailed': 'Failed to load problems',
  'pages.docEditor.problemPanel.uploadAttachment': 'Select File',
  'pages.docEditor.problemPanel.downloadAttachmentFailed': 'Failed to download attachment',

  // DocEditor review result modal
  'pages.docEditor.reviewResultModal.noComment': 'No review comment',

  // DocEditor document tree actions
  'pages.docEditor.addSameLevel': 'Add Same Level',
  'pages.docEditor.addChildLevel': 'Add Child Level',
  'pages.docEditor.upgradeNode': 'Upgrade Node',
  'pages.docEditor.downgradeNode': 'Downgrade Node',
  'pages.docEditor.delete': 'Delete',
  'pages.docEditor.unknown': 'Unknown',
  'pages.docEditor.aiGeneratedContent':
    'Based on your request "{{prompt}}", AI generated content will be displayed here.',

  // ExcelTable error messages
  'pages.excelTable.readFileFailed': 'Failed to read file',
  'pages.excelTable.noValidSheets': 'No valid worksheets found in Excel file',
  'pages.excelTable.noValidData': 'No valid table data found',
  'pages.excelTable.importFailed': 'Failed to import Excel, please check file format',
  'pages.excelTable.getTraceDataFailed': 'Failed to get trace data',

  // DocumentTree component
  'pages.documentTree.confirmDeleteTitle': 'Confirm Delete',
  'pages.documentTree.confirmDeleteContent':
    'Are you sure you want to delete this node and all its child nodes? This operation cannot be undone.',
  'pages.documentTree.addNewNodeTitle': 'Add New Node',
  'pages.documentTree.nodeTitle': 'Node Title',
  'pages.documentTree.nodeTitleRequired': 'Please enter node title',
  'pages.documentTree.nodeTitlePlaceholder': 'Please enter node title',
  'pages.documentTree.addAsChildNode': 'New node will be added as a child node of the current node',
  'pages.documentTree.addAsSiblingNode': 'New node will be added after the current node',
  'pages.documentTree.editNodeTitleTitle': 'Edit Node Title',
  'pages.documentTree.configureTraceTitle': 'Configure Trace Relationship',
  'pages.documentTree.configureTraceDescription': 'Select trace items for the current node',
  'pages.documentTree.nodeLabel': 'Node',
  'pages.documentTree.selectTraceItems': 'Select Trace Items',
  'pages.documentTree.selectTraceItemsPlaceholder': 'Please select trace items',
  'pages.documentTree.loading': 'Loading...',
  'pages.documentTree.return': 'Return',
  'pages.documentTree.saveAndClose': 'Save and Close',

  // Notifications page
  'pages.notifications.deleteRead': 'Delete Read',
  'pages.notifications.confirmDeleteTitle': 'Confirm Delete',
  'pages.notifications.confirmDeleteContent':
    'This will permanently delete all read messages and cannot be undone. Continue?',
  'pages.notifications.deleteReadMessages': 'Delete Read Messages',
  'pages.notifications.cancel': 'Cancel',
  'pages.notifications.deleteSuccess': 'Deleted successfully',
  'pages.notifications.deleteFailed': 'Delete failed',
  'pages.notifications.getListFailed': 'Failed to get notification list',
  'pages.notifications.markedAsRead': 'Marked as read',
  'pages.notifications.markReadFailed': 'Failed to mark as read',
  'pages.notifications.markAsRead': 'Mark as Read',
  'pages.notifications.read': 'Read',
  'pages.notifications.unread': 'Unread',
  'pages.notifications.total': 'Total {{total}} items',

  // Problem resolution
  'pages.problemResolution.index': 'No.',
  'pages.problemResolution.code': 'Problem Code',
  'pages.problemResolution.comments': 'Comments',
  'pages.problemResolution.commentsEmpty': 'No comments',
  'pages.problemResolution.commentPlaceholder': 'Enter a comment',
  'pages.problemResolution.commentRequired': 'Please enter comment content',
  'pages.problemResolution.commentAddSuccess': 'Comment added',
  'pages.problemResolution.commentAddFailed': 'Failed to add comment',
  'pages.problemResolution.process': 'Process',
  'pages.problemResolution.document': 'Document',
  'pages.problemResolution.subject': 'Subject',
  'pages.problemResolution.description': 'Description',
  'pages.problemResolution.reporter': 'Reporter',
  'pages.problemResolution.discoverySource': 'Problem Source',
  'pages.problemResolution.createdAt': 'Created At',
  'pages.problemResolution.updatedAt': 'Updated At',
  'pages.problemResolution.severity': 'Severity',
  'pages.problemResolution.priority': 'Priority',
  'pages.problemResolution.rootCause': 'Root Cause',
  'pages.problemResolution.status': 'Status',
  'pages.problemResolution.currentHandler': 'Current Handler',
  'pages.problemResolution.svv1Owner': 'Verifier',
  'pages.problemResolution.verifiedAt': 'Verified At',
  'pages.problemResolution.svv2Owner': 'Affirmant',
  'pages.problemResolution.confirmedAt': 'Confirmed At',
  'pages.problemResolution.owner': 'Owner',
  'pages.problemResolution.handler': 'Handler',
  'pages.problemResolution.isProblem': 'Is Problem',
  'pages.problemResolution.isProblemYes': 'Yes',
  'pages.problemResolution.isProblemNo': 'No',
  'pages.problemResolution.temporaryAction': 'Temporary Action',
  'pages.problemResolution.solution': 'Solution',
  'pages.problemResolution.plannedCompletionDate': 'Planned Completion Date',
  'pages.problemResolution.actualCompletionDate': 'Actual Completion Date',
  'pages.problemResolution.workHours': 'Work Hours',
  'pages.problemResolution.resolutionDocument': 'Resolution Version',
  'pages.problemResolution.publishedAt': 'Published At',
  'pages.problemResolution.remark': 'Remark',
  'pages.problemResolution.relatedCase': 'Related Case',
  'pages.problemResolution.similarProblem': 'Linked Problem',
  'pages.problemResolution.attachment': 'Attachment',
  'pages.problemResolution.searchPlaceholder': 'Search by subject or description',
  'pages.problemResolution.actions': 'Actions',
  'pages.problemResolution.delete': 'Delete',
  'pages.problemResolution.confirmDelete': 'Confirm Delete',
  'pages.problemResolution.confirmDeleteContent': 'Are you sure you want to delete this problem?',
  'pages.problemResolution.deleteSuccess': 'Deleted successfully',
  'pages.problemResolution.deleteFailed': 'Failed to delete',
  'pages.problemResolution.createTitle': 'Create Problem',
  'pages.problemResolution.createSuccess': 'Created successfully',
  'pages.problemResolution.createFailed': 'Failed to create',
  'pages.problemResolution.subjectRequired': 'Please enter subject',
  'pages.problemResolution.subjectPlaceholder': 'Please enter subject',
  'pages.problemResolution.descriptionRequired': 'Please enter description',
  'pages.problemResolution.descriptionPlaceholder': 'Please enter description',
  'pages.problemResolution.severityRequired': 'Please select severity',
  'pages.problemResolution.priorityRequired': 'Please select priority',
  'pages.problemResolution.processDocument': 'Process and Document',
  'pages.problemResolution.processDocumentRequired': 'Please select process and document',
  'pages.problemResolution.processDocumentPlaceholder': 'Please select process and document',
  'pages.problemResolution.discoverySourceRequired': 'Please select problem source',
  'pages.problemResolution.remarkPlaceholder': 'Please enter remark',
  'pages.problemResolution.loadOptionsFailed': 'Failed to load processes and documents',
  'pages.problemResolution.export': 'Export',
  'pages.problemResolution.exportWithCount': 'Export ({{count}})',
  'pages.problemResolution.exportEmpty': 'Please select problems to export',
  'pages.problemResolution.exportSuccess': 'Exported successfully',
  'pages.problemResolution.exportFailed': 'Failed to export',
  'pages.problemResolution.exportFileName': 'Problem List',

  // Quality assurance checklist
  'pages.qualityAssurance.index': 'No.',
  'pages.qualityAssurance.criteria': 'Evaluation Criteria',
  'pages.qualityAssurance.hasDeviation': 'Deviation',
  'pages.qualityAssurance.hasDeviationYes': 'Yes',
  'pages.qualityAssurance.hasDeviationNo': 'No',
  'pages.qualityAssurance.subject': 'Subject',
  'pages.qualityAssurance.description': 'Problem Description',
  'pages.qualityAssurance.severity': 'Severity',
  'pages.qualityAssurance.priority': 'Priority',
  'pages.qualityAssurance.status': 'Status',
  'pages.qualityAssurance.document': 'Document',
  'pages.qualityAssurance.addFinding': 'Log QA Finding',
  'pages.qualityAssurance.createTitle': 'Log QA Finding',
  'pages.qualityAssurance.editTitle': 'Edit QA Finding',
  'pages.qualityAssurance.createSuccess': 'Created successfully',
  'pages.qualityAssurance.createFailed': 'Failed to create',
  'pages.qualityAssurance.edit': 'Edit',
  'pages.qualityAssurance.editSuccess': 'Updated successfully',
  'pages.qualityAssurance.editFailed': 'Failed to update',
  'pages.qualityAssurance.criteriaRequired': 'Please enter evaluation criteria',
  'pages.qualityAssurance.criteriaPlaceholder': 'Please enter evaluation criteria',
  'pages.qualityAssurance.hasDeviationRequired': 'Please select whether there is a deviation',
  'pages.qualityAssurance.subjectRequired': 'Please enter subject',
  'pages.qualityAssurance.subjectPlaceholder': 'Please enter subject',
  'pages.qualityAssurance.descriptionRequired': 'Please enter problem description',
  'pages.qualityAssurance.descriptionPlaceholder': 'Please enter problem description',
  'pages.qualityAssurance.severityRequired': 'Please select severity',
  'pages.qualityAssurance.priorityRequired': 'Please select priority',
  'pages.qualityAssurance.documentRequired': 'Please select a document',
  'pages.qualityAssurance.selectDocument':
    'Please select a work product or planning document of the current process',
  'pages.qualityAssurance.getDocumentsFailed': 'Failed to get documents',
  'pages.qualityAssurance.searchPlaceholder': 'Search by criteria, subject or description',
  'pages.qualityAssurance.actions': 'Actions',
  'pages.qualityAssurance.delete': 'Delete',
  'pages.qualityAssurance.confirmDelete': 'Confirm Delete',
  'pages.qualityAssurance.confirmDeleteContent':
    'Are you sure you want to delete this checklist item?',
  'pages.qualityAssurance.deleteSuccess': 'Deleted successfully',
  'pages.qualityAssurance.deleteFailed': 'Failed to delete',

  // Quality assurance - checklist execution
  'pages.qualityAssurance.tabExecution': 'Checklist Execution',
  'pages.qualityAssurance.tabFindings': 'Findings',
  'pages.qualityAssurance.tabArchive': 'External Checklists',
  'pages.qualityAssurance.tabQaRecord': 'QA Records',
  'pages.qualityAssurance.tabNonconformity': 'QA Nonconformity List',
  'pages.qaNonconformity.add': 'Add Nonconformity',
  'pages.qaNonconformity.addTitle': 'Add Nonconformity',
  'pages.qaNonconformity.editTitle': 'Edit Nonconformity',
  'pages.qaNonconformity.addSuccess': 'Nonconformity added',
  'pages.qaNonconformity.saveSuccess': 'Nonconformity saved',
  'pages.qaNonconformity.saveFailed': 'Failed to save',
  'pages.qaNonconformity.deleteSuccess': 'Nonconformity deleted',
  'pages.qaNonconformity.deleteFailed': 'Failed to delete',
  'pages.qaNonconformity.deleteConfirm': 'Delete this nonconformity?',
  'pages.qaNonconformity.deleteConfirmContent': 'This action cannot be undone.',
  'pages.qaNonconformity.edit': 'Edit',
  'pages.qaNonconformity.delete': 'Delete',
  'pages.qaNonconformity.save': 'Save',
  'pages.qaNonconformity.cancel': 'Cancel',
  'pages.qaNonconformity.actions': 'Actions',
  'pages.qaNonconformity.yes': 'Yes',
  'pages.qaNonconformity.no': 'No',
  'pages.qaNonconformity.code': 'NC ID',
  'pages.qaNonconformity.codeRequired': 'Please enter the nonconformity ID',
  'pages.qaNonconformity.stage': 'Stage',
  'pages.qaNonconformity.description': 'Description',
  'pages.qaNonconformity.descriptionRequired': 'Please enter the description',
  'pages.qaNonconformity.auditType': 'Audit Type',
  'pages.qaNonconformity.auditTypeRequired': 'Please select the audit type',
  'pages.qaNonconformity.auditType_PROCESS_AUDIT': 'Process Audit',
  'pages.qaNonconformity.auditType_WORK_PRODUCT_AUDIT': 'Work Product Audit',
  'pages.qaNonconformity.submitter': 'Raised By',
  'pages.qaNonconformity.submitDate': 'Raise Date',
  'pages.qaNonconformity.severity': 'Severity',
  'pages.qaNonconformity.stageProduct': 'Stage Process / Standard Work Product',
  'pages.qaNonconformity.problemSource': 'Problem Source',
  'pages.qaNonconformity.cause': 'Root Cause',
  'pages.qaNonconformity.correctiveAction': 'Corrective Action',
  'pages.qaNonconformity.submittedToQm': 'Submitted to Quality Mgmt Dept',
  'pages.qaNonconformity.submittedToTop': 'Submitted to Top Management',
  'pages.qaNonconformity.planResolveDate': 'Planned Resolution',
  'pages.qaNonconformity.actualResolveDate': 'Actual Resolution',
  'pages.qaNonconformity.resolver': 'Resolver',
  'pages.qaNonconformity.verifyAction': 'Verified Corrective Action',
  'pages.qaNonconformity.verifyDate': 'Verification Date',
  'pages.qaNonconformity.verifier': 'Verifier',

  // Quality assurance - external checklist archive (original file kept as-is, preview/download only)
  'pages.qualityAssurance.archiveHint':
    'External checklists are maintained offline by users. The system only archives and previews the original file; it does not feed execution stats, AI pre-check, or the problem register.',
  'pages.qualityAssurance.archiveUpload': 'Upload External Checklist',
  'pages.qualityAssurance.archiveUploadTitle': 'Upload External Checklist File',
  'pages.qualityAssurance.archiveName': 'Checklist Name',
  'pages.qualityAssurance.archiveNamePlaceholder': 'Defaults to the file name',
  'pages.qualityAssurance.archiveVersionPlaceholder': 'e.g. V2.1',
  'pages.qualityAssurance.archiveRemark': 'Remark',
  'pages.qualityAssurance.archiveRemarkPlaceholder': 'e.g. executed offline, see the last column',
  'pages.qualityAssurance.archiveHasRecord': 'Contains Records',
  'pages.qualityAssurance.archiveHasRecordHint':
    'Label only; never imported into the problem register',
  'pages.qualityAssurance.archivePickFile': 'Choose File',
  'pages.qualityAssurance.archiveFileHint':
    'Supports xlsx / xls / csv / docx / pdf / images / html / txt. The original file is kept as-is and can be previewed or downloaded.',
  'pages.qualityAssurance.archiveFileRequired': 'Please choose a file first',
  'pages.qualityAssurance.archiveMultiHint':
    'You can select multiple files at once; each becomes its own record.',
  'pages.qualityAssurance.archiveTitleBatchHint':
    'Ignored for batch uploads; each file keeps its own filename',
  'pages.qualityAssurance.archiveFileTitleListHint':
    'Each file below becomes its own record. The name is pre-filled from the filename; the version can be set per file:',
  'pages.qualityAssurance.archiveFileVersionPlaceholder': 'Version',
  'pages.qualityAssurance.uploadBatchSuccess': 'Uploaded {{count}} file(s)',
  'pages.qualityAssurance.qaReviewStage': 'Review stage',
  'pages.qualityAssurance.qaReviewStagePlaceholder':
    'e.g. kickoff / planning / design / verification',
  'pages.qualityAssurance.qaReviewTypePlaceholder':
    'e.g. process audit / work product audit / customer audit',
  'pages.qualityAssurance.filterTitlePlaceholder': 'Filter by name / filename',
  'pages.qualityAssurance.filterVersionPlaceholder': 'Filter by version',
  'pages.qualityAssurance.filterStagePlaceholder': 'Filter by review stage',
  'pages.qualityAssurance.filterUploaderPlaceholder': 'Filter by uploader',
  'pages.qualityAssurance.filterTimePlaceholder': 'Filter by upload time (e.g. 2026-10)',
  'pages.qualityAssurance.filterReset': 'Reset',
  'pages.qualityAssurance.filterClearAll': 'Clear all filters',
  'pages.qualityAssurance.filterResult': '{{filtered}} of {{total}} record(s)',
  'pages.qualityAssurance.archiveEmpty': 'No external checklist yet',
  'pages.qualityAssurance.archiveEmptyDesc':
    'Upload your own offline checklist (with or without records) as-is, then preview or download it here.',
  'pages.qualityAssurance.archiveFilterEmpty': 'No external checklist matches the filters',
  'pages.qualityAssurance.archiveFilterEmptyDesc':
    'Adjust or clear the column filters and try again.',
  'pages.qualityAssurance.archiveLoadFailed': 'Failed to load external checklists',
  'pages.qualityAssurance.archiveUploadSuccess': 'External checklist uploaded',
  'pages.qualityAssurance.archiveUploadFailed': 'Failed to upload external checklist',
  'pages.qualityAssurance.archiveDeleteConfirm': 'Delete this external checklist?',
  'pages.qualityAssurance.archiveDeleteConfirmContent':
    'The uploaded original file will be deleted too. This cannot be undone.',
  'pages.qualityAssurance.archiveDeleteSuccess': 'External checklist deleted',
  'pages.qualityAssurance.archiveDeleteFailed': 'Delete failed',
  'pages.qualityAssurance.archivePreview': 'Preview',
  'pages.qualityAssurance.archiveDownload': 'Download',
  'pages.qualityAssurance.archiveDelete': 'Delete',
  // Batch delete (shared by both archive folders; mixing kinds is rejected server-side)
  'pages.qualityAssurance.batchDelete': 'Batch Delete',
  'pages.qualityAssurance.batchSelected': '{{count}} selected',
  'pages.qualityAssurance.batchDeleteConfirmTitle': 'Delete {{count}} archive item(s)?',
  'pages.qualityAssurance.batchDeleteConfirmContent':
    'The uploaded original files will be deleted too. This cannot be undone.',
  'pages.qualityAssurance.batchDeleteMore': 'and {{count}} more',
  'pages.qualityAssurance.batchDeleteSuccess': '{{count}} archive item(s) deleted',
  'pages.qualityAssurance.batchDeleteFailed': 'Batch delete failed',
  'pages.qualityAssurance.archiveColumnTitle': 'Name',
  'pages.qualityAssurance.archiveColumnVersion': 'Version',
  'pages.qualityAssurance.archiveColumnRecord': 'Records',
  'pages.qualityAssurance.archiveColumnSize': 'Size',
  'pages.qualityAssurance.archiveColumnUploader': 'Uploaded By',
  'pages.qualityAssurance.archiveColumnTime': 'Uploaded At',
  'pages.qualityAssurance.archiveColumnActions': 'Actions',
  'pages.qualityAssurance.archiveRecordYes': 'With records',
  'pages.qualityAssurance.archiveRecordNo': 'No records',
  'pages.qualityAssurance.archivePreviewTitle': 'Preview: {{name}}',
  'pages.qualityAssurance.archivePreviewLoading': 'Loading the original file…',
  'pages.qualityAssurance.archivePreviewFailed': 'Failed to load preview',
  'pages.qualityAssurance.archivePreviewUnsupported':
    'Preview is not supported for this format. Please download it to view.',
  'pages.qualityAssurance.archiveSheet': 'Sheet',
  'pages.qualityAssurance.archivePreviewHint':
    'The original file is shown read-only and is never modified. Re-upload to replace it.',

  // QA records: records a QA engineer keeps while auditing each process.
  // Same behaviour and permissions as external checklists, only the wording differs.
  'pages.qualityAssurance.qaRecordHint':
    'QA records are produced by company QA staff while auditing each process. The system only archives and previews the original file; it takes no part in execution statistics, AI pre-checks or the problem log.',
  'pages.qualityAssurance.qaRecordUpload': 'Upload QA Record',
  'pages.qualityAssurance.qaRecordUploadTitle': 'Upload QA Record',
  'pages.qualityAssurance.qaRecordName': 'Record name',
  'pages.qualityAssurance.qaRecordColumnTitle': 'Record name',
  'pages.qualityAssurance.qaRecordRemarkPlaceholder':
    'e.g. Observations and deviations from the SYS.2 audit, Oct 2026',
  'pages.qualityAssurance.qaRecordEmpty': 'No QA record uploaded yet',
  'pages.qualityAssurance.qaRecordEmptyDesc':
    'Upload the QA records of this process (inspection, review, observations, ...) as-is and preview or download them here.',
  'pages.qualityAssurance.qaRecordFilterEmpty': 'No QA record matches the filters',
  'pages.qualityAssurance.qaRecordFilterEmptyDesc':
    'Adjust or clear the column filters and try again.',
  'pages.qualityAssurance.qaRecordLoadFailed': 'Failed to load QA records',
  'pages.qualityAssurance.qaRecordUploadSuccess': 'QA record uploaded',
  'pages.qualityAssurance.qaRecordUploadFailed': 'Failed to upload QA record',
  'pages.qualityAssurance.qaRecordDeleteConfirm': 'Delete this QA record?',
  'pages.qualityAssurance.qaRecordDeleteConfirmContent':
    'The uploaded original file will be deleted too. This cannot be undone.',
  'pages.qualityAssurance.qaRecordDeleteSuccess': 'QA record deleted',
  'pages.qualityAssurance.checklistUpload': 'Upload Checklist',
  'pages.qualityAssurance.checklistUpdate': 'Update Checklist',
  'pages.qualityAssurance.checklistDelete': 'Delete Checklist',
  'pages.qualityAssurance.checklistEmptyTitle': 'No quality checklist yet',
  'pages.qualityAssurance.checklistEmptyDesc':
    'Upload the quality checklist for this process to check and record item by item.',
  'pages.qualityAssurance.checklistMeta': '{{name}} ({{count}} items)',
  'pages.qualityAssurance.checklistVersion': 'Version',
  'pages.qualityAssurance.checklistSource': 'Source file',
  'pages.qualityAssurance.checklistProgress': 'Checked {{checked}}/{{total}}',
  'pages.qualityAssurance.checklistNonconform': '{{count}} nonconforming',
  'pages.qualityAssurance.checklistRechecked': '{{count}} rechecked',
  'pages.qualityAssurance.checklistGroupChecklist': 'Checklist (reference)',
  'pages.qualityAssurance.checklistGroupRecord': 'Check records',
  'pages.qualityAssurance.checklistSeq': 'No.',
  'pages.qualityAssurance.checklistClause': 'Clause',
  'pages.qualityAssurance.checklistItemText': 'Checklist Item',
  'pages.qualityAssurance.checklistDocument': 'Checked document',
  'pages.qualityAssurance.checklistVerdict': 'Result',
  'pages.qualityAssurance.checklistEvidence': 'Evidence',
  'pages.qualityAssurance.verdictConform': 'Conform',
  'pages.qualityAssurance.verdictNonconform': 'Nonconform',
  'pages.qualityAssurance.verdictNotApplicable': 'Not applicable',
  'pages.qualityAssurance.verdictPending': 'Not checked',
  'pages.qualityAssurance.recordAction': 'Record',
  'pages.qualityAssurance.recordEditAction': 'Edit',
  'pages.qualityAssurance.recordRecheckAction': 'Recheck',
  'pages.qualityAssurance.recordRound': 'Round {{n}}',
  'pages.qualityAssurance.recordCurrentRound': 'current',
  'pages.qualityAssurance.recordRoundTitle': 'Round {{n}} check record',
  'pages.qualityAssurance.recordTitle': 'Record Check Result',
  'pages.qualityAssurance.recordEditTitle': 'Edit Check Result',
  'pages.qualityAssurance.recordClear': 'Clear result',
  'pages.qualityAssurance.recordClearConfirm': 'Remove the check record of round {{n}}?',
  'pages.qualityAssurance.recordClearContent':
    'Only this round is removed. Its derived problem is deleted too, other rounds are kept.',
  'pages.qualityAssurance.recordClearSuccess': 'Check result cleared',
  'pages.qualityAssurance.recordSuccess': 'Check result saved',
  'pages.qualityAssurance.recordFailed': 'Failed to save check result',
  'pages.qualityAssurance.verdictRequired': 'Please select a result',
  'pages.qualityAssurance.recordEvidencePlaceholder': 'Record the basis or evidence location',
  'pages.qualityAssurance.recordHint':
    'Only SUP.1 process owners or members can upload checklists and record results',
  'pages.qualityAssurance.checklistLoadFailed': 'Failed to load checklist',
  'pages.qualityAssurance.uploadTitle': 'Upload Quality Checklist',
  'pages.qualityAssurance.uploadName': 'Checklist name',
  'pages.qualityAssurance.uploadNamePlaceholder': 'e.g. SYS.2 Quality Checklist',
  'pages.qualityAssurance.uploadVersionPlaceholder': 'e.g. 1.0',
  'pages.qualityAssurance.uploadPasteTab': 'Paste items',
  'pages.qualityAssurance.uploadFileTab': 'Upload file',
  'pages.qualityAssurance.uploadPastePlaceholder':
    'One item per line; paste the "clause + item text" columns copied from Excel, or use "clause|item text"',
  'pages.qualityAssurance.uploadPickFile': 'Choose file',
  'pages.qualityAssurance.uploadFileHint':
    'Supports .xlsx / .csv / .txt; detects clause number and item text automatically, skips the header row',
  'pages.qualityAssurance.uploadFileParsed': 'Parsed {{count}} items',
  'pages.qualityAssurance.uploadFileParseFailed': 'Failed to parse the file',
  'pages.qualityAssurance.uploadPreview': 'Item preview (editable)',
  'pages.qualityAssurance.uploadPreviewEmpty': 'Paste items or choose a file first',
  'pages.qualityAssurance.uploadRemoveRow': 'Remove',
  'pages.qualityAssurance.uploadAddRow': 'Add row',
  'pages.qualityAssurance.uploadSuccess': 'Checklist saved',
  'pages.qualityAssurance.uploadFailed': 'Failed to save checklist',
  'pages.qualityAssurance.deleteChecklistConfirm': 'Delete the whole checklist?',
  'pages.qualityAssurance.deleteChecklistConfirmContent':
    'Recorded results stay in the findings list but are unlinked from checklist items.',
  'pages.qualityAssurance.deleteChecklistSuccess': 'Checklist deleted',

  // Quality assurance - AI pre-check (P2)
  'pages.qualityAssurance.aiPrecheck': 'AI Pre-check',
  'pages.qualityAssurance.aiPrecheckTitle': 'AI pre-check: document vs checklist',
  'pages.qualityAssurance.aiPrecheckNotice':
    'AI only surfaces questionable items and never concludes "conform"; verify the conclusion and the verbatim evidence yourself before deciding.',
  'pages.qualityAssurance.aiPrecheckDocument': 'Document under review',
  'pages.qualityAssurance.aiPrecheckSelectDocument':
    'Select a work product or planning document of this process',
  'pages.qualityAssurance.aiPrecheckScope': 'Scope',
  'pages.qualityAssurance.aiPrecheckScopeAll': 'All items',
  'pages.qualityAssurance.aiPrecheckScopePending': 'Undecided items only',
  'pages.qualityAssurance.aiPrecheckRun': 'Start pre-check',
  'pages.qualityAssurance.aiPrecheckRerun': 'Run again',
  'pages.qualityAssurance.aiPrecheckRunning': 'Pre-checking in batches, please wait...',
  'pages.qualityAssurance.aiPrecheckResultCount': 'AI flagged {{count}} questionable item(s)',
  'pages.qualityAssurance.aiPrecheckTruncated': 'Document too long; only its beginning was checked',
  'pages.qualityAssurance.aiPrecheckEmpty':
    'AI flagged nothing. This only means no reportable issue was found, not that the items conform.',
  'pages.qualityAssurance.aiPrecheckEvidenceLabel': 'Verbatim evidence',
  'pages.qualityAssurance.aiPrecheckEvidenceEmpty': 'No verbatim evidence given',
  'pages.qualityAssurance.aiPrecheckReasonLabel': 'Why it looks questionable',
  'pages.qualityAssurance.aiPrecheckApply': 'Save suggestions',
  'pages.qualityAssurance.aiPrecheckApplyCount': 'Save suggestions ({{count}})',
  'pages.qualityAssurance.aiPrecheckApplied': '{{count}} AI suggestion(s) saved',
  'pages.qualityAssurance.aiPrecheckApplyHint':
    'Saved as suggestions only: the check result stays empty until a human decides.',
  'pages.qualityAssurance.aiPrecheckFailed': 'AI pre-check failed',
  'pages.qualityAssurance.aiPrecheckNoSelection': 'Select at least one flagged item',
  'pages.qualityAssurance.aiPrecheckSummary': 'AI flags {{count}}',
  'pages.qualityAssurance.aiVerdictSuspect': 'Suspected nonconform',
  'pages.qualityAssurance.aiVerdictUncertain': 'Cannot judge',
  'pages.qualityAssurance.aiIgnore': 'Ignore AI suggestion',
  'pages.qualityAssurance.aiIgnoreConfirm': 'Ignore the AI suggestion for this item?',
  'pages.qualityAssurance.aiIgnoreContent':
    'Only the AI suggestion is cleared; human decisions are untouched.',
  'pages.qualityAssurance.aiIgnored': 'AI suggestion ignored',
  'pages.qualityAssurance.recordAiNotice': 'AI pre-check: {{verdict}}',
  'pages.qualityAssurance.recordAiEvidenceHint':
    'AI verbatim evidence pre-filled; please verify before adopting',
  'pages.qualityAssurance.recordAiKeepHint':
    'The AI suggestion is kept as an audit record and does not affect this decision.',

  // Quality Assurance - Quality Report (SUP.1 former "Other" tab)
  'pages.qualityReport.tab': 'Quality Report',
  'pages.qualityReport.title': 'Quality Assurance Report',
  'pages.qualityReport.project': 'Project',
  'pages.qualityReport.generatedAt': 'Generated At',
  'pages.qualityReport.generatedBy': 'Generated By',
  'pages.qualityReport.scope': 'Scope',
  'pages.qualityReport.scopeValue': '{{total}} enabled processes',
  'pages.qualityReport.refresh': 'Refresh',
  'pages.qualityReport.export': 'Export Report',
  'pages.qualityReport.exportWord': 'Export Word Report',
  'pages.qualityReport.exportExcel': 'Export Excel',
  'pages.qualityReport.empty': 'No quality report data yet',
  'pages.qualityReport.exportSuccess': 'Report exported',
  'pages.qualityReport.exportFailed': 'Failed to export report',
  'pages.qualityReport.detailLoadFailed': 'Failed to load process check details',
  'pages.qualityReport.filePrefix': 'Quality-Assurance-Report',

  // Quality Report - KPI cards
  'pages.qualityReport.kpiTitle': 'Metric',
  'pages.qualityReport.kpiValue': 'Value',
  'pages.qualityReport.kpiCoverage': 'Process Coverage',
  'pages.qualityReport.coveredRatio': '{{covered}}/{{total}} processes',
  'pages.qualityReport.kpiItems': 'Checklist Items',
  'pages.qualityReport.unitItems': 'items',
  'pages.qualityReport.kpiCompletion': 'Check Completion',
  'pages.qualityReport.kpiNonconform': 'Non-conformities',
  'pages.qualityReport.kpiNonconformRate': 'Non-conformity rate {{rate}}%',
  'pages.qualityReport.kpiProblemClose': 'Problem Closure Rate',
  'pages.qualityReport.kpiOverdue': 'Overdue Problems',
  'pages.qualityReport.kpiOverdueHint': 'Needs attention',
  'pages.qualityReport.kpiRechecked': 'Re-checked Items',
  'pages.qualityReport.kpiAiSuspect': 'AI Suspects',

  // Quality Report - charts
  'pages.qualityReport.chartCompletion': 'Check Completion by Process',
  'pages.qualityReport.chartVerdict': 'Verdict Distribution',
  'pages.qualityReport.chartSeverity': 'Non-conformity by Severity',

  // Quality Report - verdicts
  'pages.qualityReport.verdictConform': 'Conform',
  'pages.qualityReport.verdictNonconform': 'Non-conform',
  'pages.qualityReport.verdictNotApplicable': 'Not applicable',
  'pages.qualityReport.verdictPending': 'Pending',

  // Quality Report - process summary table
  'pages.qualityReport.sectionProcesses': 'Check Execution by Process',
  'pages.qualityReport.detailHint': 'Click a row to view the process check details',
  'pages.qualityReport.colProcess': 'Process',
  'pages.qualityReport.colOwner': 'Owner',
  'pages.qualityReport.colChecklist': 'Checklist',
  'pages.qualityReport.noChecklist': 'No checklist',
  'pages.qualityReport.colItems': 'Items',
  'pages.qualityReport.colChecked': 'Checked',
  'pages.qualityReport.colCompletion': 'Completion',
  'pages.qualityReport.colConform': 'Conform',
  'pages.qualityReport.colNonconform': 'Non-conform',
  'pages.qualityReport.colNotApplicable': 'N/A',
  'pages.qualityReport.colPending': 'Pending',
  'pages.qualityReport.colNonconformRate': 'Non-conform Rate',
  'pages.qualityReport.colProblemOpen': 'Open Problems',
  'pages.qualityReport.colProblemOverdue': 'Overdue',
  'pages.qualityReport.colArchive': 'Archived Checklists',
  'pages.qualityReport.totalRow': 'Total',

  // Quality Report - problem details
  'pages.qualityReport.problemTitle': 'Non-conformities / Problems',
  'pages.qualityReport.problemEmpty': 'No non-conformities',
  'pages.qualityReport.filterProcess': 'Filter by process',
  'pages.qualityReport.filterStatus': 'Filter by status',
  'pages.qualityReport.colCode': 'Code',
  'pages.qualityReport.colDocument': 'Document',
  'pages.qualityReport.colSubject': 'Subject',
  'pages.qualityReport.colDescription': 'Description',
  'pages.qualityReport.colSeverity': 'Severity',
  'pages.qualityReport.colPriority': 'Priority',
  'pages.qualityReport.colStatus': 'Status',
  'pages.qualityReport.colCreatedAt': 'Discovered',
  'pages.qualityReport.colPlanned': 'Planned',
  'pages.qualityReport.overdueYes': 'Overdue',

  // Quality Report - process detail drawer
  'pages.qualityReport.detailTitle': '{{process}} · Check Details',
  'pages.qualityReport.detailSummary':
    '{{total}} items · {{checked}} checked · {{rate}}% completion',
  'pages.qualityReport.detailEmpty': 'No quality checklist uploaded for this process',
  'pages.qualityReport.detailColSeq': 'No.',
  'pages.qualityReport.detailColClause': 'Clause',
  'pages.qualityReport.detailColText': 'Checklist Item',
  'pages.qualityReport.detailColVerdict': 'Verdict',
  'pages.qualityReport.detailColEvidence': 'Evidence',
  'pages.qualityReport.detailColProblem': 'Problem',

  // Quality Report - export sheets
  'pages.qualityReport.colVersion': 'Version',
  'pages.qualityReport.colFile': 'File Name',
  'pages.qualityReport.sheetOverview': 'Overview',
  'pages.qualityReport.sheetProcesses': 'Process Summary',
  'pages.qualityReport.sheetProblems': 'Problem Details',
  'pages.qualityReport.sheetArchives': 'Archived Checklists',

  // Recycle Bin
  'pages.recycleBin.documentsTab': 'Documents',
  'pages.recycleBin.attachmentsTab': 'Attachments',
  'pages.recycleBin.documentTitle': 'Document Name',
  'pages.recycleBin.documentCode': 'Document ID',
  'pages.recycleBin.version': 'Version',
  'pages.recycleBin.process': 'Process',
  'pages.recycleBin.fileName': 'Attachment Name',
  'pages.recycleBin.deletedBy': 'Deleted By',
  'pages.recycleBin.deletedAt': 'Deleted At',
  'pages.recycleBin.actions': 'Actions',
  'pages.recycleBin.restore': 'Restore',
  'pages.recycleBin.purge': 'Delete Permanently',
  'pages.recycleBin.cancel': 'Cancel',
  'pages.recycleBin.search': 'Search',
  'pages.recycleBin.searchDocuments': 'Search by name or document ID',
  'pages.recycleBin.searchAttachments': 'Search by attachment name',
  'pages.recycleBin.restoreSuccess': 'Restored successfully',
  'pages.recycleBin.restoreFailed': 'Failed to restore',
  'pages.recycleBin.purgeSuccess': 'Permanently deleted',
  'pages.recycleBin.purgeFailed': 'Failed to permanently delete',
  'pages.recycleBin.loadFailed': 'Failed to load recycle bin',
  'pages.recycleBin.confirmPurge': 'Confirm Permanent Delete',
  'pages.recycleBin.confirmPurgeDocument':
    'Are you sure you want to permanently delete document {{title}}? This cannot be undone.',
  'pages.recycleBin.confirmPurgeAttachment':
    'Are you sure you want to permanently delete attachment {{name}}? This cannot be undone.',
  'pages.docEditor.confirmDeleteAttachment': 'Delete Attachment',
  'pages.docEditor.confirmDeleteAttachmentContent':
    'Are you sure you want to delete attachment "{{name}}"? You can restore it from the Recycle Bin.',

  // ---- HARA: Hazard Analysis and Risk Assessment ----
  'pages.workProducts.hara': 'HARA',

  'pages.hara.tabItem': 'Item Definition',
  'pages.hara.tabFunctions': 'Functions',
  'pages.hara.tabFailureModes': 'Failure Modes',
  'pages.hara.tabScenarios': 'Operating Scenarios',
  'pages.hara.tabHazards': 'Hazard Analysis',
  'pages.hara.tabGoals': 'Safety Goals',

  'pages.hara.statHazard': 'Hazardous Events',
  'pages.hara.statGoal': 'Safety Goals',
  'pages.hara.statMaxAsil': 'Highest ASIL',
  'pages.hara.asilDistribution': 'ASIL Distribution',

  'pages.hara.save': 'Save',
  'pages.hara.cancel': 'Cancel',
  'pages.hara.delete': 'Delete',
  'pages.hara.export': 'Export Excel',
  'pages.hara.reload': 'Reload',
  'pages.hara.reset': 'Clear',
  'pages.hara.resetConfirm': 'Clear all HARA data? This cannot be undone.',
  'pages.hara.unsaved': 'You have unsaved changes',
  'pages.hara.saved': 'Saved',
  'pages.hara.saveFailed': 'Failed to save',
  'pages.hara.loadFailed': 'Failed to load HARA data',
  'pages.hara.required': 'Required',

  'pages.hara.colIndex': 'No.',
  'pages.hara.colCode': 'Code',
  'pages.hara.colName': 'Name',
  'pages.hara.colDescription': 'Description',
  // Each table names its own text column; scenarios keep the generic "Description".
  'pages.hara.functionDescription': 'Function description',
  'pages.hara.failureModeName': 'Failure mode',
  'pages.hara.colRemark': 'Remark',
  'pages.hara.colAction': 'Actions',
  'pages.hara.dimensionCount': '{{count}} entries',
  'pages.hara.emptyDimension':
    'No entries yet — use the button above, or paste straight into the grid',
  'pages.hara.sheetHint':
    'Click a cell to edit · Enter moves down · Tab moves right · Ctrl+V pastes a block',
  'pages.hara.deleteUsedTitle': 'This entry is referenced by the hazard table',
  'pages.hara.deleteUsedContent':
    '{{count}} hazardous events reference it. Deleting it turns those references stale. Continue?',
  'pages.hara.hazardDeleteConfirmTitle': 'Delete this hazardous event?',
  'pages.hara.hazardDeleteConfirmContent':
    '"{{label}}" cannot be recovered after deletion. Safety goals will be recalculated from the remaining hazards on next save.',
  'pages.hara.hazardDeleteConfirmContentNoLabel':
    'This cannot be recovered after deletion. Safety goals will be recalculated from the remaining hazards on next save.',
  'pages.hara.pasteDone': 'Pasted {{count}} cells',
  'pages.hara.pasteBadExposure': '{{count}} exposure values were not E0-E4 and were ignored',

  'pages.hara.batchImport': 'Batch import',
  'pages.hara.importSourcePaste': 'Paste text',
  'pages.hara.importSourceFile': 'Upload file',
  'pages.hara.importPasteHint':
    'Copy rows from Excel and paste them here (the first row may be a header)',
  'pages.hara.importFileHint':
    'Click or drag an xlsx / csv file here — only the first sheet is read',
  'pages.hara.importHasHeader': 'First row is a header',
  'pages.hara.importParsedRows': '{{count}} rows parsed',
  'pages.hara.importMapping': 'Column mapping',
  'pages.hara.importColumn': 'Col {{n}}',
  'pages.hara.importIgnore': 'Skip',
  'pages.hara.importPreview': 'Preview',
  'pages.hara.importPreviewTruncated': 'showing first 50 rows only',
  'pages.hara.importWillAdd': '{{count}} entries will be imported',
  'pages.hara.importNoRows': 'Nothing to import — check the column mapping',
  'pages.hara.importModeAppend': 'Append after existing entries',
  'pages.hara.importModeReplace': 'Replace all existing entries',
  'pages.hara.importConfirm': 'Import',
  'pages.hara.importDone': 'Imported {{count}} entries',
  'pages.hara.importReadFailed': 'Failed to read the file',
  'pages.hara.importIssueEmptyName':
    '{{count}} rows have no name — they cannot be picked in the hazard table',
  'pages.hara.importIssueDuplicate': '{{count}} rows duplicate an existing entry or each other',
  'pages.hara.importIssueExposure': '{{count}} exposure values were not E0-E4 and were ignored',
  'pages.hara.importIssueNote': 'These are hints only — import still proceeds when you confirm',
  'pages.hara.importWaiting': 'Paste text or upload a file to see the mapping and preview',

  'pages.hara.addFunction': 'Add Function',
  'pages.hara.addFailureMode': 'Add Failure Mode',
  'pages.hara.addScenario': 'Add Scenario',
  'pages.hara.addHazard': 'Add Hazardous Event',
  'pages.hara.hazardCount': '{{count}} hazardous events',
  'pages.hara.hazardFnDerived': 'Function is derived from the selected failure mode',
  'pages.hara.hazardFnNeedFm': 'Pick a failure mode first',
  'pages.hara.hazardFnNoFunction': 'This failure mode has no function assigned',
  'pages.hara.hazardFnMismatch':
    'Stored function reference differs from the failure mode owner — the failure mode is likely wrong',
  'pages.hara.hazardFnMismatchDetail': 'stored {{stored}} / expected {{derived}}',
  'pages.hara.hazardFnResyncHint':
    'Rewrite the stored function reference to the failure mode owner (hazard rows only; failure modes are untouched)',
  'pages.hara.hazardFnResync': 'Fix function refs ({{count}})',
  'pages.hara.hazardFnResynced': 'Fixed {{count}} function reference(s)',
  'pages.hara.locateInCross': 'Hazard ID',
  'pages.hara.locateInCrossNeedRefs':
    'Pick both a failure mode and a scenario before locating in the hazard identification table',
  'pages.hara.crossJumpHint':
    'Click to jump to the row in the main table (edit ASIL / S-E-C there)',
  'pages.hara.emptyHazard': 'No hazardous events yet',
  'pages.hara.emptyGoals':
    'No safety goals yet — they are generated once an ASIL above QM is rated',
  'pages.hara.colFailureCategory': 'Failure Category',
  'pages.hara.failureCategoryHint': 'e.g. unintended activation',
  'pages.hara.langHint': 'en',
  'pages.hara.categoryMigrated':
    '{{count}} failure mode categories were remapped to the seven FMEA classes; save to persist',
  'pages.hara.droppedBlankRows': 'Skipped {{count}} empty row(s); they were not saved',
  'pages.hara.conflictTitle': 'Data changed elsewhere',
  'pages.hara.conflictContent':
    'This HARA dataset was saved again after you opened the page. To avoid overwriting those changes, reload the latest data and redo your edits.',
  'pages.hara.conflictReload': 'Reload latest data',
  'pages.hara.conflictKeep': 'Keep my edits',
  'pages.hara.resetConfirmContent':
    '{{functions}} functions, {{modes}} failure modes and {{hazards}} hazards will be deleted. The previous version is archived automatically; ask an administrator to restore it if needed.',
  'pages.hara.fmGroup.omission': 'FM1 Omission',
  'pages.hara.fmGroup.commission': 'FM2 Commission',
  'pages.hara.fmGroup.timing': 'FM3 Timing',
  'pages.hara.fmGroup.value': 'FM4 Value',
  'pages.hara.cat.no_function': 'No function',
  'pages.hara.cat.no_function.desc':
    'Item becomes inoperable or fails suddenly; no function delivered when needed',
  'pages.hara.cat.no_function.example': 'Unable to apply the parking clamp force',
  'pages.hara.cat.degraded': 'Degraded function',
  'pages.hara.cat.degraded.desc': 'Function still delivered, but performance degrades over time',
  'pages.hara.cat.degraded.example':
    'Clamp force decays gradually after prolonged downhill braking',
  'pages.hara.cat.intermittent': 'Intermittent function',
  'pages.hara.cat.intermittent.desc': 'Operation starts, stops and restarts at random intervals',
  'pages.hara.cat.intermittent.example': 'Parking clamp engages and releases repeatedly at random',
  'pages.hara.cat.partial': 'Partial function',
  'pages.hara.cat.partial.desc':
    'Function achieved only partially; performance below the requirement',
  'pages.hara.cat.partial.example':
    'Only one-side actuator clamps; force is about half the design value',
  'pages.hara.cat.unintended': 'Unintended function',
  'pages.hara.cat.unintended.desc':
    'Function occurs when not needed: at the wrong time, in an unintended direction, with unequal performance, or latched on',
  'pages.hara.cat.unintended.example':
    'Clamps at highway speed without request; release request results in clamping',
  'pages.hara.cat.out_of_range': 'Function out of range',
  'pages.hara.cat.out_of_range.desc':
    'Output magnitude exceeds the acceptable upper or lower limit',
  'pages.hara.cat.out_of_range.example':
    'Clamp force above the upper limit locks the rear wheels; below the lower limit the vehicle rolls away',
  'pages.hara.cat.delayed': 'Function delayed',
  'pages.hara.cat.delayed.desc':
    'Occurs after an unintended time interval: too late, too early, or terminated prematurely',
  'pages.hara.cat.delayed.example':
    'Releases 500 ms too late; releases prematurely before the vehicle is stopped',
  'pages.hara.colCondition': 'Operating Condition',
  'pages.hara.conditionHint': 'e.g. highway driving, wet road, fully loaded',
  'pages.hara.colRoadType': 'Road Type',
  'pages.hara.roadTypeHint': 'e.g. motorway, urban road, car park ramp',
  'pages.hara.colTrafficDensity': 'Traffic Density',
  'pages.hara.trafficDensityHint': 'e.g. sparse, normal, congested',
  'pages.hara.colWeather': 'Weather · Lighting',
  'pages.hara.weatherHint': 'e.g. daytime clear, night, rain, fog',
  'pages.hara.colEgoState': 'Ego · Driver State',
  'pages.hara.egoStateHint': 'e.g. steady high speed; driver attentive',
  'pages.hara.colOperatingMode': 'Operating Mode',
  'pages.hara.operatingModeHint': 'e.g. driving, parking, hill start, degraded',
  'pages.hara.colExposureBasis': 'Exposure Basis',
  'pages.hara.exposureBasisHint': 'Pick the ISO 26262-3 Annex B scale',
  'pages.hara.colSeverityBasis': 'S Basis',
  'pages.hara.colExposureBasisHazard': 'E Basis',
  'pages.hara.colControllabilityBasis': 'C Basis',
  'pages.hara.colTargetMarket': 'Target Market',
  'pages.hara.targetMarketHint': 'e.g. China, EU',
  'pages.hara.colSource': 'Source / Rationale',
  'pages.hara.sourceHint': 'e.g. fleet data, accident statistics, expert assumption',
  'pages.hara.colExposureHint': 'Suggested Exposure',
  'pages.hara.exposureSuggest': 'suggest {{level}}',
  'pages.hara.exposureBasis.duration_gt10': 'Duration >10%',
  'pages.hara.exposureBasis.duration_1to10': 'Duration 1%–10%',
  'pages.hara.exposureBasis.duration_lt1': 'Duration <1%',
  'pages.hara.exposureBasis.frequency_almostEvery': 'Frequency almost every drive',
  'pages.hara.exposureBasis.frequency_monthly': 'Frequency ≥1 per month',
  'pages.hara.exposureBasis.frequency_fewPerYear': 'Frequency a few times per year',
  'pages.hara.exposureBasis.frequency_lessThanYearly': 'Frequency less than once per year',
  'pages.hara.groupIdentity': 'Scenario Identity',
  'pages.hara.groupElements': 'Scenario Elements (Conditions / Modes)',
  'pages.hara.groupExposure': 'Exposure Rating',
  'pages.hara.groupTrace': 'Traceability',
  'pages.hara.viewBasic': 'Compact',
  'pages.hara.viewFull': 'Full',
  'pages.hara.viewToggleHint':
    'Compact shows core fields only; Full expands scenario elements and the exposure basis',
  'pages.hara.pasteBadBasis': '{{count}} exposure basis values are not Annex B classes, ignored',
  'pages.hara.importIssueBasis': '{{count}} exposure basis values are not Annex B classes, ignored',
  'pages.hara.fillElements': 'Fill elements from text',
  'pages.hara.fillElementsHint':
    'Derive the empty element columns from the name / description / condition text using the controlled vocabulary. Only empty cells are filled; existing values are left untouched.',
  'pages.hara.undoFillElements': 'Undo fill',
  'pages.hara.tableEmptyActionHint':
    'The table is empty: add a row, import in bulk, or use “AI generate scenarios” first',
  'pages.hara.fillElementsDone':
    'Filled {{cells}} cells across {{rows}} scenarios (remember to save)',
  'pages.hara.fillElementsNone':
    'Nothing to fill: no new values recognised in the text, or all columns are already complete',
  'pages.hara.fillElementsUndone': 'Fill undone',
  'pages.hara.elementsGapCount': '{{count}} with incomplete elements',
  'pages.hara.elementsGapList':
    'These scenarios still have unfilled elements (use "Fill elements from text" to complete them)',

  // ---- HARA: operating scenarios AI (generate / compliance review, ISO 26262-3 6.4.2) ----
  'pages.hara.aiScenGenerate': 'AI generate scenarios',
  'pages.hara.aiScenReview': 'AI compliance review',
  'pages.hara.aiScenTitleGenerate': 'AI generate operating scenarios',
  'pages.hara.aiScenTitleReview': 'AI scenario compliance review',
  'pages.hara.aiScenContext':
    'Generated from the Item Definition · {{count}} scenarios currently defined',
  'pages.hara.aiScenNoE':
    'The AI will not assign an exposure rating (E): per ISO 26262-3 Annex B, E must be based on representative target-market data (frequency of occurrence or duration of exposure), which is not part of the Item Definition. It must be judged by the engineer from target-market data and signed off.',
  'pages.hara.aiScenRequirements':
    'Extra requirements, optional (leave empty to generate from the Item Definition and common knowledge)',
  'pages.hara.aiScenRequirementsReview':
    'Extra requirements, optional (e.g. focus on foreseeable misuse and system interactions)',
  'pages.hara.aiScenSubmitGenerate': 'Generate candidates',
  'pages.hara.aiScenSubmitReview': 'Start review',
  'pages.hara.aiScenRerun': 'Regenerate',
  'pages.hara.aiScenFindings': 'Review findings',
  'pages.hara.aiScenNoFindings': 'No issues found',
  'pages.hara.aiScenCandidates': 'Candidate scenarios (tick to append to the list)',
  'pages.hara.aiScenExcluded': 'Judged out of scope for this Item',
  'pages.hara.aiScenBasis': 'Based on Item Definition',
  'pages.hara.aiScenAdd': 'Add {{count}} selected',
  'pages.hara.aiScenAdded': 'Added {{count}} scenarios — remember to save',
  'pages.hara.aiScenNothingAdded': 'Nothing added: all selected scenarios already exist',
  'pages.hara.aiScenSkipped': 'Skipped {{count}} (same name already in the list)',
  'pages.hara.aiScenEmpty': 'The AI returned no usable result; refine the requirements and retry',
  'pages.hara.aiScenFailed': 'AI call failed, please try again later',
  'pages.hara.aiScenNoItems': 'No candidate scenarios generated',
  'pages.hara.aiScenReviewNote':
    'These are opinions only and will not change your scenario list; use "AI generate operating scenarios" to add items.',
  'pages.hara.aiScenType.missing_misuse': 'Misuse missing',
  'pages.hara.aiScenType.missing_interaction': 'Interaction missing',
  'pages.hara.aiScenType.mode_uncovered': 'Mode uncovered',
  'pages.hara.aiScenType.missing_elements': 'Elements missing',
  'pages.hara.aiScenType.missing_exposure_basis': 'No exposure basis',
  'pages.hara.aiScenType.exposure_without_market': 'No market data',
  'pages.hara.aiScenType.duplicate': 'Duplicate',
  'pages.hara.aiScenType.granularity': 'Granularity',
  'pages.hara.aiScenType.other': 'Other',

  // ---- HARA: per-function failure analysis (guidewords) ----
  'pages.hara.functionSearch': 'Search code or name',
  'pages.hara.allFailureModes': 'All failure modes',
  'pages.hara.unassignedFailureModes': 'Unassigned',
  'pages.hara.failureCoverageHint': '{{done}}/{{total}} functions analysed',
  'pages.hara.categoryCoverage': '{{done}}/{{total}} guidewords covered',
  'pages.hara.guideView': 'Guided',
  'pages.hara.sheetView': 'Sheet',
  'pages.hara.guideViewHint':
    'Walk through every guideword; mark not-applicable ones too — assessors will ask whether a blank cell was forgotten or judged',
  'pages.hara.failureDerive': 'Draft from categories',
  'pages.hara.guideKeyboardHint':
    'Press Enter to jump to the next pending category, Tab for the next row; click the box to mark not applicable',
  'pages.hara.focusNext': 'Go to next pending',
  'pages.hara.checkNaTip': 'Click to mark not applicable (a reason is required)',
  'pages.hara.checkNaUndoTip': 'Click to make it applicable again',
  'pages.hara.checkNaDisabledTip': 'Remove its failure modes before marking it not applicable',
  'pages.hara.naReasonTitle': 'Mark as not applicable',
  'pages.hara.naReasonHint':
    'The reason is exported into the failure matrix, so reviewers can tell "forgotten" from "assessed"',
  'pages.hara.naReasonPlaceholder': 'e.g. pure on/off output, no magnitude to exceed',
  'pages.hara.copyFromPrev': 'Copy previous function',
  'pages.hara.copyFromPrevTip':
    'Copy every failure mode written for {{code}}, then adapt them to this function',
  'pages.hara.copyFromPrevNone': 'No previous function to copy from',
  'pages.hara.copyFromPrevDone':
    'Copied {{count}} rows, skipped {{skipped}} categories already analysed here',
  'pages.hara.copyFromPrevNothing': '{{code}} has nothing new to copy here',
  'pages.hara.nextUnfinished': 'Next unfinished',
  'pages.hara.nextUnfinishedTip': 'Jump to the next function that is not finished',
  'pages.hara.nextUnfinishedNone': 'Every function is analysed',
  'pages.hara.allCategoriesDone': 'All {{total}} categories of {{code}} are covered',
  'pages.hara.confirm': 'OK',
  'pages.hara.failureDeriveTip':
    'Create one draft failure mode per guideword not yet analysed; analysed and excluded ones are skipped',
  'pages.hara.failureDeriveDone':
    'Created {{count}} drafts, skipped {{skipped}} already handled guidewords',
  'pages.hara.failureDeriveNothing': 'All {{total}} guidewords are already handled',
  'pages.hara.failureAnalyzed': '{{count}} analysed',
  'pages.hara.failurePending': 'Pending',
  'pages.hara.failureNa': 'N/A',
  'pages.hara.failureNaMark': 'Mark N/A',
  'pages.hara.failureNaUndo': 'Undo N/A',
  'pages.hara.failureExample': 'Example',
  'pages.hara.failureModeNameHint':
    'Vehicle-level observable failure, e.g. clamping force not applied',
  'pages.hara.expandAll': 'Expand all',
  'pages.hara.collapseAll': 'Collapse all',
  'pages.hara.unassignedHint':
    'These failure modes have no owning function yet (usually legacy data); assign one so they count towards guideword coverage',
  'pages.hara.pickFunction': 'Assign to function…',
  'pages.hara.emptyFunctionsForFailure':
    'Add functions under "Functions" first, then come back to analyse them one by one',
  'pages.hara.sheetFailureMatrix': 'Failure Matrix',
  'pages.hara.colUnclassified': 'Unclassified',
  'pages.hara.sheetExcludedHazards': 'No-hazard decisions',
  'pages.hara.colExcludeReason': 'Decision reason',

  'pages.hara.colHazardId': 'Hazard ID',
  'pages.hara.dimFunction': 'Function',
  'pages.hara.dimFailureMode': 'Failure Mode',
  'pages.hara.dimScenario': 'Scenario',
  'pages.hara.colHazard': 'Hazard',
  'pages.hara.hazardHint': 'Vehicle-level hazard caused by this failure in this scenario',
  'pages.hara.colHazardGroup': 'Hazard Group',
  'pages.hara.hazardGroupHint':
    'Events sharing a group are merged into one safety goal with the highest ASIL',
  'pages.hara.hazardGroupPlaceholder': 'e.g. unintended braking',
  'pages.hara.colSafeState': 'Safe State',
  'pages.hara.goalSafeStateHint':
    'Required. Each safety goal shall state how the safe state is entered or maintained (ISO 26262-3:2018 7.4.2.5).',
  'pages.hara.goalSafeStatePlaceholder': 'e.g. cut drive torque and enter a controlled stop',
  'pages.hara.goalSafeStateLegacy': 'Inherited from the old main-table field — review and rewrite',
  'pages.hara.goalFttiHint':
    'Optional. Only needed here when the interval affected the ASIL determination (ISO 26262-3:2018 6.4.4.3 NOTE); it is formally defined in the functional safety concept (7.4.2.3 / 7.4.2.4).',
  'pages.hara.goalFttiPlaceholder': 'e.g. 100 ms',
  'pages.hara.coverageTitle': 'Coverage check (ISO 26262-3:2018 6.4.6.1)',
  'pages.hara.coverageUncovered':
    '{{count}} hazardous event(s) with an assigned ASIL are covered by no safety goal: {{ids}}',
  'pages.hara.coverageMissingSafeState': '{{count}} safety goal(s) have no safe state yet: {{ids}}',
  'pages.hara.colSourceHazards': 'Source Hazards',

  'pages.hara.crossOpen': 'Complete hazard identification',
  'pages.hara.crossTitle': 'Hazard Identification Table',
  'pages.hara.crossSubtitle': 'Failure mode × scenario',
  'pages.hara.crossMissing': '{{missing}} of {{total}} pairs not yet analysed',
  'pages.hara.crossComplete': 'All {{total}} pairs analysed',
  'pages.hara.crossOrphan': '{{count}} orphan reference(s)',
  'pages.hara.crossSummary':
    '{{total}} pairs: {{done}} analysed ({{hazard}} with hazard / {{excluded}} no hazard), {{missing}} pending',
  'pages.hara.crossColFunction': 'Function',
  'pages.hara.crossColFailureMode': 'Failure Mode',
  'pages.hara.crossCellNone': 'Not analysed',
  'pages.hara.crossNotReady':
    'Add numbered failure modes and scenarios first, then run hazard identification',
  'pages.hara.crossTip':
    'Rows are failure modes, columns are scenarios. Click an empty cell to create a hazard event or to mark "no hazard" (reason optional) — closing the gaps one by one.',
  'pages.hara.crossTipReadOnly':
    'Rows are failure modes, columns are scenarios. An empty cell means the pair has never been analysed — exactly what reviewers ask about.',
  'pages.hara.crossCreate': 'Create hazard event',
  'pages.hara.crossExclude': 'Mark as no hazard',
  'pages.hara.crossExcludeUndo': 'Undo',
  'pages.hara.crossExcludedShort': 'No hazard',
  'pages.hara.crossExcludeNoReason': '(no reason recorded)',
  'pages.hara.crossExcludeTitle': 'Mark as "not a hazard"',
  'pages.hara.crossExcludeReasonLabel': 'Reason (optional)',
  'pages.hara.crossExcludeReasonHint':
    'e.g. the failure causes no injury in this scenario. Reviewers ask whether a cell was forgotten or judged — a short note helps.',
  'pages.hara.crossOnlyOpen': 'Undetermined only',
  'pages.hara.crossFilterFunction': 'Filter by function',
  'pages.hara.crossGroupProgress':
    'Analysed / total pairs for this function (click the arrow to collapse)',
  'pages.hara.crossCollapsedHint': '{{count}} failure mode(s) collapsed',
  'pages.hara.crossNoMode': 'No operating mode',
  'pages.hara.crossAdviceTag': 'Suggested',
  'pages.hara.crossAdviceSameFm': 'The same failure mode already has a hazard in another scenario',
  'pages.hara.crossAdviceSameSc': 'Other failure modes in this scenario already have hazards',
  'pages.hara.crossFocusHint': 'Click a scenario column header to focus on it',
  'pages.hara.crossUnfilled': 'Not set',
  'pages.hara.crossScenarioElements': 'Elements {{filled}} / {{total}}',
  'pages.hara.crossScenarioGap':
    'Missing "{{fields}}" — judging cells with incomplete elements means grading on an incomplete premise',
  'pages.hara.crossCardNoDesc': '(No description for this failure mode)',
  'pages.hara.crossCardNoElements': 'No elements set',
  'pages.hara.crossCardHazardLabel': 'Vehicle-level hazard caused by this failure in this scenario',
  'pages.hara.crossCardHazardHint':
    'e.g. braking distance extends on a slippery road, risking a rear-end collision.',
  'pages.hara.crossCardGradeHint':
    'S / E / C are decided in the main table after creation; describe only the hazard here.',
  'pages.hara.crossCardRefHint': 'Creation pre-fills only function / failure mode / scenario',
  'pages.hara.crossFocusTag': 'Focused',
  'pages.hara.crossPrevScenario': 'Previous scenario',
  'pages.hara.crossNextScenario': 'Next scenario',
  'pages.hara.crossScenarioPos': 'Scenario {{index}} / {{total}}',
  'pages.hara.crossScenarioProgress': '{{done}} / {{total}} analysed',
  'pages.hara.crossShowAllScenarios': 'Show all scenarios',
  'pages.hara.exposureHintApply':
    'Suggested by the scenario; click to adopt (the E value is yours to decide)',

  'pages.hara.aiTriage': 'AI triage',
  'pages.hara.aiTriageCollapse': 'Hide triage',
  'pages.hara.aiTriageTitle': 'AI cell triage',
  'pages.hara.aiTriageHint':
    'Picks the combinations worth looking at first — ranking only, no judgement',
  'pages.hara.aiTriageScopeFocus': 'Focused scenario',
  'pages.hara.aiTriageScopeFunction': 'One function',
  'pages.hara.aiTriageScopeAll': 'All open cells',
  'pages.hara.aiTriagePickFunction': 'Select a function',
  'pages.hara.aiTriageRequirements':
    'Extra requirements, optional (e.g. focus on misuse and system interaction)',
  'pages.hara.aiTriageScopeInfo': '{{combos}} cells in scope, {{open}} still open',
  'pages.hara.aiTriageNothingOpen': 'Every cell in this scope is already determined',
  'pages.hara.aiTriageRun': 'Start triage',
  'pages.hara.aiTriageRerun': 'Run again',
  'pages.hara.aiTriageNote':
    'AI only identifies and ranks. It never produces S / E / C or an ASIL (exposure must be based on representative target-market data), and nothing is written into the table automatically.',
  'pages.hara.aiTriageNoResult': 'AI did not flag any combination — add more details and try again',
  'pages.hara.aiTriageNoCandidates': 'No failure mode or scenario available in the current scope',
  'pages.hara.aiTriageFailed': 'AI request failed, please try again later',
  'pages.hara.aiTriageCount': 'AI suggests reviewing {{count}} cells first, most important on top',
  'pages.hara.aiTriageVerdictHazard': 'Likely a hazard',
  'pages.hara.aiTriageVerdictUncertain': 'Uncertain',
  'pages.hara.aiTriageDraftLabel': 'Hazard draft',
  'pages.hara.aiTriageGoJudge': 'Judge this cell',
  'pages.hara.aiHazardDraft': 'AI draft',
  'pages.hara.aiHazardDraftHint':
    'Drafts one vehicle-level hazard sentence from the failure mode and scenario (no ratings); edit it freely — nothing is filled in automatically',
  'pages.hara.aiHazardDraftFailed': 'AI draft failed, please try again later',

  'pages.hara.criteria.severity.S0': 'No injuries (no harm to persons)',
  'pages.hara.criteria.severity.S1':
    'Light and moderate injuries (e.g. abrasions, minor fractures; usually full recovery)',
  'pages.hara.criteria.severity.S2':
    'Severe and life-threatening injuries (survival probable; e.g. severe concussion, loss of a limb)',
  'pages.hara.criteria.severity.S3':
    'Life-threatening and fatal injuries (survival uncertain; e.g. fatal injury)',
  'pages.hara.criteria.exposure.E0':
    'Incredible (the scenario is practically never encountered over the vehicle lifetime)',
  'pages.hara.criteria.exposure.E1':
    'Very low probability (occurs occasionally in a few specific conditions)',
  'pages.hara.criteria.exposure.E2': 'Low probability (a few times per year)',
  'pages.hara.criteria.exposure.E3': 'Medium probability (about once a month)',
  'pages.hara.criteria.exposure.E4': 'High probability (almost every drive)',
  'pages.hara.criteria.controllability.C0':
    'Controllable in general (almost all drivers avoid the harm easily)',
  'pages.hara.criteria.controllability.C1':
    'Simply controllable (most drivers can act to avoid the harm)',
  'pages.hara.criteria.controllability.C2':
    'Normally controllable (most drivers can act, but need some attention)',
  'pages.hara.criteria.controllability.C3':
    'Difficult to control or uncontrollable (drivers can hardly avoid the harm)',

  'pages.hara.criteriaOpen': 'S / E / C criteria',
  'pages.hara.criteriaOpenHint':
    'S / E / C level definitions and Table 4 criteria (ISO 26262-3 6.4.3)',
  'pages.hara.criteriaOpenFromMatrix': 'See full S / E / C criteria →',
  'pages.hara.criteriaDrawerTitle': 'S / E / C criteria',
  'pages.hara.criteriaDrawerIntro':
    'Hazard event classification: severity S, exposure E and controllability C per ISO 26262-3 6.4.3; the basis for E per Annex B; ASIL determination per Table 4. This page is a reference only and does not replace engineering judgement.',
  'pages.hara.criteriaTitle.severity': 'Severity S',
  'pages.hara.criteriaTitle.exposure': 'Exposure E',
  'pages.hara.criteriaTitle.controllability': 'Controllability C',
  'pages.hara.criteriaTitleAsil': 'ASIL determination (S × E × C)',
  'pages.hara.criteriaClauseSeverity':
    'ISO 26262-3 6.4.3 — graded by the severity of potential harm to persons',
  'pages.hara.criteriaClauseExposure':
    'ISO 26262-3 6.4.3 / 6.4.3.5 — graded by frequency or duration share in the target market (classes per Annex B)',
  'pages.hara.criteriaClauseControllability':
    'ISO 26262-3 6.4.3 — graded by whether a typical driver can avoid the harm in time',
  'pages.hara.criteriaClauseAsil': 'ISO 26262-3:2018 Table 4',
  'pages.hara.criteriaColLevel': 'Level',
  'pages.hara.criteriaColText': 'Criteria',
  'pages.hara.criteriaExposureBasisNote':
    'E is not just a level: per Annex B it must sit on one of the duration or frequency classes below, and that basis must be recorded in the E column of the main table.',
  'pages.hara.criteriaBasisColBasis': 'Exposure basis',
  'pages.hara.criteriaBasisColLevel': 'Implied E',
  'pages.hara.exposureBasisKindDuration': 'By duration share',
  'pages.hara.exposureBasisKindFrequency': 'By frequency',
  'pages.hara.exposureBasisFilled': 'Basis · {{text}}',
  'pages.hara.exposureBasisMissing': 'No exposure basis',
  'pages.hara.exposureBasisClear': 'Clear basis',
  'pages.hara.missingExposureBasis':
    '{{count}} rows have no exposure basis: per ISO 26262-3 Annex B, E must sit on a duration or frequency class and be traceable',
  'pages.hara.anchorHint':
    'State why this level was chosen (free text; the assessor traces it back)',
  'pages.hara.anchorPlaceholder': 'e.g. may strike a pedestrian, causing fatal injury',
  'pages.hara.anchorSuggest': 'Common phrases (click to fill)',
  'pages.hara.anchorCriteriaRef': 'Current criteria: {{text}}',
  'pages.hara.anchorFilled': 'Basis · {{text}}',
  'pages.hara.anchorEmpty': '+ basis note',
  'pages.hara.anchorEmptyShort': 'No basis',
  'pages.hara.anchor.severity.vru': 'May involve pedestrians or cyclists',
  'pages.hara.anchor.severity.unrestrained': 'Occupants unrestrained',
  'pages.hara.anchor.severity.highEnergy':
    'High-energy collision (high speed or large mass difference)',
  'pages.hara.anchor.severity.secondary': 'May trigger a secondary collision',
  'pages.hara.anchor.severity.noHarm': 'Vehicle damage only, no personal injury',
  'pages.hara.anchor.controllability.blind': 'No warning; the driver has no time to react',
  'pages.hara.anchor.controllability.sightBlocked': 'Sight blocked; hard to notice',
  'pages.hara.anchor.controllability.counterIntuitive': 'Counter-intuitive; easily mis-operated',
  'pages.hara.anchor.controllability.expert': 'Needs expert operation or special tools',
  'pages.hara.anchor.controllability.clear': 'Clear warning and sufficient reaction time',
  'pages.hara.asilMatrixTitle': 'S × E × C → ASIL (ISO 26262-3 Table 4)',
  'pages.hara.asilMatrixCurrent': 'current',
  'pages.hara.asilMatrixCaption': 'Current: {{s}} + {{e}} + {{c}} → {{asil}}',

  'pages.hara.override': 'Override',
  'pages.hara.overrideTitle': 'Override ASIL Manually',
  'pages.hara.overrideComputed': 'Per ISO 26262-3 Table 4:',
  'pages.hara.overridePick': 'Select the overriding ASIL',
  'pages.hara.overrideReasonHint':
    'A reason is mandatory — the assessor will ask why this was rated manually',
  'pages.hara.missingOverrideReason':
    '{{count}} events override the ASIL without a reason; the assessor will ask about them',
  'pages.hara.asilComputed': 'Computed ASIL',
  'pages.hara.asilOverride': 'Manual Override',
  'pages.hara.asilMismatch':
    '{{count}} ASIL ratings differed from the backend and were corrected per ISO 26262-3 Table 4',

  'pages.hara.itemDefinition': 'Item Definition',
  'pages.hara.itemName': 'Item Name',
  'pages.hara.itemNameHint': 'e.g. Electric Parking Brake (EPB)',
  'pages.hara.aiFill': 'Fill with AI',
  'pages.hara.aiFillHint': 'Enter the name first; AI completes the four fields below',
  'pages.hara.aiFillNote':
    'From the item name, fills the four fields below (function & composition / boundaries / operating modes / legal constraints) using general knowledge. Nothing is saved automatically — review, then save.',
  'pages.hara.aiFillReadOnly': 'Not available in read-only mode',
  'pages.hara.aiFillNeedName': 'Enter the item name first; AI completes the rest from it',
  'pages.hara.aiFillOverwriteTitle': 'Overwrite existing content?',
  'pages.hara.aiFillOverwrite':
    '{{count}} of the four fields below already have content and will be overwritten by the AI result (the item name is kept). Continue?',
  'pages.hara.aiFillOverwriteOk': 'Overwrite and generate',
  'pages.hara.aiFillDone':
    '{{count}} fields filled from general knowledge — review them, then save',
  'pages.hara.aiFnGenerate': 'Generate with AI',
  'pages.hara.aiFnReview': 'Review with AI',
  'pages.hara.aiFnTitleGenerate': 'Generate function list with AI',
  'pages.hara.aiFnTitleReview': 'Review function list with AI',
  'pages.hara.aiFnContext':
    'Derived from the Item Definition · {{count}} functions already defined',
  'pages.hara.aiFnRequirements':
    'Extra requirements (optional — leave empty to use the Item Definition and general knowledge)',
  'pages.hara.aiFnRequirementsReview':
    'Extra requirements (optional — e.g. focus on hill and highway scenarios)',
  'pages.hara.aiFnSubmitGenerate': 'Generate candidates',
  'pages.hara.aiFnSubmitReview': 'Start review',
  'pages.hara.aiFnRerun': 'Regenerate',
  'pages.hara.aiFnFindings': 'Findings',
  'pages.hara.aiFnNoFindings': 'No issues found',
  'pages.hara.aiFnReviewNote':
    'These are suggestions only — your list is untouched. To add items, use "Generate function list with AI".',
  'pages.hara.aiFnCandidates': 'Candidates (checked ones are appended to the list)',
  'pages.hara.aiFnExcluded': 'Considered out of scope by AI',
  'pages.hara.aiFnDup': 'Already {{code}}',
  'pages.hara.aiFnBasis': 'Basis',
  'pages.hara.aiFnDescPlaceholder': 'One-sentence description',
  'pages.hara.aiFnAdd': 'Add {{count}} selected',
  'pages.hara.aiFnAdded': '{{count}} added — remember to save',
  'pages.hara.aiFnNothingAdded': 'Nothing added: all selected items already exist',
  'pages.hara.aiFnSkipped': '{{count}} skipped (same name already in the list)',
  'pages.hara.aiFnNoItem':
    'Fill in at least one of the Item Definition fields first (functions & composition / boundaries / operating modes / legal constraints)',
  'pages.hara.aiFnEmpty': 'AI returned nothing usable — add more detail and retry',
  'pages.hara.aiFnFailed': 'AI call failed, please retry later',
  'pages.hara.aiFnType.missing': 'Missing',
  'pages.hara.aiFnType.granularity': 'Granularity',
  'pages.hara.aiFnType.out_of_scope': 'Out of scope',
  'pages.hara.aiFnType.duplicate': 'Duplicate',
  'pages.hara.aiFnType.other': 'Other',
  'pages.hara.aiFillEmpty': 'AI returned nothing usable. Try rephrasing the item name.',
  'pages.hara.aiFillFailed': 'AI fill failed, please try again later',
  'pages.hara.aiDisabled':
    'AI is not enabled. Ask an administrator to turn it on in system settings',
  'pages.hara.aiNotConfigured': 'AI service is not fully configured. Check system settings.',
  'pages.hara.itemDescription': 'Function and composition of the item',
  'pages.hara.itemDescriptionHint':
    'What functions it provides, which parts it consists of, and its role in the vehicle',
  'pages.hara.itemBoundaries': 'Boundaries and interfaces',
  'pages.hara.itemBoundariesHint':
    'Which external systems it interacts with and where the boundary is drawn',
  'pages.hara.itemOperatingModes': 'Operating modes',
  'pages.hara.itemOperatingModesHint': 'e.g. parking, driving, hill start, degraded/fault mode',
  'pages.hara.legalConstraints': 'Legal constraints',
  'pages.hara.legalConstraintsHint':
    'Applicable laws, national standards and internal company rules',
  'pages.hara.content': 'Content',
  'pages.hara.project': 'Project',
  'pages.hara.process': 'Process',
  'pages.hara.sheetOverview': 'Overview',

  'pages.hara.goalId': 'Safety Goal',
  'pages.hara.goalDescHint':
    'ISO 26262-3:2018 6.4.4.1: a safety goal is a top-level safety requirement for the item and is expressed as a functional objective (what to avoid), not as a technical solution (e.g. "cut torque via CAN").',
  'pages.hara.goalDescPlaceholder': 'e.g. Avoid unintended drive torque output',
  'pages.hara.goalDescAuto':
    'Auto-generated from the hazard group — please rewrite as a functional objective',
  'pages.hara.goalUncovered': 'Not covered',
  'pages.hara.goalUncoveredHint':
    'This hazardous event has an ASIL but is not covered by any safety goal (ISO 26262-3:2018 6.4.6.1 d requires complete coverage of hazardous events)',

  // ---- HARA → publish work product document ----
  'pages.hara.docTitle': 'HARA Hazard Analysis and Risk Assessment Report',
  'pages.hara.generatedAt': 'Generated at',
  'pages.hara.docGeneratedNote':
    'Generated from the HARA panel as a snapshot. Later changes to the HARA data are not synced automatically - regenerate to refresh.',
  'pages.hara.publishDoc': 'Generate work product',
  'pages.hara.refreshDoc': 'Refresh work product',
  'pages.hara.publishDirty': 'Save your changes before generating the work product document',
  'pages.hara.publishEmpty': 'No hazard events yet, nothing to generate',
  'pages.hara.publishCreated': 'Work product document {{version}} created',
  'pages.hara.publishUpdated': 'Work product document {{version}} refreshed',
  'pages.hara.publishUpgraded': 'Document upgraded to {{version}} (previous version kept)',
  'pages.hara.publishFailed': 'Failed to generate the work product document',
  'pages.hara.publishVersionDesc': 'Regenerated from the HARA panel',
  'pages.hara.publishRevisionDesc': 'Synced from the HARA panel',
  'pages.hara.publishVersionFailed': 'Failed to create a new document version',
  'pages.hara.publishedDoc': 'Linked work product document',
  'pages.hara.versionPrefix': 'Version',
  'pages.hara.publishedAt': 'Generated at {{at}}',
  'pages.hara.publishedStale': 'HARA data changed since then - the document is outdated',
  'pages.hara.notPublished':
    'No work product document yet. Once generated it lives under this process with versioning, review, baseline and export.',
  'pages.hara.statTitle': 'Statistics',
  'pages.hara.staleShort': 'outdated',
  'pages.hara.noDoc': 'No document',
  'pages.hara.allSaved': 'All changes saved',
  'pages.hara.publishFirstTip':
    'It will be created under this process with versioning, review, baseline and export',
  'pages.hara.publishRefreshTip':
    'Re-render current data into the existing document: overwrite in place while draft, otherwise publish a new version',

  // ---------------------------------------------------------------- Functional Safety Concept (FSC)
  'pages.workProducts.fsc': 'Functional Safety Concept',

  'pages.fsc.tabGoals': 'Safety Goals',
  'pages.fsc.tabRequirements': 'Functional Safety Requirements',
  'pages.fsc.tabArchitecture': 'Preliminary Architecture',
  'pages.fsc.tabAllocation': 'Requirement Allocation Matrix',
  'pages.fsc.tabConsistency': 'Consistency & Traceability',
  'pages.fsc.tabExternal': 'External Measures',

  'pages.fsc.goalId': 'Safety Goal',
  'pages.fsc.hazardGroup': 'Hazard Group',
  'pages.fsc.colAsil': 'ASIL',
  'pages.fsc.safeState': 'Safe State',
  'pages.fsc.safeStateLegacy':
    'This value came from a legacy HARA main-table field; please review and re-enter it on the safety goal page',
  'pages.fsc.needReview': 'Review',
  'pages.fsc.missing': 'Not set',
  'pages.fsc.ftti': 'FTTI',
  'pages.fsc.colRequirementCount': 'Derived Requirements',
  'pages.fsc.emptyGoalsFromHara':
    'No safety goals in HARA yet: they are aggregated automatically once the main table yields an ASIL above QM',
  'pages.fsc.emptyGoalsNoHara':
    'No HARA data yet: complete "HARA" first, since safety goals are its input',
  'pages.fsc.safeStateMissingTitle':
    '{{count}} safety goal(s) still have no safe state or FTTI defined',
  'pages.fsc.safeStateMissingDesc':
    'Safe state (ISO 26262-3 7.4.2.5) and FTTI (7.4.2.3) are inputs to the functional safety concept; without them the requirement decomposition below loses its basis. Enter them under "HARA → Safety Goals"; this page only references them.',
  'pages.fsc.goalsReadOnlyNote':
    'Read-only: safety goals are aggregated from HARA hazard events, and safe state / FTTI are entered on the HARA safety goal page. No second edit entry is provided on purpose.',

  'pages.fsc.allGoals': 'All safety goals',
  'pages.fsc.onlyUnconfirmed': 'Unconfirmed only',
  'pages.fsc.reqCount': '{{total}} total, showing {{shown}}',
  'pages.fsc.reqGoal': 'Safety Goal',
  'pages.fsc.reqStrategy': 'Derivation Strategy',
  'pages.fsc.strategyClause': 'ISO 26262-3:2018 7.4.2.3 {{code}})',
  'pages.fsc.strategyUnset': 'No strategy',
  'pages.fsc.asilPartA': 'a editable, b follows',
  'pages.fsc.asilFollowHint': 'Derived from sibling a; original level {{from}} stays',
  'pages.fsc.asilDecomposedParentHint':
    'Decomposed: the level is carried by both children; this row is not allocated',
  'pages.fsc.asilInheritHint':
    'Inherited from the safety goal (read-only); use ASIL decomposition to reduce',
  'pages.fsc.asilPartnerMissing': 'ASIL {{asil}} cannot be a part of {{original}}',
  'pages.fsc.decomposePartA': 'ASIL of child {{id}}a (the other is paired automatically)',
  'pages.fsc.decomposePreview': 'Result: {{id}}a = {{a}}({{from}}) / {{id}}b = {{b}}({{from}})',
  'pages.fsc.cellAsilReadonly': 'Allocation level (follows requirement)',
  'pages.fsc.cellAsilFollow': 'Equals the requirement level; reduce it via ASIL decomposition',
  'pages.fsc.verification.review': 'Review',
  'pages.fsc.verification.walkthrough': 'Walk-through',
  'pages.fsc.verification.inspection': 'Inspection',
  'pages.fsc.verification.analysis': 'Analysis',
  'pages.fsc.verification.simulation': 'Simulation',
  'pages.fsc.verification.bench': 'Bench test',
  'pages.fsc.verification.vehicle': 'Vehicle test',
  'pages.fsc.verification.safetyAnalysis': 'Safety analysis (FMEA / FTA)',
  'pages.fsc.reqId': 'Requirement ID',
  'pages.fsc.reqDescription': 'Requirement Description',
  'pages.fsc.refinedBadge': 'Refined here — differs from the HARA-derived value',
  'pages.fsc.refinedFromHara': 'Refined on the HARA page (kept as read-only baseline)',
  'pages.fsc.reqNote':
    'Functional safety requirements are derived from HARA safety goals (ISO 26262-3:2018 7.4.2.1) and finalised here. The safety-goal cell is merged over its requirements, so requirement order is row order. Click "+ FSR" at the bottom-right of that cell to generate requirements from the 7.4.2.3 strategies (at least one per goal, 7.4.2.2); "Derivation strategy" records which one a requirement follows (a to i, if applicable, not a fixed set of four). ASIL is inherited from the safety goal — to reduce it, use "Decompose" next to the ASIL value, which splits it into two sub-requirements.',

  'pages.fsc.reqVerification': 'Verification Method',
  'pages.fsc.reqVerificationPlaceholder': 'e.g. review + test',
  'pages.fsc.reqStatus': 'Status',
  'pages.fsc.reqConfirmHint':
    'Confirmed means this requirement is frozen in the current concept and can enter review',
  'pages.fsc.confirmed': 'Confirmed',
  'pages.fsc.unconfirmed': 'Draft',
  'pages.fsc.notAllocated': 'Unallocated',
  'pages.fsc.noVerification': 'No verification',
  'pages.fsc.actions': 'Actions',
  'pages.fsc.resetOverride': 'Reset',
  'pages.fsc.resetOverrideHint':
    'Drop the refinement on this page. If an older refinement still exists on the HARA side, that read-only baseline is used instead of the derived wording',

  'pages.fsc.elementType.SYSTEM': 'System',
  'pages.fsc.elementType.HARDWARE': 'Hardware',
  'pages.fsc.elementType.SOFTWARE': 'Software',
  'pages.fsc.elementType.MECHANICAL': 'Mechanical',
  'pages.fsc.elementType.EXTERNAL': 'External measure',
  'pages.fsc.elementType.OTHER_TECH': 'Other technology',
  'pages.fsc.externalOwner.DRIVER': 'Driver',
  'pages.fsc.externalOwner.OTHER_SYSTEM': 'Other system',
  'pages.fsc.externalOwner.INFRASTRUCTURE': 'Infrastructure',
  'pages.fsc.externalOwner.PROCESS': 'Production & service',

  'pages.fsc.allocatedCountShort': '{{count}}',
  'pages.fsc.newElementName': 'New element',
  'pages.fsc.architectureTree': 'Preliminary Architecture',
  'pages.fsc.addElementMenu': 'Element',
  'pages.fsc.insertRootElement': 'New root element',
  'pages.fsc.insertRootElementHint': 'Add at root level (system / external measure)',
  'pages.fsc.insertSiblingElement': 'New sibling element',
  'pages.fsc.insertSiblingElementHint': 'Same parent, right after the selected element',
  'pages.fsc.insertChildElement': 'New child element',
  'pages.fsc.insertChildElementHint': 'Becomes the last child of the selected element',
  'pages.fsc.insertParentElement': 'Insert parent element',
  'pages.fsc.insertParentElementHint':
    'Insert a new parent that wraps the selected element (and its children)',
  'pages.fsc.dragTip':
    'Drag an element to change the hierarchy: drop it on another element to make it a child (its children follow), drop it on empty space to make it a root.',
  'pages.fsc.dragMoving': 'Dragging "{{name}}"',
  'pages.fsc.dragSubtree': '(with {{count}} child element(s), moved along)',
  'pages.fsc.dragTargetHint':
    'Drop on an element to become its child, or on empty space to become a root',
  'pages.fsc.dragBlockedCycle': 'Cannot drop on its own descendant: that would create a cycle',
  'pages.fsc.dragBlockedSelf': 'Cannot drop on itself',
  'pages.fsc.dragBlockedNoop': 'It is already a child of this element',
  'pages.fsc.emptyElements':
    'No architecture elements yet: you need at least the item elements that carry requirements',
  'pages.fsc.elementProperties': 'Element Properties',
  'pages.fsc.removeElement': 'Delete element',
  'pages.fsc.elementName': 'Name',
  'pages.fsc.elementTypeLabel': 'Type',
  'pages.fsc.elementAsilCapability': 'ASIL Capability',
  'pages.fsc.elementAsilCapabilityHint':
    'Allocating a requirement above this level will raise a capability gap in the consistency check',
  'pages.fsc.elementDcTarget': 'Diagnostic Coverage Target',
  'pages.fsc.elementDcTargetPlaceholder': 'e.g. high (>=90%)',
  'pages.fsc.elementDescription': 'Description',
  'pages.fsc.elementUsage': 'Carries {{count}} requirement(s)',
  'pages.fsc.selectElement': 'Select an element on the left',
  'pages.fsc.elementCode': 'Element ID',
  'pages.fsc.elementCodeHint':
    'Generated from the hierarchy: children of AE-001 are AE-001-001. Changing the hierarchy renumbers elements and updates allocations and the block diagram.',
  'pages.fsc.renameTitle': 'Moving under "{{target}}" requires renumbering',
  'pages.fsc.renameTitleRoot': 'Promoting to root requires renumbering',
  'pages.fsc.renameSubtreeHint':
    '"{{source}}" moves together with {{count}} descendant(s); IDs are reissued for the new position and the old ones are retired.',
  'pages.fsc.renameImpact':
    'Also updated: {{alloc}} allocation(s), {{nodes}} diagram node(s), {{edges}} edge(s).',
  'pages.fsc.renameConfirm': 'Renumber and move',
  'pages.fsc.renameCancel': 'Cancel',

  'pages.fsc.cellDegradedHint':
    'This allocation stores {{asil}}, below the current requirement level {{target}}: saving once normalises it to the requirement level. To genuinely reduce it, run ASIL decomposition on the requirements tab.',

  'pages.fsc.cellNote': 'Note',
  'pages.fsc.removeAllocation': 'Remove this allocation',
  'pages.fsc.decompose': 'ASIL Decomposition',
  'pages.fsc.decomposeTitle': 'ASIL Decomposition — {{id}}',
  'pages.fsc.cancelDecompose': 'Cancel decomposition',
  'pages.fsc.cancel': 'Cancel',
  'pages.fsc.applyDecompose': 'Apply',
  'pages.fsc.decomposeAlertTitle':
    'ISO 26262-9:2018 5.4.5: safety goals cannot be decomposed, only requirements',
  'pages.fsc.decomposeAlertDesc':
    'Decomposition creates two real child requirements (e.g. FSR-002a / FSR-002b) keeping the original ASIL in brackets: B(D). They must reside on two mutually independent architectural elements, with independence proven by DFA in the safety case.',
  'pages.fsc.decomposeElements': 'Two independent elements (order maps to a / b)',

  'pages.fsc.decomposeElementsPlaceholder': 'Select two elements',
  'pages.fsc.decomposeReason': 'Rationale (reviewers look here first)',
  'pages.fsc.decomposeReasonShort': 'Reason',
  'pages.fsc.decomposeBy': 'Decomposed by',
  'pages.fsc.decomposeApplyNote':
    'On apply: child a gets the level you picked and b is paired per ISO 26262-9:2018 5.4.5 (the original-level label such as C(D) stays); each child gets one allocation and the parent is no longer allocated.',

  'pages.fsc.noRequirementsForMatrix':
    'No functional safety requirements yet: go to the requirements tab and generate FSRs per safety goal (7.4.2.2 requires at least one)',
  'pages.fsc.noElementsForMatrix':
    'No architecture elements yet: create the item elements and external measures that carry requirements under "Architecture"',
  'pages.fsc.matrixHint':
    'Click a cell to allocate: the level follows the requirement (read-only); reduce it by ASIL decomposition on the requirements tab. Decomposed FSR-xxxa / FSR-xxxb sit right under their parent and are allocated individually; a decomposed parent can no longer be allocated directly (cells show "—").',
  'pages.fsc.matrixColFsr': 'FSR',
  'pages.fsc.matrixChildOf': 'Decomposed from {{id}}',

  'pages.fsc.reqTotal': '{{total}} requirements (including decomposed children)',
  'pages.fsc.goalCovered': '{{count}} FSR',
  'pages.fsc.goalUncovered': 'No FSR',
  'pages.fsc.goalSafeStateLabel': 'Safe state',
  'pages.fsc.goalNoRequirementHint':
    'At least one functional safety requirement is required for each safety goal (ISO 26262-3:2018 7.4.2.2). This safety goal has none yet.',
  'pages.fsc.addFsr': '+ FSR',
  'pages.fsc.decomposeShort': 'Decompose',
  'pages.fsc.colAllocation': 'Allocated to',
  'pages.fsc.columnId': 'ID',
  'pages.fsc.allocOpenHint':
    'Click to pick the carrying element (preliminary architecture, ISO 26262-3:2018 7.4.2.8)',
  'pages.fsc.allocDecomposedHint':
    'Decomposed: the function is carried by the two sub-requirements, so the parent is not allocated',
  'pages.fsc.archViewTree': 'Element tree',
  'pages.fsc.archViewDiagram': 'Block diagram',
  'pages.fsc.archOrderHint':
    'The element tree decides what exists and what each carries; the block diagram decides how signals flow — tree first.',
  'pages.fsc.aiDraftTitle': 'AI draft architecture',
  'pages.fsc.aiDraftSubtitle':
    'This is a draft and is not saved; checked items merge into the current architecture, then click Save.',
  'pages.fsc.aiDraftSource': 'Source: {{count}} FSRs',
  'pages.fsc.aiDraftElementsOnly': 'Elements only, no allocation',
  'pages.fsc.aiDraftAllowReuse': 'Allow reusing existing elements',
  'pages.fsc.aiDraftToggleHint': 'Change a toggle, then redraft',
  'pages.fsc.aiDraftCandidates': '{{count}} candidate elements',
  'pages.fsc.aiDraftElementCountHint': 'max 3 levels',
  'pages.fsc.aiDraftAllocations': 'Candidate allocations (gaps only)',
  'pages.fsc.aiDraftAllocationHint': 'Read-only; fix in the matrix after merging',
  'pages.fsc.aiDraftNew': '+ new',
  'pages.fsc.aiDraftReuse': '= reuse {{id}}',
  'pages.fsc.aiDraftUnlinked': 'no FSR basis',
  'pages.fsc.aiDraftAllocated': 'set',
  'pages.fsc.aiDraftUnassigned': 'unassigned',
  'pages.fsc.aiDraftNoAllocation': 'Elements only this round, no allocations',
  'pages.fsc.aiDraftRedraft': 'Redraft',
  'pages.fsc.aiDraftCancel': 'Cancel',
  'pages.fsc.aiDraftAccept': 'Accept {{count}} selected',
  'pages.fsc.aiDraftRetry': 'Retry',
  'pages.fsc.aiDraftRunning': 'Reading requirements and drafting, usually a few seconds…',
  'pages.fsc.aiDraftEmpty': 'The model returned no usable elements; try another toggle combination',
  'pages.fsc.aiDraftFailed': 'Draft failed',
  'pages.fsc.aiDraftNotes': 'Approach: ',
  'pages.fsc.aiDraftIssueCount': '{{count}} items adjusted during sanitizing, hover to see',
  'pages.fsc.aiDraftStatsHint':
    'Elements without an FSR basis stay unchecked: checking them creates orphan gaps',
  'pages.fsc.aiStatUnlinked': '{{count}} without FSR basis',
  'pages.fsc.aiStatReused': '{{count}} reused',
  'pages.fsc.aiStatUnassigned': '{{count}} FSRs unassigned',
  'pages.fsc.aiDraftApplied':
    'Merged {{elements}} elements and {{allocations}} allocations — remember to save',
  'pages.fsc.diagramBoundary': 'Item boundary',
  'pages.fsc.diagramEmpty': 'No architecture elements yet: create them on the left first',
  'pages.fsc.diagramLink': 'Connect',
  'pages.fsc.diagramLinkOn': 'Connecting… click the target',
  'pages.fsc.diagramLinkHint':
    'Click the source element, then the target. Both ends must be existing elements — the diagram never shows a block the data does not have',
  'pages.fsc.diagramRelayout': 'Auto layout',
  'pages.fsc.diagramRemoveEdge': 'Delete edge',
  'pages.fsc.diagramClearEdges': 'Clear edges',
  'pages.fsc.diagramClearHint': 'Removes edges only; elements and their positions are kept',
  'pages.fsc.diagramFlowLegend': 'Flow',
  'pages.fsc.diagramDangling':
    '{{count}} edge(s) point at deleted elements and are not drawn; they are cleaned up on the next save',
  'pages.fsc.diagramEdgeTitle': 'Edge: {{from}} → {{to}}',
  'pages.fsc.diagramEdgeFlow': 'Flow type',
  'pages.fsc.diagramEdgeLabel': 'Label (e.g. signal name)',
  'pages.fsc.diagramEdgeLabelPlaceholder': 'e.g. wheel speed signal / brake torque request',
  'pages.fsc.diagramEdgeAdd': 'Add edge',
  'pages.fsc.diagramEdgeExists': 'These two elements already have an edge with the same flow',
  'pages.fsc.diagramEdgeAdded': 'Edge added',
  'pages.fsc.edgeFlow.SIGNAL': 'Signal',
  'pages.fsc.edgeFlow.ENERGY': 'Energy',
  'pages.fsc.edgeFlow.DATA': 'Data',
  'pages.fsc.edgeFlow.HUMAN': 'Human',
  'pages.fsc.drawerTitle': 'Allocation of {{id}}',
  'pages.fsc.drawerSubtitle':
    'Elements of the preliminary architecture (ISO 26262-3:2018 7.4.2.8). Checked elements carry this requirement; the ASIL follows the requirement and is read-only — use Decompose to reduce it.',
  'pages.fsc.drawerPick': 'Check the carrying elements',
  'pages.fsc.drawerNewElement': '+ New element',
  'pages.fsc.drawerRoot': 'Attach at root',
  'pages.fsc.drawerCreate': 'Create',
  'pages.fsc.drawerTarget': 'Implemented on {{id}}',
  'pages.fsc.drawerAsilHint':
    'The implemented ASIL follows the requirement and cannot be changed here (decomposition is the only way down)',
  'pages.fsc.drawerNote': 'Allocation note',
  'pages.fsc.drawerNotePlaceholder': 'Why this element (reviewers will ask)',
  'pages.fsc.drawerCarried': 'This element also carries {{count}} requirement(s)',
  'pages.fsc.drawerOrphan':
    'This element carries no requirement — redundant, or a missed allocation?',
  'pages.fsc.drawerSelectHint': 'Check an element on the left to write the allocation note',
  'pages.fsc.drawerElementEmpty': '0 here',
  'pages.fsc.drawerFooterHint':
    'Changes are recorded on the page; press Save at the top to persist',
  'pages.fsc.drawerDone': 'Done',
  'pages.fsc.generateTitle': 'Generate FSRs from {{id}}',
  'pages.fsc.generateConfirm': 'Generate',
  'pages.fsc.generateAlertTitle': 'ISO 26262-3:2018 7.4.2.3 strategy checklist (if applicable)',
  'pages.fsc.generateAlertDesc':
    'Not a fixed set of four: tick what applies to this safety goal, and each ticked strategy becomes one draft FSR you can rewrite. Strategies already generated are greyed out.',
  'pages.fsc.strategyUsed': 'Generated',
  'pages.fsc.strategyLabel.a': 'Fault avoidance',
  'pages.fsc.strategyLabel.b': 'Fault detection and control',
  'pages.fsc.strategyLabel.c': 'Transition to / from safe state',
  'pages.fsc.strategyLabel.d': 'Fault tolerance',

  'pages.fsc.strategyLabel.e': 'Degradation of functionality (with warning interaction)',

  'pages.fsc.strategyLabel.f': 'Driver warning (reduce exposure time)',
  'pages.fsc.strategyLabel.g': 'Driver warning (increase controllability)',

  'pages.fsc.strategyLabel.h': 'Timing (FTTI to FHTI)',
  'pages.fsc.strategyLabel.i': 'Arbitration of control requests (avoid improper arbitration)',

  'pages.fsc.strategyGroupFallback': 'this hazard',
  'pages.fsc.strategySafeStateFallback': '(safe state to be defined)',
  'pages.fsc.strategyFttiFallback': '(FTTI to be defined)',
  'pages.fsc.childTag': 'Decomposed',
  'pages.fsc.decomposed': 'Decomposed',
  'pages.fsc.decomposeHint':
    'Split into two child requirements on independent elements (ISO 26262-9)',
  'pages.fsc.decomposeBase': 'Base ASIL (from the requirement)',
  'pages.fsc.decomposeNeedElements':
    'Select two independent architectural elements: ASIL decomposition only holds on independent elements',
  'pages.fsc.cancelDecomposeTitle': 'Cancel decomposition of {{id}}?',
  'pages.fsc.cancelDecomposeContent':
    'The two child requirements and their allocations are deleted; the parent becomes a normal requirement again. Save to apply.',
  'pages.fsc.delete': 'Delete',
  'pages.fsc.deleteRequirementTitle': 'Delete requirement {{id}}?',
  'pages.fsc.deleteRequirementContent': 'Related allocations are deleted too. Save to apply.',
  'pages.fsc.deleteRequirementWithChildren':
    'Its {{count}} decomposed child requirements and their allocations are deleted too.',
  'pages.fsc.parentNotAllocatable':
    'A decomposed requirement is not allocated directly: its function is carried by the two children',
  'pages.fsc.clearRequirements': 'Clear all requirements',
  'pages.fsc.clearRequirementsTitle': 'Clear all functional safety requirements?',
  'pages.fsc.clearRequirementsContent':
    'Decomposed children and related allocations are removed; safety goals (HARA) are not affected. You can regenerate with "Generate FSR".',
  'pages.fsc.gapDecomposeCombination': 'Illegal decomposition combination',
  'pages.fsc.gapDecomposeParent': 'Decomposed requirement still allocated',
  'pages.fsc.gapDecomposeIndependence': 'Decomposition elements not independent',
  'pages.fsc.gapDecomposeStale': 'Decomposition label is stale',

  'pages.fsc.gapUnallocated': 'Requirement unallocated',
  'pages.fsc.gapUnallocatedDetail':
    'A requirement with ASIL {{asil}} is not allocated to any architectural element',
  'pages.fsc.gapUncoveredGoal': 'Safety goal uncovered',
  'pages.fsc.gapUncoveredGoalDetail':
    'Safety goal "{{group}}" is not covered by any functional safety requirement',
  'pages.fsc.gapAsil': 'Undecomposed ASIL reduction',
  'pages.fsc.gapAsilDetail':
    'Requirement {{from}} is implemented as {{to}} on {{element}}: {{reason}}',
  'pages.fsc.gapCapability': 'Element capability gap',
  'pages.fsc.gapCapabilityDetail':
    '{{element}} has ASIL capability {{capability}}, below the allocated {{asil}}',
  'pages.fsc.gapDangling': 'Dangling reference',
  'pages.fsc.gapSafeState': 'Missing safe state / FTTI',
  'pages.fsc.gapSafeStateDetail':
    'Safety goal "{{group}}" is missing: {{missing}} (fill it in on the HARA safety goal page)',
  'pages.fsc.gapVerification': 'Missing verification method',
  'pages.fsc.gapVerificationDetail': 'This requirement does not state how it will be verified',
  'pages.fsc.gapKind': 'Gap Type',
  'pages.fsc.gapTarget': 'Object',
  'pages.fsc.gapDetail': 'Detail',
  'pages.fsc.gotoFix': 'Fix',
  'pages.fsc.consistencyOk':
    'No critical gaps: every requirement is allocated and every safety goal is covered',
  'pages.fsc.gapList': 'Gap List',
  'pages.fsc.noGaps': 'No gaps detected',
  'pages.fsc.traceTitle': 'Traceability Chain',
  'pages.fsc.traceEmpty': 'No traceability chain to show yet',
  'pages.fsc.traceEmptyHint':
    'The chain starts from HARA safety goals, so it needs HARA completed first',
  'pages.fsc.traceSafeState': 'Safe state {{value}}',
  'pages.fsc.traceNoSafeState': 'No safe state defined',
  'pages.fsc.traceVerification': 'Verify: {{value}}',
  'pages.fsc.traceNoVerification': 'No verification method',
  'pages.fsc.kpiRequirements': 'Requirements',
  'pages.fsc.kpiAllocated': 'Allocated',
  'pages.fsc.kpiConfirmed': 'Confirmed',
  'pages.fsc.kpiElements': 'Elements',
  'pages.fsc.kpiGaps': 'Gaps',

  'pages.fsc.externalName': 'External measure / dependency',
  'pages.fsc.externalNamePlaceholder': 'e.g. driver presses the brake pedal',
  'pages.fsc.externalOwnerLabel': 'Owner',
  'pages.fsc.externalAssumption': 'Assumption',
  'pages.fsc.externalAssumptionPlaceholder': 'e.g. driver reacts within 1 s after the warning',
  'pages.fsc.externalRelated': 'Related Requirements',
  'pages.fsc.addExternal': 'Add external measure',
  'pages.fsc.externalAlertTitle':
    'External measures and assumptions must be self-evident (ISO 26262-3 7.4.2.8)',
  'pages.fsc.externalAlertDesc':
    'Any measure outside the item that the concept relies on (driver, other systems, infrastructure, production and service processes) must be listed here with its preconditions. Being "obvious" is not a reason to omit it.',
  'pages.fsc.externalMissingAssumptionShort': '{{count}} item(s) lack an assumption',
  'pages.fsc.externalMissingAssumption':
    'Some external measures have no assumption, so reviewers cannot confirm the precondition',

  'pages.fsc.statRequirements': 'Requirements',
  'pages.fsc.statAllocated': 'Allocated',
  'pages.fsc.statElements': 'Elements',
  'pages.fsc.statMaxAsil': 'Max ASIL',
  'pages.fsc.statOk': 'No critical gaps',
  'pages.fsc.statGaps': '{{count}} gap(s)',
  'pages.fsc.statDetail':
    'Unallocated requirements {{unallocated}} · gaps {{gaps}} · max ASIL {{maxAsil}}',
  'pages.fsc.save': 'Save',
  'pages.fsc.saveSuccess': 'Saved',
  'pages.fsc.saveFailed': 'Save failed',
  'pages.fsc.saveConflict':
    'The server data was updated elsewhere; reload before editing to avoid overwriting',
  'pages.fsc.saveBlockedByLoadError':
    'Data failed to load. Saving is blocked to protect the server copy — reload first',
  'pages.fsc.unsaved': 'Unsaved changes',
  'pages.fsc.allSaved': 'Saved, nothing pending',
  'pages.fsc.preservedWarning':
    'Some tables were not submitted this time; server values were kept: {{tables}}',
  'pages.fsc.export': 'Export Excel',
  'pages.fsc.exportFailed': 'Export failed',
  'pages.fsc.publishTip':
    'Creates a work product under this process with full versioning, review, baseline and export',
  'pages.fsc.refreshDoc': 'Refresh Work Product',
  'pages.fsc.publishDoc': 'Create Work Product',
  'pages.fsc.publishCreated': 'Work product document created',
  'pages.fsc.publishUpdated': 'Existing document content refreshed',
  'pages.fsc.publishUpgraded': 'New document version created',
  'pages.fsc.publishFailed': 'Failed to create work product document',
  'pages.fsc.publishBeforeSave':
    'There are unsaved changes — save before creating the work product',
  'pages.fsc.publishedStale':
    'Data changed afterwards; the work product is outdated, regenerate it',
  'pages.fsc.publishedFresh': 'Work product matches current data',
  'pages.fsc.notPublished': 'No work product document yet',
  'pages.fsc.reload': 'Reload',
  'pages.fsc.resetAll': 'Clear everything',
  'pages.fsc.resetTitle': 'Clear the entire functional safety concept?',
  'pages.fsc.resetContent':
    'Architecture elements, allocations, ASIL decompositions and external measures will be cleared (an archived copy is kept first). HARA data is not affected.',
  'pages.fsc.resetConfirm': 'Clear',
  'pages.fsc.resetDone': 'Cleared',
  'pages.fsc.clearAllocations': 'Clear allocations',
  'pages.fsc.loadErrorTitle': 'Could not load the functional safety concept from the server',
  'pages.fsc.loadErrorDesc':
    'The empty tables shown here do not mean the database is empty. Saving is temporarily blocked to avoid overwriting existing content. Reload before entering data.',
  'pages.fsc.noHaraTitle': 'No HARA data yet, so safety goals and requirements are empty',
  'pages.fsc.noHaraDesc':
    'The functional safety concept takes "item definition + hazard analysis and risk assessment" as input. You can build the preliminary architecture first and allocate once HARA yields safety goals.',
  'pages.fsc.scopeNote':
    'This page covers ISO 26262-3:2018 clause 7: at least one functional safety requirement per safety goal (7.4.2.2), strategies a) to i) (7.4.2.3), requirement attributes (operating modes / FTTI / safe states / emergency operation / functional redundancy, 7.4.2.4), safe states and emergency operation (7.4.2.5 / 7.4.2.6), assumptions on driver actions (7.4.2.7), allocation to architectural elements (7.4.2.8), elements of other technologies and external measures (7.4.2.9 / 7.4.2.10), safety validation criteria and concept verification (7.4.3 / 7.4.4); ASIL decomposition follows ISO 26262-9:2018 clause 5. Safety mechanisms belong to the technical safety concept (ISO 26262-4:2018 6.4.2) and are not on this page. Safety goals, safe state and FTTI are maintained on the HARA side and are read-only here.',

  'pages.fscReport.filePrefix': 'FSC',
  'pages.fscReport.docTitle': 'Functional Safety Concept',
  'pages.fscReport.sheetGoals': '1 Safety Goals',
  'pages.fscReport.sheetRequirements': '2 Functional Safety Requirements',
  'pages.fscReport.sheetElements': '3.1 Preliminary Architecture Elements',
  'pages.fscReport.sheetEdges': '3.2 Preliminary Architecture Interfaces',
  'pages.fscReport.sheetDiagram': '3 Preliminary Architecture Block Diagram',
  'pages.fscReport.sheetAllocations': '4 Requirement Allocation',
  'pages.fscReport.sheetDecompositions': '5 ASIL Decomposition',
  'pages.fscReport.sheetExternal': '6 External Measures',
  'pages.fscReport.sheetGaps': '7 Consistency Gaps',
  'pages.fscReport.sheetTrace': '8 Traceability',
  'pages.fscReport.colRequirementId': 'Requirement ID',
  'pages.fscReport.colGoalId': 'Safety Goal',
  'pages.fscReport.colKind': 'Derivation strategy',

  'pages.fscReport.colDescription': 'Description',
  'pages.fscReport.colAsil': 'ASIL',
  'pages.fscReport.colSafeState': 'Safe State',
  'pages.fscReport.colFtti': 'FTTI',
  'pages.fscReport.colVerification': 'Verification',
  'pages.fscReport.colConfirmed': 'Status',
  'pages.fscReport.colHazardGroup': 'Hazard Group',
  'pages.fscReport.colSourceHazards': 'Source Hazards',
  'pages.fscReport.colElementId': 'Element ID',
  'pages.fscReport.colElementName': 'Element Name',
  'pages.fscReport.colElementType': 'Type',
  'pages.fscReport.colParent': 'Parent',
  'pages.fscReport.colCapability': 'ASIL Capability',
  'pages.fscReport.colDcTarget': 'DC Target',
  'pages.fscReport.colTarget': 'Allocated Element',
  'pages.fscReport.colParts': 'Combination',
  'pages.fscReport.colChild': 'Child requirements',
  'pages.fscReport.colDecomposed': 'Decomposition',
  'pages.fscReport.decomposedTag': 'Decomposed',
  'pages.fscReport.childOf': 'From {{id}}',
  'pages.fscReport.colReason': 'Rationale',
  'pages.fscReport.colOwner': 'Owner',
  'pages.fscReport.colAssumption': 'Assumption',
  'pages.fscReport.colRelatedRequirement': 'Related Requirements',
  'pages.fscReport.colGapKind': 'Gap Type',
  'pages.fscReport.colGapTarget': 'Object',
  'pages.fscReport.colGapDetail': 'Detail',
  'pages.fscReport.colNote': 'Note',
  'pages.fscReport.none': '(none)',

  // ---- Unified requirement repository (P1-b) ----
  'pages.requirements.title': 'System Requirement Specification',
  'pages.requirements.titleSwe': 'Software Requirement Specification',
  'pages.requirements.titleHwe': 'Hardware Requirement Specification',
  'pages.requirements.add': 'Add Requirement',
  'pages.requirements.reload': 'Refresh',
  'pages.requirements.colId': 'ID',
  'pages.requirements.colDomain': 'Domain',
  'pages.requirements.colText': 'Requirement',
  'pages.requirements.colRating': 'Rating',
  'pages.requirements.colOrigin': 'Origin',
  'pages.requirements.colUpstream': 'Upstream',
  'pages.requirements.colStatus': 'Status',
  'pages.requirements.colVerification': 'Verification',
  'pages.requirements.colNote': 'Note',
  'pages.requirements.colAction': 'Actions',
  'pages.requirements.colPriority': 'Priority',
  'pages.requirements.colMilestone': 'Milestone',
  'pages.requirements.addChild': 'Add child',
  'pages.requirements.noParent': 'None (root requirement)',
  'pages.requirements.envImpactTag': 'Env.',
  'pages.requirements.envImpactPrefix': 'Operating environment impact',
  'pages.requirements.outline': 'Requirement outline (by hierarchy)',
  'pages.requirements.consistencyTitle': '{{count}} hierarchy consistency notice(s)',
  'pages.requirements.priority.HIGH': 'High',
  'pages.requirements.priority.MEDIUM': 'Medium',
  'pages.requirements.priority.LOW': 'Low',
  'pages.requirements.milestone.A': 'A sample',
  'pages.requirements.milestone.B': 'B sample',
  'pages.requirements.milestone.C': 'C sample',
  'pages.requirements.milestone.OTS': 'OTS',
  'pages.requirements.milestone.SOP': 'SOP',
  'pages.requirements.domain.SAFETY': 'Functional Safety',
  'pages.requirements.domain.CYBERSECURITY': 'Cybersecurity',
  'pages.requirements.domain.FUNCTIONAL': 'Functional',
  'pages.requirements.origin.INTERNAL': 'Internal upstream',
  'pages.requirements.origin.EXTERNAL': 'External input',
  'pages.requirements.origin.MANUAL': 'Manual',
  'pages.requirements.semantics.derive': 'Derive',
  'pages.requirements.semantics.satisfy': 'Satisfy',
  'pages.requirements.semantics.verify': 'Verify',
  'pages.requirements.semantics.allocate': 'Allocate',
  'pages.requirements.status.DRAFT': 'Draft',
  'pages.requirements.status.IN_REVIEW': 'In review',
  'pages.requirements.status.APPROVED': 'Approved',
  'pages.requirements.unlinked': 'No upstream linked',
  'pages.requirements.editTitle.new': 'Add Requirement',
  'pages.requirements.editTitle.edit': 'Edit {{id}}',
  'pages.requirements.field.domain': 'Domain',
  'pages.requirements.field.text': 'Requirement',
  'pages.requirements.field.rationale': 'Rationale',
  'pages.requirements.field.acceptanceCriteria': 'Acceptance criteria',
  'pages.requirements.field.verificationMethod': 'Verification method',
  'pages.requirements.field.asil': 'ASIL',
  'pages.requirements.field.cal': 'CAL',
  'pages.requirements.field.originType': 'Origin type',
  'pages.requirements.field.upstreamRefs': 'Upstream refs (multi-select)',
  'pages.requirements.field.upstreamSemantics': 'Link semantics',
  'pages.requirements.field.externalDocument': 'External document',
  'pages.requirements.field.externalVersion': 'Version',
  'pages.requirements.field.externalClause': 'Clause / page',
  'pages.requirements.field.status': 'Status',
  'pages.requirements.field.note': 'Note',
  'pages.requirements.field.parentId': 'Parent requirement',
  'pages.requirements.field.priority': 'Priority',
  'pages.requirements.field.milestone': 'Milestone',
  'pages.requirements.field.envImpact': 'Operating environment impact analysis',
  'pages.requirements.hint.envImpact':
    'Optional: low temperature, altitude, EMC and other constraints; shown as an "Env." tag and included in the published document',
  'pages.requirements.hint.asilInherit':
    'Inherited from safety requirements; silent downgrade is blocked',
  'pages.requirements.hint.calMissing':
    'CAL may stay empty when the cybersecurity concept is missing; prompt to complete it',
  'pages.requirements.hint.originExternal':
    'External input requires provenance (document or clause)',
  'pages.requirements.hint.originManual': 'Manual entries have no upstream',
  'pages.requirements.hint.unlinkedNeutral':
    'Unlinked upstream is a legal state, shown as a neutral label in the trace matrix',
  'pages.requirements.empty': 'No requirements yet. Click "Add Requirement" to start.',
  'pages.requirements.saveConflict':
    'The following requirements were changed elsewhere. Refresh and try again',
  'pages.requirements.saveFailed': 'Save failed',
  'pages.requirements.saved': 'Saved',
  'pages.requirements.deleteConfirm':
    'Delete requirement {{id}}? It can be recovered from revisions',
  'pages.requirements.resetConfirm': 'Clear all requirement rows owned by this process?',
  'pages.requirements.deleted': 'Deleted (effective after save)',
  'pages.requirements.pendingDeleteTag': 'Pending delete',
  'pages.requirements.upstreamCount': '{{count}} upstream',
  'pages.requirements.ownerScope':
    'This page lists and edits requirements owned by {process}; rows of other processes are aggregated in the trace matrix page',
  'pages.requirements.export': 'Export Excel',
  'pages.requirements.publish': 'Publish as Work Product',
  'pages.requirements.republish': 'Regenerate Work Product',
  'pages.requirements.publishedTag': 'Published {{version}}',
  'pages.requirements.stale': 'Data changed; regenerate',
  'pages.requirements.publishDone': 'Work product {{action}} (version {{version}})',
  'pages.requirements.publishAction.created': 'created',
  'pages.requirements.publishAction.updated': 'updated',
  'pages.requirements.publishAction.upgraded': 'upgraded',
  'pages.requirementsReport.filePrefix': 'ReqSpec',
  'pages.requirementsReport.docTitle': 'Requirement Specification',
  'pages.requirementsReport.sheetRequirements': '1 Requirement list',
  'pages.requirementsReport.none': '(none)',

  // ---- SYS.3 architecture & concept baseline (P1-d) ----
  'pages.sys3.title': 'Architecture Design',
  'pages.sys3.conceptTitle': 'Concept Baseline',
  'pages.sys3.tabElements': 'Architecture Tree',
  'pages.sys3.tabElementsSw': 'Software Components',
  'pages.sys3.tabInterfaces': 'Interfaces',
  'pages.sys3.tabAllocations': 'Requirement Allocation',
  'pages.sys3.tabMechanisms': 'Safety Mechanisms',
  'pages.sys3.tabSafeStates': 'Safe States',
  'pages.sys3.elementsTitle':
    'Architecture tree: system → hardware / software / mechanical / external elements',
  'pages.sys3.elementsTitleSw':
    'Software architecture tree: application layer → services / middleware / basic software',
  'pages.sys3.interfacesTitle': 'Interfaces: signal, power, bus links between elements',
  'pages.sys3.interfacesTitleSw':
    'Software interfaces: signal and service links between components',
  'pages.sys3.allocationsTitle':
    'Requirement allocation: SYS.2 requirements mapped to architecture elements',
  'pages.sys3.allocationsTitleSw':
    'Requirement allocation: SWE.1 software requirements mapped to software components',
  'pages.sys3.mechanismsTitle':
    'Safety mechanisms: detection target, method, response and fault handling time',
  'pages.sys3.safeStatesTitle':
    'Safe states: entry / exit conditions with related safety goals (HARA read-only)',
  'pages.sys3.colId': 'ID',
  'pages.sys3.colName': 'Name',
  'pages.sys3.colType': 'Type',
  'pages.sys3.colParent': 'Parent',
  'pages.sys3.colAsil': 'ASIL',
  'pages.sys3.colDescription': 'Description',
  'pages.sys3.colSource': 'Source',
  'pages.sys3.colTarget': 'Target',
  'pages.sys3.colRequirement': 'Requirement',
  'pages.sys3.colElement': 'Element',
  'pages.sys3.colElementSw': 'Software Component',
  'pages.sys3.colMechanisms': 'Mechanisms',
  'pages.sys3.colNote': 'Note',
  'pages.sys3.colDetectionTarget': 'Detection target',
  'pages.sys3.colDetectionMethod': 'Detection method',
  'pages.sys3.colResponseAction': 'Response action',
  'pages.sys3.colFaultHandlingTime': 'Fault handling time',
  'pages.sys3.colRelatedTsr': 'Related TSR',
  'pages.sys3.colStatus': 'Status',
  'pages.sys3.colEntryCondition': 'Entry condition',
  'pages.sys3.colExitCondition': 'Exit condition',
  'pages.sys3.colRelatedSg': 'Related safety goals',
  'pages.sys3.colTransitionDeadline': 'Transition deadline',
  'pages.sys3.colSafeState': 'Safe state',
  'pages.sys3.addRow': 'Add',
  'pages.sys3.editRow': 'Edit',
  'pages.sys3.deleteRowConfirm':
    'Delete this row? Effective after save; recoverable from revisions',
  'pages.sys3.colActions': 'Actions',
  'pages.sys3.emptyTable': 'No {{title}} yet. Click "Add" to start.',
  'pages.sys3.loading': 'Loading…',
  'pages.sys3.save': 'Save',
  'pages.sys3.saved': 'Saved',
  'pages.sys3.saveFailed': 'Save failed',
  'pages.sys3.reload': 'Refresh',
  'pages.sys3.reset': 'Clear',
  'pages.sys3.resetConfirm':
    'Clear all architecture data? It is archived first and recoverable from revisions',
  'pages.sys3.conflictTitle': 'Data changed by someone else',
  'pages.sys3.conflictContent':
    'Server data is newer than this page. Reload before editing to avoid overwriting',
  'pages.sys3.conflictReload': 'Reload',
  'pages.sys3.consistencyErrors': 'Consistency issues',
  'pages.sys3.consistencyWarnings': 'Hints',
  'pages.sys3.consistencyBanner':
    'Consistency check found {{count}} hint(s) (facts only, save is not blocked)',
  'pages.sys3.fhtHint': 'e.g. 100ms (aligned with FTTI)',
  'pages.sys3.deadlineHint': 'e.g. 200ms (aligned with FTTI)',
  'pages.sys3.noSg': 'None',
  'pages.sys3.sgInvalidHint': 'The related safety goal does not exist in HARA; check the ID',
  'pages.sys3.enum.SYSTEM': 'System',
  'pages.sys3.enum.HARDWARE': 'Hardware',
  'pages.sys3.enum.SOFTWARE': 'Software',
  'pages.sys3.enum.MECHANICAL': 'Mechanical',
  'pages.sys3.enum.EXTERNAL': 'External',
  'pages.sys3.enum.OTHER_TECH': 'Other tech',
  'pages.sys3.enum.SIGNAL': 'Signal',
  'pages.sys3.enum.POWER': 'Power',
  'pages.sys3.enum.BUS': 'Bus',
  'pages.sys3.enum.DIAGNOSTIC': 'Diagnostic',
  'pages.sys3.enum.OTHER': 'Other',
  'pages.sys3.enum.PLANNED': 'Planned',
  'pages.sys3.enum.IN_DESIGN': 'In design',
  'pages.sys3.enum.IMPLEMENTED': 'Implemented',
  'pages.sys3.enum.VERIFIED': 'Verified',
  'pages.sys3.enum.IN': 'Input',
  'pages.sys3.enum.OUT': 'Output',
  'pages.sys3.enum.BIDIR': 'Bidirectional',
  // S3: pin I/O and connector / peripheral enums
  'pages.sys3.enum.DI': 'Digital in',
  'pages.sys3.enum.DO': 'Digital out',
  'pages.sys3.enum.AI': 'Analog in',
  'pages.sys3.enum.AO': 'Analog out',
  'pages.sys3.enum.PWM': 'PWM',
  'pages.sys3.enum.GND': 'Ground',
  'pages.sys3.enum.MIXED': 'Mixed',
  'pages.sys3.enum.INTERNAL': 'Internal',
  'pages.sys3.enum.ACTIVE': 'Active',
  'pages.sys3.enum.RETIRED': 'Archived',
  'pages.sys3.enum.STRUCTURE': 'Structure',
  'pages.sys3.enum.CONTEXT': 'Context',
  'pages.sys3.enum.DEPLOY': 'Deployment',
  'pages.sys3.enum.DATAFLOW': 'Data flow',
  'pages.sys3.enum.STATE': 'State machine',
  'pages.sys3.conceptTabBaseline': 'Concept baseline refs',
  'pages.sys3.conceptTabTsc': 'TSC aggregate',
  'pages.sys3.conceptReadonlyHint':
    'Concept baseline is read-only: architecture from FSC, safety goals and FSRs from HARA; edit none of them here.',
  'pages.sys3.tscReadonlyHint':
    'TSC aggregate view (read-only): requirements from SYS.2, mechanisms and states from this page; exportable, not editable.',
  'pages.sys3.conceptArchitecture': 'FSC preliminary architecture elements',
  'pages.sys3.conceptGoals': 'Safety goals (HARA)',
  'pages.sys3.conceptFsrs': 'Functional safety requirements (FSR)',
  'pages.sys3.conceptNoFsc':
    'FSC has no preliminary architecture yet; an empty view is a legal state',
  'pages.sys3.tscRequirements': 'Safety-related requirements (SYS.2)',
  'pages.sys3.tscMechanisms': 'Safety mechanisms',
  'pages.sys3.tscSafeStates': 'Safe states and transitions',
  'pages.sys3.tscFilePrefix': 'TSC',
  'pages.sys3.exportExcel': 'Export Excel',

  // ---- Architecture workspace (S1: diagram and tables side by side) ----
  'pages.sys3.ws.modeWorkspace': 'Workspace',
  'pages.sys3.ws.modeTable': 'Tables',
  'pages.sys3.ws.modeHint':
    'In the workspace the diagram and the tables are two projections of the same data: the tree and the inspector edit data, the canvas only decides layout, and saving writes both at once.',
  'pages.sys3.ws.unnamed': 'Unnamed',
  'pages.sys3.ws.searchPlaceholder': 'Search id or name',
  'pages.sys3.ws.treeEmpty': 'No architecture elements yet — add them under Tables first',
  'pages.sys3.ws.inspectorEmpty': 'Select an element on the left to view and edit its properties',
  'pages.sys3.ws.linkedTitle': 'Related records',
  'pages.sys3.ws.linkedInterfaces': 'Interfaces',
  'pages.sys3.ws.linkedAllocations': 'Requirement allocations',
  'pages.sys3.ws.linkedMechanisms': 'Safety mechanisms',
  'pages.sys3.ws.linkedEmpty': 'No records',
  'pages.sys3.ws.pickElementHint':
    'Showing all records; select an element to see only the rows related to it',
  'pages.sys3.ws.parentNone': 'None (top level)',
  'pages.sys3.ws.dirty': 'Unsaved changes',
  'pages.sys3.ws.savedAll': 'Architecture data and diagram saved',
  'pages.sys3.ws.exportFailed': 'Diagram changes could not be exported; only attributes were saved',
  'pages.sys3.ws.canvasHint':
    'The canvas only decides layout; id / name / type / ASIL always come from the tree and the inspector',
  'pages.sys3.ws.needEngine': 'The drawing engine is not ready yet, please retry shortly',
  'pages.sys3.ws.conflict': 'This data was changed by someone else, please reload before editing',

  // ---- Architecture workspace S2: dual IDs / multi-view / soft delete ----
  'pages.sys3.ws.code': 'Element code',
  'pages.sys3.ws.codeHint':
    'External code, editable at any time; the internal ID never changes, so references stay intact',
  'pages.sys3.ws.idImmutable':
    'Internal ID, fixed once created — interfaces, allocations and diagram shapes all hang off it',
  'pages.sys3.ws.groupExplain': 'Description',
  'pages.sys3.ws.layer': 'Layer',
  'pages.sys3.ws.layerPlaceholder': 'e.g. system / subsystem / component',
  'pages.sys3.ws.summary': 'One-line summary',
  'pages.sys3.ws.summaryPlaceholder': 'What it is responsible for, in one line',
  'pages.sys3.ws.decompNote': 'Decomposition rationale',
  'pages.sys3.ws.decompHint': 'Why it is split this way (the first thing reviewers ask)',
  'pages.sys3.ws.remark': 'Remark',
  'pages.sys3.ws.archive': 'Archive',
  'pages.sys3.ws.archiveConfirm': 'Archive this element?',
  'pages.sys3.ws.archiveConfirmDesc':
    'It will be hidden by default and can be restored at any time. Existing interfaces and allocations stay intact — nothing is physically deleted.',
  'pages.sys3.ws.archived': 'Archived, can be restored at any time',
  'pages.sys3.ws.restore': 'Restore',
  'pages.sys3.ws.restored': 'Restored',
  'pages.sys3.ws.retired': 'Archived',
  'pages.sys3.ws.showRetired': 'Show archived ({{count}})',
  'pages.sys3.ws.hideRetired': 'Hide archived',
  'pages.sys3.ws.createChild': 'New element under {{name}}',
  'pages.sys3.ws.createRoot': 'New top-level element',
  'pages.sys3.ws.newElement': 'New element',
  'pages.sys3.ws.noView': 'No view yet',
  'pages.sys3.ws.noViewDesc':
    'No architecture diagram yet: click "Generate" to draw one from the element tree, or create a view first',
  'pages.sys3.ws.noViewHint':
    'One view each for structure / deployment / data flow is a good start',
  'pages.sys3.ws.newView': 'New view',
  'pages.sys3.ws.newViewName': 'View {{index}}',
  'pages.sys3.ws.defaultView': 'Default view',
  'pages.sys3.ws.renameView': 'Rename view',
  'pages.sys3.ws.deleteView': 'Delete view',
  'pages.sys3.ws.deleteViewTitle': 'Delete view "{{name}}"?',
  'pages.sys3.ws.deleteViewDesc':
    'Only this diagram is removed; element data and other views are untouched.',
  'pages.sys3.ws.keepOneView': 'At least one view must remain',
  'pages.sys3.ws.viewNameRequired': 'View name cannot be empty',
  'pages.sys3.ws.viewNamePlaceholder': 'View name',
  'pages.sys3.ws.viewCount': '{{count}} view(s)',
  'pages.sys3.ws.saveBeforeSwitch': 'There are unsaved changes — save before switching views',
  'pages.sys3.ws.colProtocol': 'Protocol',
  'pages.sys3.ws.colSignal': 'Signal',
  'pages.sys3.ws.colDirection': 'Direction',
  'pages.sys3.ws.dataElement': 'Data element',
  'pages.sys3.ws.internalId': 'Internal ID',

  // ---- S3: interface design (5.x) + non-functional requirements (6) ----
  'pages.sys3.ws.modeInterfaces': 'Interface design',
  'pages.sys3.ws.modeNfr': 'Non-functional',
  'pages.sys3.ws.saveBeforeLeave': 'You have unsaved changes — save before switching',
  'pages.sys3.ws.groupStatic': 'Static architecture',
  'pages.sys3.ws.groupDynamic': 'Dynamic architecture',
  'pages.sys3.ws.kind.FBD': 'Functional block',
  'pages.sys3.ws.kind.ELECTRICAL': 'Electrical architecture',
  'pages.sys3.ws.kind.PHYSICAL': 'Physical architecture',
  'pages.sys3.ws.kind.CONTEXT': 'Context',
  'pages.sys3.ws.kind.DEPLOY': 'Deployment',
  'pages.sys3.ws.kind.DATAFLOW': 'Data flow',
  'pages.sys3.ws.kind.STATE': 'State machine',
  'pages.sys3.ws.kind.SEQUENCE': 'Sequence',
  'pages.sys3.ws.kind.OTHER': 'Other',
  'pages.sys3.ws.viewKind': 'View type',
  'pages.sys3.ws.createView': 'New view',
  'pages.sys3.ws.viewNameIndexed': '{{name}} {{index}}',
  'pages.sys3.ws.staticKindTip':
    'Static views are projections of the element table: generate a first draft and run diagram sync',
  'pages.sys3.ws.dynamicViewHint':
    'This is a behaviour view: draw states and interactions by hand. It does not take part in element sync, but codes on the canvas still map to the table',
  'pages.sys3.ws.dynamicEmptyDesc':
    'Behaviour views have nothing to generate — start drawing, and put the element code in the shape label to link it',
  'pages.sys3.ws.dynamicNoGenerate':
    'Dynamic views are hand-drawn: they are not a projection of the element list, so there is no draft to generate',
  'pages.sys3.ws.bindStat': 'Bound {{bound}}/{{total}}',
  'pages.sys3.ws.bindTip':
    '{{unbound}} shapes carry no element code, {{unknown}} codes are not in the table yet. Put the code on the first line of the label to bind a shape',
  'pages.sys3.ws.onCanvas': 'This element is drawn on the canvas',
  'pages.sys3.ws.toggleTree': 'Show / hide element tree',
  'pages.sys3.ws.toggleInspector': 'Show / hide properties',
  'pages.sys3.ws.toggleLinked': 'Show / hide linked records',
  'pages.sys3.ws.fullscreen': 'Fullscreen canvas',
  'pages.sys3.ws.exitFullscreen': 'Exit fullscreen',
  'pages.sys3.io.hint':
    'The four tables of chapter 5 come from Excel in practice (schematics, pin assignments, harness lists): import them rather than typing every row. Importing only fills the table — click Save to store it.',
  'pages.sys3.io.tabSignals': 'Signal interfaces',
  'pages.sys3.io.tabConnectors': 'Connector pins',
  'pages.sys3.io.tabChipPins': 'Chip pins',
  'pages.sys3.io.tabPeripherals': 'CPU config',
  'pages.sys3.io.signalsTitle':
    'Signal interfaces: source → target, with protocol / signal / direction',
  'pages.sys3.io.connectorsTitle': 'Connector list (grouping for 5.1)',
  'pages.sys3.io.pinsTitle': 'Connector pin list (pin number unique per connector)',
  'pages.sys3.io.chipPinsTitle': 'Chip pin definition (basic · hardware · software)',
  'pages.sys3.io.internal': 'Internal (5.3)',
  'pages.sys3.io.external': 'Peripheral (5.4)',
  'pages.sys3.io.internalTitle': 'CPU internal configuration (5.3)',
  'pages.sys3.io.externalTitle': 'CPU peripheral configuration (5.4)',
  'pages.sys3.io.nfrTitle': 'Non-functional requirements (6)',
  'pages.sys3.io.nfrHint':
    'Which element carries a performance / reliability / resource target, and how it is realised. Different from the allocation matrix, which maps functional requirements to elements.',
  'pages.sys3.io.colConnectorName': 'Connector',
  'pages.sys3.io.colLocation': 'Location',
  'pages.sys3.io.colMate': 'Mates with',
  'pages.sys3.io.colConnector': 'Connector',
  'pages.sys3.io.colIo': 'I/O',
  'pages.sys3.io.colPinNo': 'Pin no.',
  'pages.sys3.io.colPinName': 'Pin name',
  'pages.sys3.io.colFunction': 'Function',
  'pages.sys3.io.colElectrical': 'Electrical',
  'pages.sys3.io.colDefault': 'Default',
  'pages.sys3.io.colConnectTo': 'Connects to',
  'pages.sys3.io.colChip': 'Chip',
  'pages.sys3.io.colOwner': 'Element',
  'pages.sys3.io.colHwId': 'HW ID',
  'pages.sys3.io.colHwIdShort': 'HW ID',
  'pages.sys3.io.colHwChar': 'I/O characteristic',
  'pages.sys3.io.colHwDefault': 'Reset state',
  'pages.sys3.io.colSwId': 'SW ID',
  'pages.sys3.io.colSwConfig': 'SW config',
  'pages.sys3.io.colConfigPath': 'Config path',
  'pages.sys3.io.colParam1': 'Param 1',
  'pages.sys3.io.colParam2': 'Param 2',
  'pages.sys3.io.colParam3': 'Param 3',
  'pages.sys3.io.colParam4': 'Param 4',
  'pages.sys3.io.colNfrCode': 'NFR ID',
  'pages.sys3.io.colNfrText': 'Requirement',
  'pages.sys3.io.colNfrElements': 'Carried by',
  'pages.sys3.io.colNfrMethod': 'Method',
  'pages.sys3.io.importConnectors': 'Import connectors',
  'pages.sys3.io.importPins': 'Import pins',
  'pages.sys3.io.importChipPins': 'Import chip pins',
  'pages.sys3.io.importPeripherals': 'Import config',
  'pages.sys3.io.importNfrs': 'Import NFR',
  'pages.sys3.io.title': 'Import Excel · {{label}}',
  'pages.sys3.io.uploadHint': 'Drop the Excel here, or click to choose a file',
  'pages.sys3.io.uploadSubHint':
    'Only .xlsx; download the template to guarantee column recognition',
  'pages.sys3.io.parsing': 'Parsing…',
  'pages.sys3.io.parseFailed': 'Parse failed: make sure it is a .xlsx with a header row',
  'pages.sys3.io.templateFailed': 'Template download failed',
  'pages.sys3.io.rechoose': 'Choose another file',
  'pages.sys3.io.sheet': 'Sheet',
  'pages.sys3.io.headerRow': 'Header row',
  'pages.sys3.io.parsed': 'Importable',
  'pages.sys3.io.skipped': 'Skipped',
  'pages.sys3.io.mapped': 'Recognised columns',
  'pages.sys3.io.unmapped': 'Ignored',
  'pages.sys3.io.missingRequired':
    'Missing required columns: {{fields}} — rename them or use the template',
  'pages.sys3.io.unresolvedConnectors': 'Unknown connectors: {{names}}',
  'pages.sys3.io.unresolvedBlocked':
    'Some connectors are unresolved: tick "auto-create missing connectors" or create them first',
  'pages.sys3.io.issues': 'Validation notes ({{count}}, first 30 shown)',
  'pages.sys3.io.rowLabel': 'Row {{row}}',
  'pages.sys3.io.preview': 'Preview (first {{count}} rows)',
  'pages.sys3.io.downloadTemplate': 'Download template',
  'pages.sys3.io.modeAppend': 'Append to existing rows',
  'pages.sys3.io.modeReplace': 'Replace existing rows (archive old)',
  'pages.sys3.io.autoCreateConnectors': 'Auto-create missing connectors (by name)',
  'pages.sys3.io.applyCount': 'Import {{count}} rows',
  'pages.sys3.io.applied': 'Imported {{count}} rows — click Save to store them',

  // ---- SWE.3 software detailed design (P2-c: units / detailed design / allocation) ----
  'pages.swe3.tabTitle': 'Detailed Design',
  'pages.swe3.tabUnits': 'Software Units',
  'pages.swe3.tabDesigns': 'Detailed Design',
  'pages.swe3.tabAllocations': 'Requirement Allocation',
  'pages.swe3.unitsTitle': 'Software unit list',
  'pages.swe3.designsTitle': 'Detailed design',
  'pages.swe3.allocationsTitle': 'Requirement allocation',
  'pages.swe3.colId': 'ID',
  'pages.swe3.colName': 'Name',
  'pages.swe3.colComponent': 'Component',
  'pages.swe3.colUnitType': 'Unit type',
  'pages.swe3.colLanguage': 'Language',
  'pages.swe3.colAsil': 'ASIL capability',
  'pages.swe3.colFilePath': 'Implementation file',
  'pages.swe3.colDescription': 'Responsibility',
  'pages.swe3.colUnit': 'Software unit',
  'pages.swe3.colDesignType': 'Design type',
  'pages.swe3.colDesignDescription': 'Design description',
  'pages.swe3.colInterfaceSpec': 'Interfaces and dependencies',
  'pages.swe3.colErrorHandling': 'Error handling',
  'pages.swe3.colResourceConstraint': 'Resource constraints',
  'pages.swe3.colReviewStatus': 'Review status',
  'pages.swe3.colRequirement': 'Software requirement',
  'pages.swe3.colNote': 'Note',
  'pages.swe3.addRow': 'Add',
  'pages.swe3.editRow': 'Edit',
  'pages.swe3.deleteRowConfirm': 'Delete this row?',
  'pages.swe3.colActions': 'Actions',
  'pages.swe3.emptyTable': 'No content in "{{title}}" yet',
  'pages.swe3.loading': 'Loading…',
  'pages.swe3.save': 'Save',
  'pages.swe3.reload': 'Refresh',
  'pages.swe3.reset': 'Clear',
  'pages.swe3.saved': 'Saved',
  'pages.swe3.saveFailed': 'Save failed',
  'pages.swe3.conflictTitle': 'Data has been updated',
  'pages.swe3.conflictContent':
    'The server data was updated by another page or colleague. Refresh before editing to avoid overwriting.',
  'pages.swe3.conflictReload': 'Refresh',
  'pages.swe3.resetConfirm':
    'Clear all SWE.3 detailed design data? (The current version is archived first)',
  'pages.swe3.consistencyErrors': 'Consistency issues',
  'pages.swe3.consistencyWarnings': 'Hints',
  'pages.swe3.consistencyBanner':
    'Consistency check found {{count}} hint(s) (facts only, save is not blocked)',
  'pages.swe3.summaryLine': 'Units {{units}} · Designs {{designs}} · Allocations {{allocations}}',
  'pages.swe3.unitWithoutDesign': '{{count}} unit(s) without design',
  'pages.swe3.unitWithoutAllocation': '{{count}} unit(s) without requirement',
  'pages.swe3.noComponents':
    'SWE.2 has no software component yet: you can create units first and set the component later.',
  'pages.swe3.enum.FUNCTION': 'Function',
  'pages.swe3.enum.CLASS': 'Class',
  'pages.swe3.enum.MODULE': 'Module',
  'pages.swe3.enum.ISR': 'ISR',
  'pages.swe3.enum.LIBRARY': 'Library',
  'pages.swe3.enum.OTHER': 'Other',
  'pages.swe3.enum.STATE_MACHINE': 'State machine',
  'pages.swe3.enum.SEQUENCE': 'Sequence',
  'pages.swe3.enum.ALGORITHM': 'Algorithm',
  'pages.swe3.enum.DATA_STRUCTURE': 'Data structure',
  'pages.swe3.enum.DRAFT': 'Draft',
  'pages.swe3.enum.IN_REVIEW': 'In review',
  'pages.swe3.enum.REVIEWED': 'Reviewed',
  'pages.swe3.enum.APPROVED': 'Approved',
  // P2-d: HWE.2 hardware design (architecture / component selection / safety mechanisms / allocation)
  'pages.hwe2.tabTitle': 'Hardware Design',
  'pages.hwe2.loading': 'Loading hardware design data…',
  'pages.hwe2.tabElements': 'Architecture',
  'pages.hwe2.tabComponents': 'Component Selection',
  'pages.hwe2.tabMechanisms': 'Safety Mechanisms',
  'pages.hwe2.tabAllocations': 'Requirement Allocation',
  'pages.hwe2.elementsTitle': 'Hardware Architecture Elements',
  'pages.hwe2.componentsTitle': 'Component Selection List',
  'pages.hwe2.mechanismsTitle': 'Hardware Safety Mechanism List',
  'pages.hwe2.allocationsTitle': 'Hardware Requirement Allocation',
  'pages.hwe2.colId': 'ID',
  'pages.hwe2.colName': 'Name',
  'pages.hwe2.colElementType': 'Element type',
  'pages.hwe2.colParent': 'Parent',
  'pages.hwe2.colSystemElement': 'System element',
  'pages.hwe2.colAsil': 'ASIL capability',
  'pages.hwe2.colDescription': 'Description',
  'pages.hwe2.colCategory': 'Category',
  'pages.hwe2.colElement': 'Element',
  'pages.hwe2.colManufacturer': 'Manufacturer',
  'pages.hwe2.colPartNumber': 'Part number',
  'pages.hwe2.colPackage': 'Package',
  'pages.hwe2.colKeySpec': 'Key specification',
  'pages.hwe2.colTempRange': 'Temperature range',
  'pages.hwe2.colQualification': 'Qualification',
  'pages.hwe2.colFailureRate': 'Failure rate (FIT)',
  'pages.hwe2.colComponentStatus': 'Selection status',
  'pages.hwe2.colDetectionTarget': 'Detection target',
  'pages.hwe2.colDetectionMethod': 'Detection method',
  'pages.hwe2.colResponseAction': 'Response action',
  'pages.hwe2.colFaultHandlingTime': 'Fault handling time',
  'pages.hwe2.colRelatedRequirement': 'Related requirement',
  'pages.hwe2.colMechanismStatus': 'Status',
  'pages.hwe2.colRequirement': 'Requirement ID',
  'pages.hwe2.colMechanisms': 'Safety mechanisms',
  'pages.hwe2.colNote': 'Note',
  'pages.hwe2.addRow': 'Add',
  'pages.hwe2.editRow': 'Edit',
  'pages.hwe2.deleteRowConfirm': 'Delete this row?',
  'pages.hwe2.colActions': 'Actions',
  'pages.hwe2.emptyTable': 'No {{title}} yet. Click "Add" at the top right to start.',
  'pages.hwe2.save': 'Save',
  'pages.hwe2.saved': 'Hardware design saved',
  'pages.hwe2.saveFailed': 'Save failed',
  'pages.hwe2.reset': 'Clear',
  'pages.hwe2.reload': 'Refresh',
  'pages.hwe2.conflictTitle': 'Data has been updated',
  'pages.hwe2.conflictContent':
    'The server data was updated by another page or colleague. Refresh before editing to avoid overwriting.',
  'pages.hwe2.conflictReload': 'Refresh',
  'pages.hwe2.resetConfirm':
    'Clear all HWE.2 hardware design data? (The previous version is archived.)',
  'pages.hwe2.consistencyErrors': 'Consistency issues',
  'pages.hwe2.consistencyWarnings': 'Hints',
  'pages.hwe2.consistencyBanner':
    'Consistency check found {{count}} hints (facts only, saving is not blocked)',
  'pages.hwe2.summaryLine':
    'Elements {{elements}} · Components {{components}} · Mechanisms {{mechanisms}} · Allocations {{allocations}}',
  'pages.hwe2.elementWithoutComponent': '{{count}} elements without components',
  'pages.hwe2.elementWithoutAllocation': '{{count}} elements without requirements',
  'pages.hwe2.selectedWithoutPart': '{{count}} selected components missing part number',
  'pages.hwe2.noRequirements':
    'HWE.1 has no hardware requirements yet. Elements and components can be entered first; allocation can follow.',
  'pages.hwe2.enum.SUBSYSTEM': 'Subsystem',
  'pages.hwe2.enum.CIRCUIT': 'Circuit',
  'pages.hwe2.enum.MODULE': 'Module',
  'pages.hwe2.enum.SENSOR': 'Sensor',
  'pages.hwe2.enum.ACTUATOR': 'Actuator',
  'pages.hwe2.enum.POWER': 'Power supply',
  'pages.hwe2.enum.PCB': 'PCB',
  'pages.hwe2.enum.CONNECTOR': 'Connector',
  'pages.hwe2.enum.OTHER': 'Other',
  'pages.hwe2.enum.MCU': 'MCU',
  'pages.hwe2.enum.SOC': 'SoC',
  'pages.hwe2.enum.POWER_IC': 'Power IC',
  'pages.hwe2.enum.ANALOG_IC': 'Analog IC',
  'pages.hwe2.enum.DIGITAL_IC': 'Digital IC',
  'pages.hwe2.enum.PASSIVE': 'Passive',
  'pages.hwe2.enum.AEC_Q100': 'AEC-Q100',
  'pages.hwe2.enum.AEC_Q101': 'AEC-Q101',
  'pages.hwe2.enum.AEC_Q200': 'AEC-Q200',
  'pages.hwe2.enum.NONE': 'Non-automotive',
  'pages.hwe2.enum.TBD': 'TBD',
  'pages.hwe2.enum.CANDIDATE': 'Candidate',
  'pages.hwe2.enum.SELECTED': 'Selected',
  'pages.hwe2.enum.OBSOLETE': 'Obsolete',
  'pages.hwe2.enum.REJECTED': 'Rejected',
  'pages.hwe2.enum.PLANNED': 'Planned',
  'pages.hwe2.enum.IN_DESIGN': 'In design',
  'pages.hwe2.enum.IMPLEMENTED': 'Implemented',
  'pages.hwe2.enum.VERIFIED': 'Verified',

  // ---- P2-e architecture diagram editor (plan V2.4 chapter 10) ----
  'pages.archDiagram.viewList': 'List view',
  'pages.archDiagram.viewDiagram': 'Diagram view',
  'pages.archDiagram.generate': 'Generate initial diagram',
  'pages.archDiagram.blank': 'Blank canvas',
  'pages.archDiagram.save': 'Save diagram',
  'pages.archDiagram.sync': 'Sync',
  'pages.archDiagram.refresh': 'Refresh',
  'pages.archDiagram.elementCount': '{{count}} shapes',
  'pages.archDiagram.generateDone':
    'Initial diagram generated with {{count}} elements; save to keep editing',
  'pages.archDiagram.generateFailed': 'Failed to generate the initial diagram',
  'pages.archDiagram.loadFailed': 'Failed to load the architecture diagram',
  'pages.archDiagram.notReady': 'The diagram engine is still loading, please retry shortly',
  'pages.archDiagram.saved': 'Architecture diagram saved',
  'pages.archDiagram.saveFailed': 'Failed to save the architecture diagram',
  'pages.archDiagram.syncFailed': 'Sync comparison failed',
  'pages.archDiagram.exportEmpty': 'No diagram data was returned, please retry',
  'pages.archDiagram.syncApplied': 'Applied {{count}} confirmed item(s)',
  'pages.archDiagram.syncApplyFailed': 'Failed to apply the sync',
  'pages.archDiagram.degradedTitle': 'Diagram editor unavailable, switched back to list view',
  'pages.archDiagram.degradedDesc':
    'The diagram editor is not enabled for this project or globally (ARCH_DIAGRAM_ENABLED). The list view keeps working.',
  'pages.archDiagram.timeoutTitle': 'The drawing service timed out, switched back to list view',
  'pages.archDiagram.timeoutDesc':
    'The diagram engine is slow on first load, or the service is unreachable from this network. Click Retry to reopen the diagram view; the list view keeps working.',
  'pages.archDiagram.unavailableTitle': 'Local drawing assets are not installed',
  'pages.archDiagram.unavailableDesc':
    'The same-origin drawing service (/drawio/) is missing. Run python tools/setup_drawio.py in the project root, then retry. The list view keeps working.',
  'pages.archDiagram.retry': 'Retry',
  'pages.archDiagram.engineLoading': 'Loading the diagram engine, please wait…',
  'pages.archDiagram.emptyTitle': 'No architecture diagram yet',
  'pages.archDiagram.emptyDesc':
    'Generate an initial diagram from the current data (layout and IDs are filled in automatically), or start from a blank canvas',
  'pages.archDiagram.diffTitle': 'Confirm sync differences',
  'pages.archDiagram.diffApply': 'Apply sync',
  'pages.archDiagram.diffCancel': 'Cancel',
  'pages.archDiagram.diffScope':
    '{{shapes}} shapes / {{edges}} connectors in the diagram; nothing is written before you confirm',
  'pages.archDiagram.diffEmpty': 'The diagram matches the data — nothing to sync',
  'pages.archDiagram.colType': 'Difference',
  'pages.archDiagram.colSysId': 'System ID',
  'pages.archDiagram.colDiagram': 'In diagram',
  'pages.archDiagram.colData': 'In dataset',
  'pages.archDiagram.colDetail': 'Detail',
  'pages.archDiagram.colAction': 'Decision',
  'pages.archDiagram.action.import': 'Import as new element',
  'pages.archDiagram.action.ignore': 'Ignore',
  'pages.archDiagram.action.keepData': 'Keep dataset value',
  'pages.archDiagram.action.useDiagram': 'Rename from diagram',
  'pages.archDiagram.action.keep': 'Keep dataset',
  'pages.archDiagram.action.acknowledge': 'Acknowledged',
  'pages.archDiagram.kind.ELEMENT': 'Architecture element',
  'pages.archDiagram.kind.MECHANISM': 'Safety mechanism',
  'pages.archDiagram.kind.INTERFACE': 'Interface',
  'pages.archDiagram.kind.COMPONENT': 'Component',
  'pages.archDiagram.kind.UNIT': 'Software unit',
  'pages.archDiagram.kind.MEASURE': 'External measure',
  'pages.sys3.doc.title': 'Architecture design document',
  'pages.sys3.doc.save': 'Save',
  'pages.sys3.doc.reload': 'Reload',
  'pages.sys3.doc.unsaved': 'Unsaved',
  'pages.sys3.doc.issueCount': '{{count}} to review',
  'pages.sys3.doc.issueBanner': '{{count}} consistency notes — saving is not blocked',
  'pages.sys3.doc.newSection': 'Add section',
  'pages.sys3.doc.newSectionHint': 'Template sections are preset; add more as needed',
  'pages.sys3.doc.emptyTab': 'No sections in this tab yet',
  'pages.sys3.doc.tab.STATIC': 'System static design',
  'pages.sys3.doc.tab.DYNAMIC': 'System dynamic design',
  'pages.sys3.doc.tab.INTERFACE': 'Interface design',
  'pages.sys3.doc.tab.NFR': 'Non-functional requirements',
  'pages.sys3.doc.tab.ALLOCATION': 'Requirement allocation',
  'pages.sys3.doc.tableOnly': 'Table only',
  'pages.sys3.doc.toggleCollapse': 'Collapse / expand',
  'pages.sys3.doc.moveUp': 'Move up',
  'pages.sys3.doc.moveDown': 'Move down',
  'pages.sys3.doc.removeSection': 'Delete section',
  'pages.sys3.doc.removeConfirm': 'Delete this section?',
  'pages.sys3.doc.removeHint': 'Only the section and its diagram are removed; table rows are kept.',
  'pages.sys3.doc.renameSection': 'Rename section',
  'pages.sys3.doc.sectionNamePlaceholder': 'e.g. System electrical architecture',
  'pages.sys3.doc.boundRatio': 'Bound {{bound}}/{{total}}',
  'pages.sys3.doc.bindingTip': 'Shapes carrying an ID / elements in this section',
  'pages.sys3.doc.noTableBinding': 'No table bound to this section',
  'pages.sys3.doc.tableOf': 'Table: {{name}}',
  'pages.sys3.doc.rowCount': '{{count}} rows',
  'pages.sys3.doc.onlyBound': 'Bound only ({{count}})',
  'pages.sys3.doc.colLayer': 'Layer',
  'pages.sys3.doc.colDataElement': 'Data element',
  'pages.sys3.doc.rowBelongsToTable':
    'These are master-table records: the same row appears in every section that shows this table.',
  'pages.sys3.doc.hintElements': 'No elements yet — add one, or draw a box and write its code',
  'pages.sys3.doc.hintInterfaces':
    'No interfaces yet — add one, or draw a connector and write its code',
  'pages.sys3.doc.hintConnectorPins':
    'No pin rows yet — enter pin number and connected object per connector',
  'pages.sys3.doc.hintChipPins':
    'No pin rows yet — enter pin number, HW resource and SW configuration',
  'pages.sys3.doc.hintPeripherals':
    'No configuration items yet — add internal / external peripherals',
  'pages.sys3.doc.hintNfrs': 'No NFRs yet — requirement → carrying element → implementation method',
  'pages.sys3.doc.hintAllocations': 'No allocations yet — build the requirement × element matrix',
  'pages.sys3.doc.hintTransitions': 'No transitions yet — from state → to state → trigger',
  'pages.sys3.doc.hintSteps': 'No steps yet — index / component / action / interface used',
  'pages.sys3.doc.colConnector': 'Connector',
  'pages.sys3.doc.colPinNo': 'Pin no.',
  'pages.sys3.doc.colPinName': 'Pin name',
  'pages.sys3.doc.colFunction': 'Function',
  'pages.sys3.doc.colElectrical': 'Electrical',
  'pages.sys3.doc.colConnectTo': 'Connected to',
  'pages.sys3.doc.colDefault': 'Default',
  'pages.sys3.doc.colHwId': 'HW ID',
  'pages.sys3.doc.colHwChar': 'HW I/O characteristic',
  'pages.sys3.doc.colHwDefault': 'Initial state',
  'pages.sys3.doc.colSwId': 'SW ID',
  'pages.sys3.doc.colSwConfig': 'Function config',
  'pages.sys3.doc.colConfigPath': 'Config path',
  'pages.sys3.doc.colParam1': 'Parameter 1',
  'pages.sys3.doc.colParam2': 'Parameter 2',
  'pages.sys3.doc.colParam3': 'Parameter 3',
  'pages.sys3.doc.colParam4': 'Parameter 4',
  'pages.sys3.doc.colNfrText': 'Requirement',
  'pages.sys3.doc.colCarrier': 'Carrying element',
  'pages.sys3.doc.colMethod': 'Implementation',
  'pages.sys3.doc.colFromState': 'From state',
  'pages.sys3.doc.colToState': 'To state',
  'pages.sys3.doc.colTrigger': 'Trigger',
  'pages.sys3.doc.colAction': 'Action',
  'pages.sys3.doc.colStep': 'Index',
  'pages.sys3.doc.colComponent': 'Component',
  'pages.sys3.doc.colActionText': 'Action',
  'pages.sys3.doc.colUseInterface': 'Interface used',
  'pages.sys3.doc.kindInternal': 'Internal',
  'pages.sys3.doc.kindExternal': 'External',
  'pages.sys3.doc.engineDegraded': 'Canvas degraded',
  'pages.sys3.doc.generate': 'Generate draft',
  'pages.sys3.doc.generateHint': 'Regenerate from the element table (overwrites current drawing)',
  'pages.sys3.doc.bindingCheck': 'Check bindings',
  'pages.sys3.doc.engineFallback': 'Diagram engine not ready — retry or reopen later',
  'pages.sys3.doc.retry': 'Retry',
  'pages.sys3.doc.openToEdit': 'Click to open the canvas',
  'pages.sys3.doc.openCanvas': 'Open canvas',
  'pages.sys3.doc.emptyCanvas': 'No diagram yet — draw it, or generate from elements',
  'pages.sys3.doc.noDiagram': 'No diagram in this section',
  'pages.sys3.ws.colCode': 'ID',
  'pages.sys3.fieldRequired': 'Required',
  'pages.sys3.doc.tab.CONTROL': 'Control strategy',
  'pages.sys3.doc.tab.RESOURCE': 'Resource estimation',
  'pages.sys3.doc.tab.SWE2.STATIC': 'Software static design',
  'pages.sys3.doc.tab.SWE2.INTERFACE': 'Component interface design',
  'pages.sys3.doc.tab.SWE2.DYNAMIC': 'Software dynamic design',
  'pages.sys3.doc.tab.SWE2.NFR': 'Non-functional requirements',
  'pages.sys3.doc.tab.SWE2.CONTROL': 'Software control strategy',
  'pages.sys3.doc.tab.SWE2.RESOURCE': 'Resource estimation',
  'pages.sys3.doc.tab.SWE2.ALLOCATION': 'Requirement allocation',
  'pages.sys3.doc.boundTable': 'Bound table',
  'pages.sys3.table.elements': 'Architecture elements',
  'pages.sys3.table.interfaces': 'Interfaces',
  'pages.sys3.table.modules': 'Modules',
  'pages.sys3.table.functions': 'Component interfaces',
  'pages.sys3.table.signals': 'Interface signals',
  'pages.sys3.table.stateTransitions': 'State transitions',
  'pages.sys3.table.sequenceSteps': 'Sequence steps',
  'pages.sys3.table.dataFlows': 'Data flows',
  'pages.sys3.table.nfrs': 'Non-functional requirements',
  'pages.sys3.table.controlTimings': 'Response time',
  'pages.sys3.table.osTasks': 'Task management',
  'pages.sys3.table.isrs': 'Interrupt handlers',
  'pages.sys3.table.memoryRegions': 'Memory layout',
  'pages.sys3.table.resourceBudgets': 'Memory budget',
  'pages.sys3.table.cpuLoads': 'CPU load',
  'pages.sys3.table.allocations': 'Requirement allocation',
  'pages.sys3.table.connectors': 'Connectors',
  'pages.sys3.table.connectorPins': 'Connector pins',
  'pages.sys3.table.chipPins': 'Chip pins',
  'pages.sys3.table.peripherals': 'CPU internal / external peripherals',
  'pages.sys3.swe2.colSummary': 'Function summary',
  'pages.sys3.swe2.colDevMode': 'Development mode',
  'pages.sys3.swe2.colOwnerElement': 'Owning component',
  'pages.sys3.swe2.colModule': 'Module',
  'pages.sys3.swe2.colFunctionName': 'Function',
  'pages.sys3.swe2.colPrototype': 'Prototype',
  'pages.sys3.swe2.colSyncMode': 'Call mode',
  'pages.sys3.swe2.colReturnType': 'Return type',
  'pages.sys3.swe2.colReentrant': 'Reentrant',
  'pages.sys3.swe2.colTiming': 'Timing constraint',
  'pages.sys3.swe2.colDataType': 'Data type',
  'pages.sys3.swe2.colValueRange': 'Value range',
  'pages.sys3.swe2.colRangeNote': 'Range notes',
  'pages.sys3.swe2.colUnit': 'Unit',
  'pages.sys3.swe2.colInitialValue': 'Initial value',
  'pages.sys3.swe2.colFunctionOwner': 'Interface',
  'pages.sys3.swe2.colDataFlowDesc': 'Data flow description',
  'pages.sys3.swe2.colBehaviorId': 'Behaviour ID',
  'pages.sys3.swe2.colRequired': 'Required performance',
  'pages.sys3.swe2.colEstimated': 'Estimated performance',
  'pages.sys3.swe2.colBehaviorRef': 'Related behaviour',
  'pages.sys3.swe2.colTaskName': 'Task',
  'pages.sys3.swe2.colPeriod': 'Period',
  'pages.sys3.swe2.colPriority': 'Priority',
  'pages.sys3.swe2.colRuntime': 'Runtime',
  'pages.sys3.swe2.colCpuLoad': 'CPU load',
  'pages.sys3.swe2.colIsrName': 'Interrupt',
  'pages.sys3.swe2.colIsrSource': 'Source',
  'pages.sys3.swe2.colFrequency': 'Frequency / event',
  'pages.sys3.swe2.colDuty': 'Responsibility',
  'pages.sys3.swe2.colStartAddr': 'Start address',
  'pages.sys3.swe2.colEndAddr': 'End address',
  'pages.sys3.swe2.colSize': 'Size',
  'pages.sys3.swe2.colMemType': 'Memory type',
  'pages.sys3.swe2.colAccess': 'Access',
  'pages.sys3.swe2.colUsage': 'Usage',
  'pages.sys3.swe2.colTarget': 'Object',
  'pages.sys3.swe2.colRom': 'ROM',
  'pages.sys3.swe2.colRamStatic': 'RAM · static',
  'pages.sys3.swe2.colRamStack': 'RAM · stack',
  'pages.sys3.swe2.colRamHeap': 'RAM · heap',
  'pages.sys3.swe2.colFlash': 'Flash',
  'pages.sys3.swe2.colNvm': 'NVM',
  'pages.sys3.swe2.colScenario': 'Worst-case scenario',
  'pages.sys3.swe2.colBehaviors': 'Included behaviours',
  'pages.sys3.swe2.colLoadTarget': 'Target load',
  'pages.sys3.swe2.colLoadEstimate': 'Estimated load',
  'pages.sys3.swe2.ramTotal': 'RAM total',
  'pages.sys3.swe2.summaryTotal': 'Total',
  'pages.sys3.swe2.devMode.NEW': 'New',
  'pages.sys3.swe2.devMode.REUSE': 'Reuse',
  'pages.sys3.swe2.devMode.CHANGE': 'Change',
  'pages.sys3.swe2.devMode.PURCHASE': 'Purchase',
  'pages.sys3.swe2.devMode.OUTSOURCE': 'Outsource',
  'pages.sys3.swe2.syncMode.SYNC': 'Synchronous',
  'pages.sys3.swe2.syncMode.ASYNC': 'Asynchronous',
  'pages.sys3.swe2.syncMode.ISR': 'Interrupt context',
  'pages.sys3.swe2.treeInput': 'Input signals ({{count}})',
  'pages.sys3.swe2.treeOutput': 'Output signals ({{count}})',
  'pages.sys3.swe2.treeFunctions': '{{count}} interface(s)',
  'pages.sys3.swe2.treeOrphanFunctions': 'Interfaces without module ({{count}})',
  'pages.sys3.swe2.treeOrphanSignals': 'Signals without interface ({{count}})',
  'pages.sys3.swe2.treeEmpty':
    'No modules yet — add the module list first, then interfaces per module',
  'pages.sys3.swe2.hintModules': 'No modules yet — add module ID / name / function summary',
  'pages.sys3.swe2.hintFunctions':
    'No interfaces yet — add prototype, owning module and function description',
  'pages.sys3.swe2.hintSignals': 'No signals yet — add name / data type / value range',
  'pages.sys3.swe2.hintDataFlows':
    'No data flows yet — add step / component / description / interface',
  'pages.sys3.swe2.hintControlTimings':
    'No response-time entries yet — required vs estimated performance',
  'pages.sys3.swe2.hintTasks': 'No tasks yet — add name / period / priority',
  'pages.sys3.swe2.hintIsrs': 'No interrupts yet — add name / source / priority / responsibility',
  'pages.sys3.swe2.hintMemoryRegions':
    'No memory regions yet — add start / end address and memory type',
  'pages.sys3.swe2.hintResourceBudgets': 'No estimation rows yet — add object / ROM / RAM / Flash',
  'pages.sys3.swe2.hintCpuLoads':
    'No scenarios yet — add worst case / target load / estimated load',

  // ═══ S5: HWE.2 hardware architecture ═══
  'pages.sys3.hwTitle': 'Hardware Architecture Design',
  'pages.sys3.doc.tab.HWE2.STATIC': 'Static hardware design',
  'pages.sys3.doc.tab.HWE2.POWER': 'Power & ground design',
  'pages.sys3.doc.tab.HWE2.INTERFACE': 'Hardware interface design',
  'pages.sys3.doc.tab.HWE2.SAFETY': 'Safety mechanisms & metrics',
  'pages.sys3.doc.tab.HWE2.ALLOCATION': 'Requirement allocation',
  'pages.sys3.doc.hwLevels': 'Hardware levels',
  'pages.sys3.doc.colHwLevel': 'Level',
  'pages.sys3.doc.hwLevelEmpty': 'No elements at this level',
  'pages.sys3.table.hwComponents': 'Component list',
  'pages.sys3.table.hwPowerNets': 'Power & ground nets',
  'pages.sys3.table.hwEmcMeasures': 'EMC measures',
  'pages.sys3.table.hwMetrics': 'Hardware architecture metrics',
  'pages.sys3.table.hwPinRefs': 'Pin usage',
  'pages.sys3.enum.ECU': 'ECU',
  'pages.sys3.enum.BOARD': 'Board',
  'pages.sys3.enum.COMPONENT': 'Component',
  'pages.sys3.enum.GROUND': 'Ground',
  'pages.sys3.enum.SUBSYSTEM': 'Subsystem',
  'pages.sys3.enum.CIRCUIT': 'Circuit',
  'pages.sys3.enum.MODULE': 'Module',
  'pages.sys3.enum.SENSOR': 'Sensor',
  'pages.sys3.enum.ACTUATOR': 'Actuator',
  'pages.sys3.enum.PCB': 'PCB',
  'pages.sys3.enum.CONNECTOR': 'Connector',
  'pages.sys3.hw.colCategory': 'Category',
  'pages.sys3.hw.colPartNumber': 'Part number',
  'pages.sys3.hw.colManufacturer': 'Manufacturer',
  'pages.sys3.hw.colKeySpec': 'Key spec',
  'pages.sys3.hw.colQualification': 'Automotive qualification',
  'pages.sys3.hw.colSelectStatus': 'Selection status',
  'pages.sys3.hw.colOwnerElement': 'Element',
  'pages.sys3.hw.colPackage': 'Package',
  'pages.sys3.hw.colTempRange': 'Temperature range',
  'pages.sys3.hw.colNetName': 'Net name',
  'pages.sys3.hw.colNetNameShort': 'On-board net',
  'pages.sys3.hw.colNetKind': 'Kind',
  'pages.sys3.hw.colRail': 'Rail',
  'pages.sys3.hw.colVoltage': 'Voltage',
  'pages.sys3.hw.colSource': 'Source / ground point',
  'pages.sys3.hw.colSourceElement': 'Source element',
  'pages.sys3.hw.colConsumers': 'Consumers',
  'pages.sys3.hw.colProtection': 'Protection',
  'pages.sys3.hw.colWireSpec': 'Wire / routing',
  'pages.sys3.hw.colGroundPoint': 'Ground point',
  'pages.sys3.hw.colEmcSource': 'Disturbance source',
  'pages.sys3.hw.colCouplingPath': 'Coupling path',
  'pages.sys3.hw.colEmcType': 'Measure type',
  'pages.sys3.hw.colEmcMeasure': 'Measure',
  'pages.sys3.hw.colEmcResult': 'Verification result',
  'pages.sys3.hw.colVerify': 'Verification method',
  'pages.sys3.hw.colMetricTarget': 'Measured item',
  'pages.sys3.hw.colMetricKind': 'Metric kind',
  'pages.sys3.hw.colMetricGoal': 'Target',
  'pages.sys3.hw.colMetricActual': 'Actual',
  'pages.sys3.hw.colUnit': 'Unit',
  'pages.sys3.hw.colVerdict': 'Verdict',
  'pages.sys3.hw.colDataSource': 'Data source',
  'pages.sys3.hw.colRefCode': 'SYS.3 pin code',
  'pages.sys3.hw.colPinSource': 'Source',
  'pages.sys3.hw.colPinNo': 'Pin number',
  'pages.sys3.hw.hintComponents':
    'No components yet — add part number / manufacturer / category / key spec',
  'pages.sys3.hw.hintPowerNets':
    'No nets yet — add net name / source / consumers / voltage; power and ground share this table',
  'pages.sys3.hw.hintEmc':
    'No EMC measures yet — add disturbance source / coupling path / measure type / measure',
  'pages.sys3.hw.hintMetrics':
    'No metric rows yet — add measured item / kind (SPFM, LFM, PMHF, FIT) / target / actual',
  'pages.sys3.hw.hintPinRefs':
    'No pin usage yet — add the referenced SYS.3 pin code / element / net',
  'pages.sys3.hw.category.MCU': 'MCU',
  'pages.sys3.hw.category.SOC': 'SOC',
  'pages.sys3.hw.category.SENSOR': 'Sensor',
  'pages.sys3.hw.category.ACTUATOR': 'Actuator',
  'pages.sys3.hw.category.POWER_IC': 'Power IC',
  'pages.sys3.hw.category.ANALOG_IC': 'Analog IC',
  'pages.sys3.hw.category.DIGITAL_IC': 'Digital IC',
  'pages.sys3.hw.category.PASSIVE': 'Passive',
  'pages.sys3.hw.category.CONNECTOR': 'Connector',
  'pages.sys3.hw.category.PCB': 'PCB',
  'pages.sys3.hw.category.OTHER': 'Other',
  'pages.sys3.hw.qualification.AEC_Q100': 'AEC-Q100 (ICs)',
  'pages.sys3.hw.qualification.AEC_Q101': 'AEC-Q101 (discretes)',
  'pages.sys3.hw.qualification.AEC_Q200': 'AEC-Q200 (passives)',
  'pages.sys3.hw.qualification.NONE': 'Not qualified',
  'pages.sys3.hw.qualification.TBD': 'TBD',
  'pages.sys3.hw.status.CANDIDATE': 'Candidate',
  'pages.sys3.hw.status.SELECTED': 'Selected',
  'pages.sys3.hw.status.OBSOLETE': 'Obsolete',
  'pages.sys3.hw.status.REJECTED': 'Rejected',
  'pages.sys3.hw.rail.KL30': 'KL30 permanent',
  'pages.sys3.hw.rail.KL15': 'KL15 ignition',
  'pages.sys3.hw.rail.KL31': 'KL31 ground',
  'pages.sys3.hw.rail.VBAT': 'VBAT',
  'pages.sys3.hw.rail.5V': '5V',
  'pages.sys3.hw.rail.3V3': '3V3',
  'pages.sys3.hw.rail.1V8': '1V8',
  'pages.sys3.hw.rail.VREF': 'VREF',
  'pages.sys3.hw.rail.OTHER': 'Other',
  'pages.sys3.hw.emcType.SHIELD': 'Shielding',
  'pages.sys3.hw.emcType.FILTER': 'Filtering',
  'pages.sys3.hw.emcType.TVS': 'TVS diode',
  'pages.sys3.hw.emcType.FERRITE': 'Ferrite bead',
  'pages.sys3.hw.emcType.CAP': 'Capacitor',
  'pages.sys3.hw.emcType.LAYOUT': 'Layout / routing',
  'pages.sys3.hw.emcType.GROUNDING': 'Grounding',
  'pages.sys3.hw.emcType.OTHER': 'Other',
  'pages.sys3.hw.metric.FIT': 'FIT (failure rate)',
  'pages.sys3.hw.metric.SPFM': 'SPFM (single-point fault metric)',
  'pages.sys3.hw.metric.LFM': 'LFM (latent fault metric)',
  'pages.sys3.hw.metric.PMHF': 'PMHF (probabilistic metric for random HW failures)',
  'pages.sys3.hw.metric.DIAG_COVERAGE': 'Diagnostic coverage',
  'pages.sys3.hw.verdict.PASS': 'Pass',
  'pages.sys3.hw.verdict.CONDITIONAL': 'Conditional pass',
  'pages.sys3.hw.verdict.FAIL': 'Fail',
  'pages.sys3.hw.verdict.TBD': 'TBD',
  'pages.sys3.hw.pinSource.CONNECTOR': 'Connector pin',
  'pages.sys3.hw.pinSource.CHIP_PIN': 'Chip pin',
  'pages.sys3.hw.pinSource.LOCAL': 'On-board pin',

  // ---- S6: SWE.3 software detailed design (PAM SWE.3-T-0002 + ISO 26262-6 §8) ----
  'pages.sys3.swe3Title': 'Software Detailed Design',
  'pages.sys3.doc.tab.SWE3.STATIC': 'Software Static Design',
  'pages.sys3.doc.tab.SWE3.INTERFACE': 'Component Interface Design',
  'pages.sys3.doc.tab.SWE3.DYNAMIC': 'Software Dynamic Design',
  'pages.sys3.doc.tab.SWE3.UNIT': 'Unit Detailed Design',
  'pages.sys3.doc.tab.SWE3.ALLOCATION': 'Requirement Allocation',
  'pages.sys3.ws.groupUnit': 'Unit detailed design',
  'pages.sys3.ws.kind.CLASS': 'Class diagram',
  'pages.sys3.ws.kind.ACTIVITY': 'Activity diagram',
  'pages.sys3.ws.kind.FLOWCHART': 'Unit flowchart',
  'pages.sys3.table.units': 'Software units',
  'pages.sys3.table.designs': 'Unit design descriptions',
  'pages.sys3.table.classes': 'Classes',
  'pages.sys3.table.componentNotes': 'Component (function) descriptions',
  'pages.sys3.table.unitInterfaces': 'Unit interfaces',
  'pages.sys3.table.dataStructures': 'Data structures',
  'pages.sys3.table.globalVars': 'Global variables',
  'pages.sys3.table.parameters': 'Constants and calibration parameters',
  'pages.sys3.table.externalFunctions': 'External function definitions',
  'pages.sys3.table.unitFunctions': 'Function designs',
  'pages.sys3.table.codeUnits': 'Code unit mapping',
  'pages.sys3.table.activitySteps': 'Activity steps',
  // Empty-table hints
  'pages.sys3.swe3.hintUnits':
    'No software units yet — add name / owning component / type / size; each unit must map to a SWE.2 component',
  'pages.sys3.swe3.hintDesigns':
    'No unit design descriptions yet — add unit / design type / description / error handling',
  'pages.sys3.swe3.hintClasses':
    'No classes yet — add name / kind / base class / members; pure C projects can skip this chapter',
  'pages.sys3.swe3.hintComponentNotes':
    'No component descriptions yet — components come from SWE.2, only goal / inputs / outputs are added here',
  'pages.sys3.swe3.hintUnitInterfaces':
    'No unit interfaces yet — each interface needs data type + valid value range + physical unit (PAM SWE.3.BP1)',
  'pages.sys3.swe3.hintDataStructures':
    'No data structures yet — add name / kind / member composition / size in bytes',
  'pages.sys3.swe3.hintGlobalVars':
    'No global variables yet — every global must state its rationale (ISO 26262-6 Table 6)',
  'pages.sys3.swe3.hintParameters':
    'No parameters yet — constants need a value; calibration parameters need range + scaling + default',
  'pages.sys3.swe3.hintExternalFunctions':
    'No external functions yet — add prototype / source / parameters / return type / call constraints',
  'pages.sys3.swe3.hintUnitFunctions':
    'No function designs yet — each function needs pre/post-conditions, algorithm steps and error handling',
  'pages.sys3.swe3.hintCodeUnits':
    'No code mapping yet — add unit / file / function / lines; these cells are the SWE.4 test objects',
  'pages.sys3.swe3.hintActivitySteps':
    'No activity steps yet — add sequence / action / node type / condition / next step',
  // Column names
  'pages.sys3.swe3.colUnit': 'Software unit',
  'pages.sys3.swe3.colUnitType': 'Unit type',
  'pages.sys3.swe3.colComponent': 'Owning component',
  'pages.sys3.swe3.colLanguage': 'Language',
  'pages.sys3.swe3.colPlannedLoc': 'Planned LOC',
  'pages.sys3.swe3.colComplexity': 'Cyclomatic complexity',
  'pages.sys3.swe3.colDescription': 'Description',
  'pages.sys3.swe3.colAsil': 'ASIL capability',
  'pages.sys3.swe3.colFilePath': 'Implementation file',
  'pages.sys3.swe3.colDesignType': 'Design type',
  'pages.sys3.swe3.colDesignDescription': 'Design description',
  'pages.sys3.swe3.colErrorHandling': 'Error handling',
  'pages.sys3.swe3.colReviewStatus': 'Review status',
  'pages.sys3.swe3.colInterfaceSpec': 'Interfaces and dependencies',
  'pages.sys3.swe3.colResourceConstraint': 'Resource constraints',
  'pages.sys3.swe3.colClassKind': 'Kind',
  'pages.sys3.swe3.colVisibility': 'Visibility',
  'pages.sys3.swe3.colBaseClass': 'Base class',
  'pages.sys3.swe3.colMembers': 'Members',
  'pages.sys3.swe3.colRelation': 'Relation',
  'pages.sys3.swe3.colRelatedClass': 'Related class',
  'pages.sys3.swe3.colMethods': 'Methods',
  'pages.sys3.swe3.colGoal': 'Goal',
  'pages.sys3.swe3.colInputs': 'Inputs',
  'pages.sys3.swe3.colOutputs': 'Outputs',
  'pages.sys3.swe3.colProvider': 'Provider',
  'pages.sys3.swe3.colConsumer': 'Consumer',
  'pages.sys3.swe3.colDataType': 'Data type',
  'pages.sys3.swe3.colValueRange': 'Valid range',
  'pages.sys3.swe3.colMeasureUnit': 'Unit',
  'pages.sys3.swe3.colDefault': 'Default',
  'pages.sys3.swe3.colDirection': 'Direction',
  'pages.sys3.swe3.colStructKind': 'Kind',
  'pages.sys3.swe3.colSizeBytes': 'Bytes',
  'pages.sys3.swe3.colScope': 'Scope',
  'pages.sys3.swe3.colInitialValue': 'Initial value',
  'pages.sys3.swe3.colReason': 'Rationale',
  'pages.sys3.swe3.colWriters': 'Writers',
  'pages.sys3.swe3.colReaders': 'Readers',
  'pages.sys3.swe3.colParamKind': 'Parameter kind',
  'pages.sys3.swe3.colValue': 'Value',
  'pages.sys3.swe3.colScale': 'Scaling',
  'pages.sys3.swe3.colPrototype': 'Prototype',
  'pages.sys3.swe3.colSource': 'Source',
  'pages.sys3.swe3.colLibrary': 'Library',
  'pages.sys3.swe3.colConstraint': 'Call constraints',
  'pages.sys3.swe3.colParams': 'Parameters',
  'pages.sys3.swe3.colReturnType': 'Return type',
  'pages.sys3.swe3.colPurpose': 'Purpose',
  'pages.sys3.swe3.colFunctionName': 'Function',
  'pages.sys3.swe3.colBranches': 'Branches',
  'pages.sys3.swe3.colFunctionKind': 'Function kind',
  'pages.sys3.swe3.colPreCondition': 'Pre-condition',
  'pages.sys3.swe3.colPostCondition': 'Post-condition',
  'pages.sys3.swe3.colAlgorithm': 'Algorithm steps',
  'pages.sys3.swe3.colCodeFile': 'Implementation file',
  'pages.sys3.swe3.colLines': 'Lines of code',
  'pages.sys3.swe3.colGenerated': 'Generated',
  'pages.sys3.swe3.colStaticAnalysis': 'Static analysis',
  'pages.sys3.swe3.colSeq': 'Seq.',
  'pages.sys3.swe3.colAction': 'Action',
  'pages.sys3.swe3.colStepKind': 'Node type',
  'pages.sys3.swe3.colCondition': 'Condition',
  'pages.sys3.swe3.colNextStep': 'Next step',
  // Enumerations (shared across groups: CLASS / OTHER / STRUCT mean the same everywhere)
  'pages.sys3.swe3.enum.FUNCTION': 'Function',
  'pages.sys3.swe3.enum.CLASS': 'Class',
  'pages.sys3.swe3.enum.MODULE': 'Module',
  'pages.sys3.swe3.enum.ISR': 'ISR',
  'pages.sys3.swe3.enum.LIBRARY': 'Library',
  'pages.sys3.swe3.enum.OTHER': 'Other',
  'pages.sys3.swe3.enum.ALGORITHM': 'Algorithm',
  'pages.sys3.swe3.enum.STATE_MACHINE': 'State machine',
  'pages.sys3.swe3.enum.SEQUENCE': 'Sequence',
  'pages.sys3.swe3.enum.DATA_STRUCTURE': 'Data structure',
  'pages.sys3.swe3.enum.DRAFT': 'Draft',
  'pages.sys3.swe3.enum.IN_REVIEW': 'In review',
  'pages.sys3.swe3.enum.REVIEWED': 'Reviewed',
  'pages.sys3.swe3.enum.APPROVED': 'Approved',
  'pages.sys3.swe3.enum.ABSTRACT': 'Abstract class',
  'pages.sys3.swe3.enum.INTERFACE': 'Interface',
  'pages.sys3.swe3.enum.STRUCT': 'Struct',
  'pages.sys3.swe3.enum.ENUM': 'Enum',
  'pages.sys3.swe3.enum.UNION': 'Union',
  'pages.sys3.swe3.enum.TYPEDEF': 'Typedef',
  'pages.sys3.swe3.enum.PUBLIC': 'Public',
  'pages.sys3.swe3.enum.PROTECTED': 'Protected',
  'pages.sys3.swe3.enum.PRIVATE': 'Private',
  'pages.sys3.swe3.enum.PACKAGE': 'Package',
  'pages.sys3.swe3.enum.INHERIT': 'Inheritance',
  'pages.sys3.swe3.enum.REALIZE': 'Realization',
  'pages.sys3.swe3.enum.COMPOSE': 'Composition',
  'pages.sys3.swe3.enum.AGGREGATE': 'Aggregation',
  'pages.sys3.swe3.enum.ASSOCIATE': 'Association',
  'pages.sys3.swe3.enum.DEPEND': 'Dependency',
  'pages.sys3.swe3.enum.NONE': 'None',
  'pages.sys3.swe3.enum.IN': 'In',
  'pages.sys3.swe3.enum.OUT': 'Out',
  'pages.sys3.swe3.enum.INOUT': 'In/out',
  'pages.sys3.swe3.enum.ARRAY': 'Array',
  'pages.sys3.swe3.enum.BITFIELD': 'Bit field',
  'pages.sys3.swe3.enum.GLOBAL': 'Global',
  'pages.sys3.swe3.enum.FILE_STATIC': 'File static',
  'pages.sys3.swe3.enum.EXTERN': 'Extern',
  'pages.sys3.swe3.enum.CONST': 'Constant',
  'pages.sys3.swe3.enum.APP': 'Calibration parameter',
  'pages.sys3.swe3.enum.BSW': 'Basic software',
  'pages.sys3.swe3.enum.OS': 'Operating system',
  'pages.sys3.swe3.enum.DRIVER': 'Driver',
  'pages.sys3.swe3.enum.THIRD_PARTY': 'Third party',
  'pages.sys3.swe3.enum.CALLBACK': 'Callback',
  'pages.sys3.swe3.enum.UTILITY': 'Utility',
  'pages.sys3.swe3.enum.YES': 'Yes',
  'pages.sys3.swe3.enum.NO': 'No',
  'pages.sys3.swe3.enum.START': 'Start',
  'pages.sys3.swe3.enum.ACTION': 'Action',
  'pages.sys3.swe3.enum.DECISION': 'Decision',
  'pages.sys3.swe3.enum.MERGE': 'Merge',
  'pages.sys3.swe3.enum.CALL': 'Call',
  'pages.sys3.swe3.enum.WAIT': 'Wait',
  'pages.sys3.swe3.enum.END': 'End',
  // ===== S6-a: SWE.4/5/6 verification =====
  'pages.sys3.verTitle': 'Verification Documents',
  'pages.sys3.doc.tab.VER.PLAN': 'Verification Plan',
  'pages.sys3.doc.tab.VER.INTEGRATION': 'Software Integration',
  'pages.sys3.doc.tab.VER.INTEGRATION_SYS': 'System Integration',
  'pages.sys3.doc.tab.VER.INTEGRATION_HW': 'Hardware Integration',
  'pages.sys3.doc.tab.VER.SPECS': 'Verification Specification',
  'pages.sys3.doc.tab.VER.RESULTS': 'Verification Results',
  'pages.sys3.doc.tab.VER.COVERAGE': 'Coverage',
  'pages.sys3.table.strategies': 'Verification strategies',
  'pages.sys3.table.assumptions': 'Assumptions & constraints',
  'pages.sys3.table.testCases': 'Test cases',
  'pages.sys3.table.codeReviews': 'Code reviews',
  'pages.sys3.table.integrationItems': 'Integration items',
  'pages.sys3.table.coverage': 'Coverage',
  'pages.sys3.ver.colName': 'Name',
  'pages.sys3.ver.colMethod': 'Method',
  'pages.sys3.ver.colTool': 'Tool',
  'pages.sys3.ver.colEnvironment': 'Environment',
  'pages.sys3.ver.colEntryCriteria': 'Entry criteria',
  'pages.sys3.ver.colNote': 'Note',
  'pages.sys3.ver.colCategory': 'Category',
  'pages.sys3.ver.colStatus': 'Status',
  'pages.sys3.ver.colContent': 'Content',
  'pages.sys3.ver.colImpact': 'Impact & mitigation',
  'pages.sys3.ver.colTitle': 'Title',
  'pages.sys3.ver.colLevel': 'Test level',
  'pages.sys3.ver.colRequirement': 'Related requirement',
  'pages.sys3.ver.colCaseStatus': 'Execution status',
  'pages.sys3.ver.colTestDate': 'Test date',
  'pages.sys3.ver.colEnv': 'Environment',
  'pages.sys3.ver.colPath': 'Code path',
  'pages.sys3.ver.colStubs': 'Stubs',
  'pages.sys3.ver.colInputs': 'Inputs',
  'pages.sys3.ver.colPrecondition': 'Preconditions',
  'pages.sys3.ver.colSteps': 'Test steps',
  'pages.sys3.ver.colExpected': 'Expected result',
  'pages.sys3.ver.colActual': 'Actual result',
  'pages.sys3.ver.colProblem': 'Problem description',
  'pages.sys3.ver.colRefs': 'References',
  'pages.sys3.ver.colExecutor': 'Tester',
  'pages.sys3.ver.colModule': 'Module',
  'pages.sys3.ver.colSubModule': 'Sub-module',
  'pages.sys3.ver.colUnit': 'Unit under test',
  'pages.sys3.ver.colComponent': 'Component under test',
  'pages.sys3.ver.colElement': 'Element under test',
  'pages.sys3.ver.colVerdict': 'Verdict',
  'pages.sys3.ver.colReviewer': 'Reviewer',
  'pages.sys3.ver.colReviewDate': 'Review date',
  'pages.sys3.ver.colChecklistItem': 'Checklist item',
  'pages.sys3.ver.colRule': 'Rule',
  'pages.sys3.ver.colFinding': 'Finding',
  'pages.sys3.ver.colSeq': 'Order',
  'pages.sys3.ver.colComposition': 'Composition',
  'pages.sys3.ver.colCriteria': 'Integration criteria',
  'pages.sys3.ver.colKind': 'Coverage kind',
  'pages.sys3.ver.colTarget': 'Target',
  'pages.sys3.ver.hintStrategies':
    'No verification strategies yet — add unit test / static check / review entries',
  'pages.sys3.ver.hintAssumptions':
    'No assumptions & constraints yet — record what happens if a premise fails',
  'pages.sys3.ver.hintTestCases':
    'No test cases yet — follow the specification template columns (method / steps / expected)',
  'pages.sys3.ver.hintCodeReviews':
    'No code review records yet — follow the code review checklist (C-0004)',
  'pages.sys3.ver.hintIntegrationItems':
    'No integration items yet — layer by layer with composition and criteria',
  'pages.sys3.ver.hintCoverage':
    'No coverage data yet — record requirement / statement / branch / MC-DC target vs actual',
  'pages.sys3.ver.enum.UNIT_TEST': 'Unit test',
  'pages.sys3.ver.enum.STATIC_CHECK': 'Static check',
  'pages.sys3.ver.enum.REVIEW': 'Review',
  'pages.sys3.ver.enum.INTEGRATION': 'Integration',
  'pages.sys3.ver.enum.INTERFACE_TEST': 'Interface test',
  'pages.sys3.ver.enum.PERFORMANCE_TEST': 'Performance test',
  'pages.sys3.ver.enum.QUALIFICATION_TEST': 'Qualification test',
  'pages.sys3.ver.enum.TEST': 'Test',
  'pages.sys3.ver.enum.ANALYSIS': 'Analysis',
  'pages.sys3.ver.enum.SIMULATION': 'Simulation',
  'pages.sys3.ver.enum.INSPECTION': 'Inspection',
  'pages.sys3.ver.enum.OTHER': 'Other',
  'pages.sys3.ver.enum.UNIT': 'Unit level',
  'pages.sys3.ver.enum.COMPONENT': 'Component level',
  'pages.sys3.ver.enum.QUALIFICATION': 'Qualification level',
  'pages.sys3.ver.enum.NOT_RUN': 'Not run',
  'pages.sys3.ver.enum.PASS': 'Pass',
  'pages.sys3.ver.enum.FAIL': 'Fail',
  'pages.sys3.ver.enum.BLOCKED': 'Blocked',
  'pages.sys3.ver.enum.NA': 'N/A',
  'pages.sys3.ver.enum.CONDITIONAL': 'Conditional',
  'pages.sys3.ver.enum.TBD': 'TBD',
  'pages.sys3.ver.enum.PLANNED': 'Planned',
  'pages.sys3.ver.enum.INTEGRATED': 'Integrated',
  'pages.sys3.ver.enum.VERIFIED': 'Verified',
  'pages.sys3.ver.enum.FAILED': 'Failed',
  'pages.sys3.ver.enum.REQUIREMENT': 'Requirement coverage',
  'pages.sys3.ver.enum.STATEMENT': 'Statement coverage',
  'pages.sys3.ver.enum.BRANCH': 'Branch coverage',
  'pages.sys3.ver.enum.MCDC': 'MC/DC coverage',
  'pages.sys3.ver.enum.CALL': 'Call coverage',
  'pages.sys3.ver.enum.FUNCTION': 'Function coverage',
  'pages.sys3.ver.enum.ASSUMPTION': 'Assumption',
  'pages.sys3.ver.enum.CONSTRAINT': 'Constraint',
  'pages.sys3.ver.enum.OPEN': 'Open',
  'pages.sys3.ver.enum.CLOSED': 'Closed',
  'pages.safety.title': 'Safety Analysis Workbench',
  'pages.safety.loadFailed': 'Failed to load safety analysis data',
  'pages.safety.saveFailed': 'Save failed',
  'pages.safety.saved': 'Saved',
  'pages.safety.save': 'Save',
  'pages.safety.reload': 'Refresh',
  'pages.safety.edit': 'Edit',
  'pages.safety.delete': 'Delete',
  'pages.safety.unsaved': 'Unsaved changes',
  'pages.safety.summary': 'Analyses {{a}} · Items {{i}} · N/A {{n}}',
  'pages.safety.consistency.title': 'Consistency check: {{e}} errors · {{w}} warnings',
  'pages.safety.tab.analyses': 'Analyses',
  'pages.safety.tab.items': 'Analysis Items',
  'pages.safety.tab.metrics': 'Architecture Metrics',
  'pages.safety.tab.na': 'N/A Justification',
  'pages.safety.analysis.id': 'ID',
  'pages.safety.analysis.type': 'Method',
  'pages.safety.analysis.title': 'Analysis object',
  'pages.safety.analysis.titleHint':
    'e.g. Domain controller system FMEA / brake torque safety goal fault tree',
  'pages.safety.analysis.objective': 'Objective and scope',
  'pages.safety.analysis.refs': 'Linked safety goals / requirements / elements (comma separated)',
  'pages.safety.analysis.applicable': 'Applicability',
  'pages.safety.analysis.applicableYes': 'Applicable',
  'pages.safety.analysis.na': 'N/A',
  'pages.safety.analysis.naMissing': 'Reason missing',
  'pages.safety.analysis.status': 'Status',
  'pages.safety.analysis.add': 'Add analysis',
  'pages.safety.analysis.empty':
    'No analysis yet: start an FTA from a safety goal, or create an FMEA',
  'pages.safety.analysis.modalTitle': 'Analysis',
  'pages.safety.analysis.note': 'Note',
  'pages.safety.analysis.confirmDelete': 'Delete this analysis and its items?',
  'pages.safety.item.id': 'ID',
  'pages.safety.item.name': 'Name / object',
  'pages.safety.item.parent': 'Parent',
  'pages.safety.item.gate': 'Gate',
  'pages.safety.item.seq': 'Seq',
  'pages.safety.item.voteK': 'Voting k',
  'pages.safety.item.voteKHint':
    'VOTE gates only: the top event occurs when any k of n inputs fail (2-of-3 → 2). Empty means all inputs must fail.',
  'pages.safety.item.event': 'Basic event / failure description',
  'pages.safety.item.failureMode': 'Failure mode',
  'pages.safety.item.effect': 'Effect',
  'pages.safety.item.faultClass': 'Fault class',
  'pages.safety.item.dc': 'DC (0–1)',
  'pages.safety.item.fit': 'Failure rate (FIT)',
  'pages.safety.item.coupling': 'Coupling factor',
  'pages.safety.item.couplingHint': 'Shared supply / clock / silicon / PCB / compiler / team…',
  'pages.safety.item.measure': 'Measure',
  'pages.safety.item.refs': 'Linked requirement / element IDs (comma separated)',
  'pages.safety.item.status': 'Status',
  'pages.safety.item.note': 'Note',
  'pages.safety.item.actions': 'Actions',
  'pages.safety.item.add': 'Add item',
  'pages.safety.item.empty': 'No items in this analysis yet',
  'pages.safety.item.modalTitle': 'Analysis item',
  'pages.safety.item.pickAnalysis': 'Analysis',
  'pages.safety.item.ftaReadonly': 'The FTA tree is owned by SYS.3; read-only here',
  'pages.safety.item.noAnalysis': 'Create an analysis first',
  'pages.safety.item.confirmDelete': 'Delete this item?',
  // —— S6-c-2 measure disposition ——
  'pages.safety.item.disposition': 'Disposition',
  'pages.safety.item.target': 'Lands on',
  'pages.safety.item.targetMissing': 'No target',
  'pages.safety.item.targetKind': 'Target kind',
  'pages.safety.item.targetId': 'Target ID',
  'pages.safety.item.targetRequired':
    'An adopted measure must name its target (element / requirement / verification ID)',
  'pages.safety.item.rejectReason': 'Rejection reason',
  'pages.safety.item.rejectReasonRequired':
    'A rejected measure needs a reason so reviewers can see why it was not adopted',
  'pages.safety.item.rejectReasonHint':
    'Already covered by an existing constraint / cost unacceptable / deferred to a later phase…',
  'pages.safety.item.owner': 'Owner',
  'pages.safety.item.due': 'Due',
  'pages.safety.item.changeRef': 'Change request / decision ID',
  'pages.safety.disposition.PENDING': 'Pending',
  'pages.safety.disposition.ADOPTED': 'Adopted',
  'pages.safety.disposition.REJECTED': 'Rejected',
  'pages.safety.disposition.DEFERRED': 'Deferred',
  'pages.safety.targetKind.ELEMENT': 'Architecture element',
  'pages.safety.targetKind.REQUIREMENT': 'Requirement',
  'pages.safety.targetKind.VERIFICATION': 'Verification measure',
  'pages.safety.targetKind.NONE': 'No design impact',
  // —— S6-c-3 FMEA five steps / FMEDA template ——
  'pages.safety.item.function': 'Function',
  'pages.safety.item.functionHint':
    'P3 function analysis: what is this element / component supposed to do',
  'pages.safety.item.partRef': 'Part (reference / element)',
  'pages.safety.item.modeDist': 'Mode share',
  'pages.safety.item.relevantFit': 'Relevant FIT (auto)',
  'pages.safety.item.smRef': 'Safety mechanism SM',
  'pages.safety.item.smRefHint': 'Picking an SM brings in its achievable DC',
  'pages.safety.item.ap': 'Action priority AP (auto lookup)',
  'pages.safety.item.apPending': 'AP appears when S/O/D are all set',
  'pages.safety.item.detection': 'Current controls (prevention / detection)',
  'pages.safety.mech.add': 'Add safety mechanism',
  'pages.safety.mech.empty':
    'No safety mechanisms yet — FMEDA rows pick up DC once they reference an SM',
  'pages.safety.mech.id': 'SM ID',
  'pages.safety.mech.description': 'Description',
  'pages.safety.mech.descriptionHint':
    'e.g. Voltage monitor comparator (window ±5%), fails into safe state',
  'pages.safety.mech.dc': 'Achievable DC (0–1)',
  'pages.safety.mech.ref': 'ISO 26262-5 Annex D entry',
  'pages.safety.mech.usedBy': 'Referenced by',
  'pages.safety.mech.confirmDelete':
    'Delete this mechanism? Rows referencing it lose their DC default',
  'pages.safety.mech.modalTitle': 'Safety mechanism',
  'pages.safety.wizard.mechHint':
    'Maintain the SM list first (ID + achievable DC, see ISO 26262-5 Annex D), then reference SMs row by row in the table above.',
  'pages.safety.metrics.empty':
    'No FMEDA items yet — metrics are aggregated from FMEDA rows (failure rate / DC / fault class)',
  'pages.safety.metrics.asil': 'Safety goal ASIL',
  'pages.safety.metrics.scope': '{{n}} items counted · total λ {{fit}} FIT',
  'pages.safety.metrics.spfmHint': 'Lower residual single-point share is better',
  'pages.safety.metrics.lfmHint': 'Diagnostic coverage of latent multi-point faults',
  'pages.safety.metrics.pmhfHint': 'Probability per hour, lower is better',
  'pages.safety.metrics.noteTitle': 'Metric basis',
  'pages.safety.metrics.noteBody':
    'Targets follow ISO 26262-5:2018 Tables 4 / 5 / 6; ASIL A and QM have no quantitative targets.',
  'pages.safety.na.notice':
    'Blank means "not executed" to an assessor; only "N/A + justification" counts as tailored out.',
  'pages.safety.na.noticeBody':
    'A pure-software project marks hardware analyses N/A with a reason (e.g. "no hardware development"); vice versa for hardware-only projects.',
  'pages.safety.na.empty': 'No analyses marked N/A',
  'pages.safety.na.reason': 'N/A justification (required when N/A)',
  'pages.safety.na.placeholder': 'e.g. Pure software product, no hardware development',
  'pages.safety.footnote':
    'Three-level placement: the FTA tree is built once (owned by SYS.3), other levels read a subtree; FMEA / FMEDA / DFA are owned per level. This page complements, not replaces, the existing "Safety analysis" document list.',
  // —— S6-c-2 analysis task list ——
  'pages.safety.task.tab': 'Analysis tasks {{n}}',
  'pages.safety.task.title': 'Task name',
  'pages.safety.task.method': 'Method',
  'pages.safety.task.scope': 'Scope (what)',
  'pages.safety.task.anchor': 'Starting point (where)',
  'pages.safety.task.progress': 'Progress',
  'pages.safety.task.progressText': '{{done}}/{{total}} steps · {{pending}} pending',
  'pages.safety.task.assumed': 'Assumed',
  'pages.safety.task.assumedTip':
    'Locally assumed input: no upstream HARA / FSC to cite, so consistency checks downgrade to info instead of errors',
  'pages.safety.task.readonly': 'Read-only',
  'pages.safety.task.readonlyTip': 'The FTA tree is owned by SYS.3; this process reads a subtree',
  'pages.safety.task.preview': 'Preview',
  'pages.safety.task.edit': 'Edit',
  'pages.safety.task.na': 'N/A',
  'pages.safety.task.allItems': 'All analysis items (read-only, {{n}})',
  'pages.safety.task.empty':
    'No analysis tasks yet — fill a required method from "Should have vs has"',
  // —— S6-c-2 create / edit task ——
  'pages.safety.form.method': 'Analysis method',
  'pages.safety.form.upstream': 'Upstream input',
  'pages.safety.form.upstreamInherited':
    'Cite upstream (HARA safety goal / FSC functional safety requirement)',
  'pages.safety.form.upstreamAssumed': 'Local assumption (start here, upstream not available yet)',
  'pages.safety.form.assumedStart': 'Assumed starting point',
  'pages.safety.form.assumedStartHint':
    'e.g. Assume the vehicle-level safety goal is "avoid unintended braking torque"',
  'pages.safety.form.assumedWarn':
    'Assumption mode: this task cites no real upstream, so consistency issues are warnings only. Switch back to citing once upstream is ready.',
  'pages.safety.form.scope': 'Scope (what)',
  'pages.safety.form.scopeHint':
    'Pick architecture elements; DFA may leave it empty and record a coupling assumption',
  'pages.safety.form.anchor': 'Starting point (where)',
  'pages.safety.form.anchorFTA': 'Top event',
  'pages.safety.form.anchorFMEA': 'Element / function analysed',
  'pages.safety.form.anchorFMEDA': 'Hardware element analysed',
  'pages.safety.form.anchorDFA': 'Coupling assumption',
  'pages.safety.form.anchorSW': 'Software component analysed',
  'pages.safety.form.asil': 'ASIL',
  'pages.safety.form.status': 'Status',
  'pages.safety.form.objective': 'Objective and boundary',
  'pages.safety.form.refs': 'Linked list (comma separated)',
  'pages.safety.form.note': 'Note',
  // —— S6-c-2 should-have vs has matrix ——
  'pages.safety.matrix.title': 'Should have vs has',
  'pages.safety.matrix.subtitle':
    'Derive what this level should analyse from ISO 26262-4 Table 1 / -5 §8 / -9 §7 and compare with tasks actually created',
  'pages.safety.matrix.rowGoal': 'By safety goal',
  'pages.safety.matrix.rowElement': 'By architecture element',
  'pages.safety.matrix.have': 'Has',
  'pages.safety.matrix.missing': 'Gap',
  'pages.safety.matrix.na': 'N/A',
  'pages.safety.matrix.waived': 'Waived',
  'pages.safety.matrix.waive': 'Waive this cell',
  'pages.safety.matrix.waiveReason': 'Why is it not applicable? (reason required)',
  'pages.safety.matrix.restore': 'Restore all derivations',
  'pages.safety.matrix.waivedList': 'Waived derivations ({{n}})',
  'pages.safety.matrix.basis': 'Derivation basis (standard text)',
  'pages.safety.matrix.create': 'Create task',
  'pages.safety.matrix.emptyGoals':
    'No safety goal / requirement available — finish safety goals in FSC first',
  'pages.safety.matrix.emptyElements':
    'No architecture elements — build the element list on the architecture page first',
  'pages.safety.matrix.noAsil': 'ASIL not set — treated as QM, only FMEA is derived as required',
  // —— S6-c-2 measure strip / review ——
  'pages.safety.strip.total': '{{n}} measures',
  'pages.safety.strip.adopted': '{{n}} adopted',
  'pages.safety.strip.pending': '{{n}} pending',
  'pages.safety.strip.rejected': '{{n}} rejected',
  'pages.safety.strip.deferred': '{{n}} deferred',
  'pages.safety.strip.assumed': '{{n}} assumed inputs',
  'pages.safety.strip.gap': '{{n}} without target',
  'pages.safety.review.submit': 'Submit for review',
  'pages.safety.review.title': 'Review pre-check failed',
  'pages.safety.review.pass': 'Review pre-check passed: no hard gaps',
  'pages.safety.review.blockers': '{{n}} items must be resolved first:',
  'pages.safety.review.gapsTitle': 'Adopted but no target ({{n}})',
  'pages.safety.review.hint':
    'The pre-check blocks only three hard gaps: no starting point, rejected without reason, measure left undecided. Other consistency issues are advisory.',
  // —— S6-c-2 wizard ——
  'pages.safety.wizard.back': 'Back to task list',
  'pages.safety.wizard.modeEdit': 'Editing',
  'pages.safety.wizard.modeReadonly': 'Read-only',
  'pages.safety.wizard.step': 'Step {{now}} / {{total}}',
  'pages.safety.wizard.prev': 'Previous',
  'pages.safety.wizard.next': 'Next',
  'pages.safety.wizard.gap': 'Still missing for this step: {{gap}}',
  'pages.safety.wizard.done': 'This step is complete',
  'pages.safety.wizard.tableView': 'Table',
  'pages.safety.wizard.treeView': 'Tree view',
  'pages.safety.wizard.modeTable': 'Table',
  'pages.safety.wizard.modeTree': 'Tree view',
  'pages.safety.wizard.treeTodo':
    'The graphical fault tree arrives in the next version; use the table for now',
  'pages.safety.wizard.needStart': 'Go back to the task list and add a starting point',
  'pages.safety.wizard.measuresPending': '{{n}} measures awaiting disposition',
  'pages.safety.wizard.finishHint':
    'Submitting for review checks hard gaps only; it does not replace the review record.',
  // —— S6-c-3 fault tree (diagram → tables) ——
  'pages.safety.fta.empty':
    'No fault tree nodes yet: create the top event and basic events in the table first',
  'pages.safety.fta.hint':
    'The diagram is read-only: edit structure in the table, inspect the tree and results here',
  'pages.safety.fta.mission': 'Mission time',
  'pages.safety.fta.recalc': 'Recalculate',
  'pages.safety.fta.topProb': 'Top event probability (upper bound)',
  'pages.safety.fta.topProbHint': '(sum of cut set probabilities, conservative)',
  'pages.safety.fta.cutCount': 'Minimal cut sets',
  'pages.safety.fta.minOrder': 'Minimal order',
  'pages.safety.fta.cut': 'Minimal cut set',
  'pages.safety.fta.order': 'Order',
  'pages.safety.fta.prob': 'Cut set probability',
  'pages.safety.fta.missingRate': 'Some basic events have no FIT',
  'pages.safety.fta.spf': 'Single point',
  'pages.safety.fta.importance': 'FV importance (largest contribution to the top event)',
  'pages.safety.fta.event': 'Basic event',
  'pages.safety.fta.share': 'Contribution',
  'pages.safety.fta.needStart':
    'This analysis has no starting point; set the top event in the task list first',
  'pages.safety.fta.calcFailed': 'Cut set calculation failed',
  // —— S6-c-3c FMEDA BOM (two entry points) ——
  'pages.safety.bom.hint':
    'The BOM is the scope of this FMEDA run (the FMEDA rows themselves), not a separate table. Prefer picking architecture elements so the metrics map back to architecture coverage.',
  'pages.safety.bom.fromArch': 'Pick from architecture',
  'pages.safety.bom.import': 'Import BOM (paste / CSV)',
  'pages.safety.bom.partRef': 'Ref des / element',
  'pages.safety.bom.noRef': 'Not set',
  'pages.safety.bom.empty': 'No components yet — pick architecture elements or import a local BOM',
  'pages.safety.bom.unmatched': '{{n}} rows do not match any architecture element: {{list}}',
  'pages.safety.bom.unmatchedHint':
    'Calculation still works, but these rows are not counted by the architecture coverage check. If a row is a component of an element, set its ref des to the element ID.',
  'pages.safety.bom.pickTitle': 'Pick architecture elements (scope of this FMEDA)',
  'pages.safety.bom.pickHint':
    'Select only the elements in scope; ones already in the BOM are greyed out. Each selected element becomes one row with its element ID as ref des.',
  'pages.safety.bom.pickOk': 'Add to BOM ({{n}})',
  'pages.safety.bom.inBom': '(already in BOM)',
  'pages.safety.bom.noArch':
    'This project has no architecture elements yet (create them in the SYS.3 / HWE.2 architecture tab), or use import instead.',
  'pages.safety.bom.importTitle': 'Import BOM',
  'pages.safety.bom.importHint':
    'One component per line, columns: ref des / name / failure rate (FIT) / qty, comma or tab separated. You can paste straight from Excel; a header row is skipped automatically.',
  'pages.safety.bom.chooseFile': 'Choose file',
  'pages.safety.bom.reparse': 'Parse again',
  'pages.safety.bom.importOk': 'Import ({{n}})',
  'pages.safety.bom.importUnmatched':
    '{{n}} rows do not match any element and will be marked "not in architecture"',
  'pages.safety.bom.importUnmatchedHint':
    'You can still import (FMEDA is often finer grained than architecture elements); unmatched rows are not counted by the architecture coverage check.',
  'pages.safety.bom.match': 'Architecture match',
  'pages.safety.bom.matched': 'Linked',
  'pages.safety.bom.notInArch': 'Not in architecture',
  'pages.safety.wizard.bomHint':
    'Once the scope is set, enter failure modes and distribution in the next step; the base FIT rate can also be edited in the table here.',
};
